import {
   Component, OnInit, ViewChild, Input, ElementRef,
   AfterViewInit, Output, EventEmitter,
   ChangeDetectorRef, OnDestroy
} from '@angular/core';
import {Subject} from 'rxjs';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {TranslateService} from '@ngx-translate/core';
import {IdexService} from '../../../idex.service';
import {LeftPanelComponent} from '../left-panel/left-panel.component';
import {ViewDocumentComponent} from '../view-document/view-document.component';
import {Router} from '@angular/router';
import {Toast} from '../../../shared/toast/toast';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ConfirmRemovesignDialogComponent} from '../../confirm-removesign-dialog/confirm-removesign-dialog.component';
import {Mimetype} from '../../../shared/mimetype';
import {PdfRenditionWatcher} from '../../../shared/pdf-rendition-watcher';
import {CommentboxComponent} from '../../comment-pdf/commentbox/commentbox.component';
import {Section} from '../../../e-form/model/eform-type';
import {EformAPI} from '../../../e-form/e-form.api';
import {Observable} from 'rxjs';
import {AnnotationControllerComponent} from '../../../dms/annotation-controller/annotation-controller.component';
import { DocumentData } from '../../../dms/annotation-controller/document-data.type';
import { DynamicFormBuilderComponent } from 'app/e-form/form-generate/dynamic-form-builder/dynamic-form-builder.component';
import { Form, TaskAttribute } from '../../create-task/create-task.type';
import { ToolsComponent } from '../tools/tools.component';

declare let $: any;
declare let SVG: any;
declare let moment: any;
// declare const SVG:any;
let imageHeight;
let changeImage;
let currentImageHeight;
let onDrag;
let isZoom;
declare let EnjoyHint: any;

const widthIconInit = 25;
const heightIconInit = 25;
const widthAttachInit = 64;
const heightAttachInit = 64;
const widthInit = 100;
const widthInitial = 80;
const heightInit = 50;
const heightInitial = 40;
export interface Itemrotate {
   item: Itemrotate2[];
}

export interface Itemrotate2 {
   scale: number;
   posx: number;
   posy: number;
   transformHeight: number;
   width: number;
   height: number;
}

export interface Itemrotate2 {
   item: Itemrotate3[];
}

export interface Itemrotate3 {
   scale: number;
   posx: number;
   posy: number;
   transformHeight: number;
   width: number;
   height: number;
}

@Component({
   selector: 'app-create-task-sign-off',
   templateUrl: './create-task-sign-off.component.html',
   styleUrls: ['./create-task-sign-off.component.css', '../../../../assets/font_stylesheet.css']
})
export class CreateTaskSignOffComponent implements OnInit, AfterViewInit, OnDestroy {
   @Input() typeName: string;
   @Input() taskAttribute: TaskAttribute;
   @Input() isToggleRightOpened;
   @Input() isToggleLeftOpened;
   @Input() disableButtonSign;
   @Input() isCompleteTask;
   @Input() isShowAttachFile: boolean;
   @Input() show = true;
   @Input() viewMode = true;
   /**
    * `True` สามารถ Annotate ใน step 3 ได้ (มีปุ่ม Annotate)
    * `False` ไม่สามารถ Annotate ใน step 3 ได้ (ไม่มีปุ่ม Annotate)
    */
   @Input() allowAnnotate = true;
   @Input() firstSignField: any;
   @Input() setSelectedList: any;
   @Input() haveSignField: boolean;
   @Output() ongetThumbnail = new EventEmitter<any>();
   @Output() onlistClickEvent = new EventEmitter<any>();
   @Output() onscrollTum = new EventEmitter<any>();
   @Output() flagRotateByPage = new EventEmitter<any>();
   @Output() onloadPageEnd = new EventEmitter<any>();
   @Output() ondownloadAll = new EventEmitter<any>();
   @Output() sendWidthHeight = new EventEmitter<any>();
   @Output() flagloadrotate = new EventEmitter<any>();
   @Output() toggleRight = new EventEmitter<any>();
   @Output() toggleLeft = new EventEmitter<any>();
   @Output() onloadedPage = new EventEmitter<any>();
   @Output() onloadedByPage = new EventEmitter<any>();
   @Output() onselectFormSigner = new EventEmitter<any>();
   @Output() onshowDownloadAll = new EventEmitter<any>();
   @Output() updateSignValid = new EventEmitter<any>();
   @Input() sections: Section[];
   @Input() taskStatus: string;
   @ViewChild('print') print: ElementRef;
   @ViewChild('drawer') drawer;
   @ViewChild('mainDrawer') mainDrawer;
   @ViewChild('btnAction') btnAction;
   @ViewChild('btnToggleNav') btnToggleNav;
   @ViewChild('groupPageTrans') groupPageTrans: ElementRef;
   @ViewChild('groupAction') groupAction: ElementRef;
   @ViewChild('allImages') allImages: ElementRef;
   @ViewChild('sideNavContent') sideNavContent: ElementRef;
   @ViewChild(LeftPanelComponent) leftPanelComp: LeftPanelComponent;
   @ViewChild(ViewDocumentComponent) viewDocumentComp: ViewDocumentComponent;
   @ViewChild(CommentboxComponent) commentboxComp: CommentboxComponent ;
   @ViewChild(AnnotationControllerComponent) annoComp: AnnotationControllerComponent;
   @ViewChild(DynamicFormBuilderComponent) dynamicFormComp: DynamicFormBuilderComponent;
   @ViewChild(ToolsComponent) toolsComp: ToolsComponent;
   siteId: any;
   item: any;
   docidlist: any;
   canNotPreview: boolean;
   private _isFormName: boolean;
   get isFormName(): boolean {
      return this._isFormName;
   }
   set isFormName(value: boolean) {
      this._isFormName = value;
   }
   renditionWatcher = new PdfRenditionWatcher();
   /** นับการเรียก changeDrawPage (ใช้ใน onListClick เพื่อรู้ว่ามีการโหลดเอกสารจาก server ที่จะปิด loading เอง) */
   private drawPageSeq = 0;

   /** เอกสารที่กำลังแสดงยังแปลงเป็น PDF ไม่เสร็จ */
   get isConverting(): boolean {
      return PdfRenditionWatcher.isConverting(this.dataPages?.[this.currentIndex]);
   }
   fieldName: any;
   numprint: any;
   type: any;
   namelist: any;
   doc: any;
   doc2: any = {};
   canNotFound = false;
   swap: number;
   itemrotatenum2: any = [];
   countpageprint = 0;
   countpage = 0;
   position: any = 0;
   comment: any;
   heightMax: any = 0;
   widthMax: any = 0;
   pdfUrl: SafeResourceUrl;
   listPageNo: any = 1;
   checkAmount = false;
   pageNo1 = 1;
   multiRotate = 0;
   checkclicklist = true;
   checkheightpage: any = 0;
   page = 1;
   mimType: any;
   setscaleThumbnail: any = [];
   checkPositionPage = true;
   errorMessage: string;
   itemRotates: any = [];
   checkImgLoaded: any = [];
   selectedItems: any;
   amount: any;
   checkLasyload: any = [];
   itemRotate: Itemrotate = {} as any;
   isClickPage = false;
   isLoopPage = false;
   mytime: any;
   numLoadpage: number;
   checkscroll: number;
   checkscrollUp: number;
   checkloadrotate = true;
   progress: any;
   numberlooprotate: number;
   timeout = 0;
   watermark: any;
   form: any = [];
   documentData: DocumentData;
   docUrl: any;
   myFiles = "My Files";
   isRecalText = true;
   public indexPage = 0;
   public _docId;
   public _totalPages;
   public signMenuClick;
   public signMenuDrag;
   public signActionClick;
   public saveActionClick;
   public sendActionClick;
   public isHideArrowLeft = false;
   public isHideAction = false;
   public isHideArrowRight = true;
   public isInitail = false;
   public isDrawing = false;
   public startDrawing = false;
   public images;
   public picComment;
   public picAttachImg;
   public picCheckBox;
   public picSignature;
   public picInitSignature;
   public imgUrl: any;
   public maxWidth = 0;
   public maxHeight = 0;
   public width = 384;
   public height = 594;
   private _currentIndex = 0;
   get currentIndex() {
      return this._currentIndex;
   }
   set currentIndex(value) {
      this._currentIndex = value;
      if (
         this.taskAttribute.docList[value].isForm ||
         this.taskAttribute.docList[value].docName.endsWith('.zdox')
      ) {
         this.isFormName = true;
         this.flagDownload = false;
      } else {
         this.isFormName = false;
         this.flagDownload = true;
      }
   }
   public selectedTab = 1;
   public signerSelected;
   public pageType = 'CP';
   public _docName;
   public positionType = 'CT';
   public fieldType;
   public chkName = false;
   public chkDate = false;
   public chkApplyAll = false;
   public includeName: any;
   public includeDate: any;
   public certId;
   public stepOrder;
   public taskContactId;
   public fontDetail = {
      'fontStyle': 'THSarabunNew',
      'fontSize': 9,
      'fontColor': '#000000',
      'fontBold': false,
      'fontItalic': false,
      'fontUnderline': false,
      'textRequired' : false,
   }
   public isHidepageType = false
   public isHideDeleteBtn = false;
   public isHideRequire = false;
   public isHideProperties = false;
   public isHideCommentPdf = false;
   public isToggle = true;
   public currentPageNo; // TODO : change when docList Click
   public widthSignItem;
   public heightSignItem;
   public transformHeight;
   public zoomRatio = 1.0;
   public _statusInitial = [];
   public isHideViewDocument = true;
   public isPageLoadFinish = false;
   public isZoom = false;
   public isFitPage = false;
   public dataPages;
   public colors = [
      '#8b0000',
      '#daa520',
      '#778899',
      '#800080',
      '#ff00ff',
      '#008080',
      '#556b2f',
      '#32cd32',
      '#3EA99F',
      '#0000cd',
      '#ff69b4',
      '#ff0000',
      '#bdb76b',
      '#FFD700',
      '#7FFFD4',
      '#FF4500',
      '#32CD32',
      '#FF8B8B',
      '#9932CC',
      '#A0522D',
      '#00CED1',
      '#2F4F4F',
      '#98AFC7',
      '#566D7E',
      '#FBE7A1',
      '#728FCE',
      '#4863A0',
      '#2B547E',
      '#81D8D0',
      '#2554C7',
      '#1589FF',
      '#00BFFF',
      '#87CEEB',
      '#C6DEFF',
      '#B0E0E6',
      '#16E2F5',
      '#045F5F',
      '#31906E',
      '#50C878',
      '#006400',
      '#32CD32',
      '#DAEE01',
      '#FFFACD',
      '#57FEFF',
      '#FED8B1',
      '#FFFF00',
      '#D9F1F1',
      '#B6E3E9',
      '#D1EAF5',
      '#C3DDE0',
      '#A5CEDB',
      '#95C8D7',
      '#AACCE2',
      '#789CCE',
      '#FBD4AD',
      '#F8D7C1',
      '#EDAB94',
      '#FFAE92',
      '#DADDC5',
      '#A5B89C',
      '#C1D7D0',
      '#CAE3CC',
      '#E0F8E8',
      '#D9EDE7',
      '#BDDED1',
      '#B7B7FF',
      '#E7D2EF',
      '#EFE5EE',
      '#C4B3C3',
      '#C6A5C7',
      '#E2D0DC',
      '#D9B0CD',
      '#DFA5D6',
      '#E5A9DE',
      '#FEF4F3',
      '#FCDEE2',
      '#FFD6DA',
      '#FFC6CF',
      '#FFE4E3',
      '#FFD3D3',
      '#FFCDCD',
      '#FFB7B7',
      '#FBF1D5',
      '#FFE2AE',
      '#F4CC84',
      '#F7D07A'
   ];
   public _isVisible;
   public _isComment;
   private _marginn = 30;
   private _isHideProp = false;
   private _pageCount = 1;
   private _isDeselect = true;
   private _giveNullElement;
   private _objectSVG = [];
   private _docIds = [];
   private _signItem;
   private _user = this.service.user;
   private _margin = 30;
   private _draw;
   private _objDraw;
   private _addAllSignature = [];
   private _imgFocus: any;
   private _widthInit = 100;
   private _widthInitialSign = 80;
   private _widthInitName = 49;
   private _widthInitDate = 54;
   private _widthInitTextarea = 100;
   private _widthInitIcon = 25;
   private _widthInitAttach = 64;
   private _widthInitCheckBox = 22.5;
   private _widthInitBox = 13.5;
   private _widthInitCheck = 10;
   private _heightInit = 50;
   private _heightInitialSign = 40;
   private _heightInitNameDate = 9;
   private _heightInitTextarea = 25;
   private _widthSignature = 30;
   private _widthInitSignature = 18;
   private _heightSignature = 13;
   private _heightInitIcon = 25;
   private _heightInitAttach = 64;
   private _heightInitCheckBox = 22.5;
   private _heightInitBox = 12;
   private _heightInitCheck = 10;
   private _y = -4;
   private _fontSize = 9;
   private _isHaveThai = false;
   private _eventMouseOver;
   private _objectDrag: any;
   private _onDrag;
   private _onClickDelete;
   private _onDeleteComment;
   private _signature = 'Signature';
   private _initSignature = 'Initial Sign';
   private _fullName = 'Song Manse';
   private _date = 'DATE';
   private _text = 'TEXT';
   private _image = 'IMAGE';
   private _idSignitems;
   private _heightDialogShowPage = 500;
   private _signer;
   private _fieldType = 'signature';
   private _pageNum = '1';
   private _moveOnPage = false;
   private _dragIcon;
   private _isDrag = false;
   private _imgFocusCal;
   private giveScroll = 0;
   private _keyFieldType = {
      signature: 'signature',
      initSignature: 'initSignature',
      name: 'name',
      date: 'date',
      text: 'text',
      comment: 'comment',
      image: 'image',
      checkbox: 'checkbox'
   };
   private _flagMouseOver;
   public countZoom = 0;
   public isShowTextarea = false;
   isAttFile: any;
   private textPageOf;
   private chunkSize = 500000;
   private itemImageId;
   ext: any;
   private IdAttachItem: any;
   checkMimeType: string = '';
   fullName: string = '';
   objTempId = {};
   signatureDefaultValue = [];
   flagTempleteSignatureDefault = true;
   signatureDefaultLength = 0;
   flagSwitchView = false;
   imgDeleted: string[] = [];
   idImgDefaultValue = [];
   flagImg = true;
   idImgUpdateValue = [];
   isShowSignTool = false;
   flagDownload = true;
   isFormatError = false;

   constructor(public service: IdexService,
               private dialog: MatDialog,
               private toast: Toast,
               private sanitizer: DomSanitizer,
               private translate: TranslateService,
               private router: Router,
               private changeDetector: ChangeDetectorRef) { // TODO : comment for test
      this.signMenuClick = new Subject();
      this.signMenuDrag = new Subject();
      this.signActionClick = new Subject();
      this.saveActionClick = new Subject();
      this.sendActionClick = new Subject();
      this._signer = this._user.email;
      this._isHaveThai = this.checkThaiLanguage(this._user.name);
      this._signItem = {
         'signer': this._signer
         , 'fieldType': this._fieldType
         , 'pageType': this.pageType
         , 'pageNum': this._pageNum
         , 'positionType': this.positionType
         , 'chkName': this.chkName
         , 'chkDate': this.chkDate
         , 'certId': this.certId
         , 'coordinateX': '150'
         , 'coordinateY': '470'
         , 'fieldWidth': this._widthInit
         , 'fieldHeight': this._heightInit
         , 'idSignItem': ''
         , 'flagSign': false
         , 'content': ''
         , 'order': 0
         , 'comment': null
         , 'idImageItem': null
         , 'fontStyle': 'THSarabunNew'
         , 'fontSize': 9
         , 'fontColor': '#000000'
         , 'fontBold': false
         , 'fontItalic': false
         , 'fontUnderline': false
         , 'textRequired': false
         , 'flagCheckbox': false
         , 'stepOrder': 0
         , 'taskContactId': 0
      };
      this._dragIcon = document.createElement('img');
      this._flagMouseOver = false;
      this.picComment = 'assets/icons/comment.png';
      this.picAttachImg = 'assets/icons/attachImg.png';
      this.picCheckBox = 'assets/icons/tick.png';
      this.picSignature = 'assets/images/signature.png';
      this.picInitSignature = 'assets/images/initials.png';
      this.translate.get('flow.of').subscribe(s => {
         this.textPageOf =  s.toString();
      });
   }

   ngOnInit() {
      this.handleMenuClick();
      this.handleMenuDrag();
      this.handleGetTranslateSignItem();
      this.handleCheckLanguage();
      this.handleToggleClosed();
      this.getWatermark();
      this.getProfile();
      if (this.type === 'startFlow') { // initial File
         this.typeName = 'startFlow';
         this.service.getDocumentAdmin(this.item.id, 0, 'task')
            .subscribe((data) => {
                  this.fullName = data.creator.name;
                  this.doc = data;
                  this.comment = data.comments;
                  if (this.item?.isForm && this.item.isForm) {
                     this.taskAttribute.formName = data.name;
                     this.taskAttribute.isFormStartFlow = true;
                     this.taskAttribute.docList.push({docName: data.name, docId: data.id, isForm: true, isFromStartFlow: true});
                  } else {
                     this.taskAttribute.docList.push({docName: data.name, docId: data.id, isFromStartFlow: true});
                  }

               },
               err => {
                  this.handleWaitAction(false);
                  console.error(err);
               });
      }
   }

   handleWaitActionPrint(isShow) {
      if (isShow) {
         $('#pano-sign-task').show();
         $('#main-page').addClass('blur');
      } else {
         $('#pano-sign-task').hide();
         $('#main-page').removeClass('blur');
      }
   }
   getIcon(item: any): string {
      return Mimetype.getIcon(item);
   }
   ngAfterViewInit() {
      this._giveNullElement = this.allImages.nativeElement;
      this.handleToggleClosed();
   }

   getWatermark() {
      this.service.getWatermark('Web',this.taskAttribute.siteId).subscribe((data) => {
         this.watermark = data;
      });
   }

   getProfile() {
      if(this.signerSelected && this.signerSelected.signer) {
         this.service.getProfileByUserName(this.signerSelected.signer.signerEmail).subscribe(data => {
            if (data) {
               this.includeName = data.includeName;
               this.includeDate = data.includeDate;
               this.chkName = data.includeName;
               this.chkDate = data.includeDate;
            }
            let ratioZoom = this.getCountZoom();
            let width = 0;
            if (this.chkName || this.chkDate) {
               width = 50;
            }
            if (this._objDraw) {
               if (this._objDraw.attr('fieldType') === 'signature') {
                  $($(this._objDraw.node).children()[0]).attr('width',(this._widthInit + width) * ratioZoom,this._heightInit * ratioZoom);
                  $($(this._objDraw.node).children()[1]).attr('width',(this._widthInit + width) * ratioZoom,this._heightInit * ratioZoom);
                  this._objDraw.attr({width: (100 + width) * ratioZoom, height: 50 * ratioZoom});
               }
            } else if (this._objectDrag) {
               const $objectDrag = $(this._objectDrag);
               if ($objectDrag.attr('fieldType') === 'signature') {
                  $($($objectDrag).children()[0]).attr('width',(this._widthInit + width) * ratioZoom,this._heightInit * ratioZoom);
                  $($($objectDrag).children()[1]).attr('width',(this._widthInit + width) * ratioZoom,this._heightInit * ratioZoom);
                  $objectDrag.attr({width: (100 + width) * ratioZoom, height: 50 * ratioZoom});
               }
            }
         });
      }
   }

   /** เมื่อเปิดเข้ามาในหน้า เซ็นอกสารทำการเรียก service transform เพื่อดึงข้อมูลรูปภาพมาวางไว้ตั้งต้นก่อน */
   changeDrawPage(index) {
      this.drawPageSeq++;
      this.signatureDefaultValue = [];
      this.flagSwitchView = false;
      this.getWatermark();
      this.commentboxComp.clearCommentComponent();
      this.viewDocumentComp.isCompleteTask = this.isCompleteTask;
      this.viewDocumentComp.taskId = this.taskAttribute.taskId;
      this.clearAllPage();
      const token = this.service.user.token;
      this._docIds = [];
      let isShowDownloadAll = false;
      if (this.taskAttribute.docList[index].isForm
         || this.taskAttribute.docList[index].docName.endsWith('.zdox')) {
         this.isFormName = true;
         this.flagDownload = false;
      } else {
         this.isFormName = false;
         this.flagDownload = true;
      }
      if (this.taskAttribute.docList.length > 0) {
         this.setDocName(this.taskAttribute.docList[index].docName);
         this.setDocId(this.taskAttribute.docList[index].docId);
         this.onlistClickEvent.emit(this.getDocId());
         for (const document of this.taskAttribute.docList) {
            this._docIds.push(document.docId);
            if (!document.isForm && !document.docName.endsWith('.zdox')){
               isShowDownloadAll = true;
            }
         }
         this.onshowDownloadAll.emit(isShowDownloadAll);

         this.handleWaitAction(true);
         const taskId = this.viewDocumentComp.taskId;
         this.service.transformPdf(this._docIds, taskId, true)
            .subscribe((data) => {
                  this.watchRendition(data, taskId);
                  this.listPageNo = 1;
                  this.countpage = 0;
                  this._pageCount = 1;
                  this.zoomRatio = 1.0;
                  this.countZoom = 0;
                  this.isClickPage = true;
                  this.isLoopPage = false;

                  this._statusInitial = [];
                  // บรรทัดนี้อาจดูซ้ำซากกับ clearAllPage() ข้างบนก่อนเรียก service.transformPdf() แต่เป็นการป้องกันกล่องลายเซ็นซ้อนกัน (ZE-4929)
                  // ในกรณีที่ changeDrawPage ถูกเรียกติดๆกันหลายครั้งแล้ว service.transformPdf() จาก changeDrawPage ครั้งแรกส่งค่ากลับมาช้ากว่า clearAllPage() ที่ถูกเรียกจาก changeDrawPage ครั้งที่สอง
                  // ทำให้ clearAllPage() ที่ถูกเรียกจากครั้งที่สองทำงานก่อนที่กล่องลายเซ็นของครั้งแรกถูกวาด แล้วก็วาดกล่องลายเซ็นของครั้งที่สองทับทับกล่องลายเซ็นของครั้งแรก
                  // การใส่ clearAllPage() ตรงนี้ทันทีหลังจากรีเซ็ต _statusInitial จึงทำให้กล่องลายเซ็นเก่าถูกลบก่อนที่จะวาดกล่องลายเซ็นใหม่แน่นอน
                  this.clearAllPage();

                  this.transformHeight = 0;
                  this.dataPages = data;
                  this.isAttFile = this.taskAttribute.docList[index].isAttachFile;
                  this.mimType = this.dataPages[index]?.mimType;
                  if (!this.mimType || Mimetype.checkMimeType(this.mimType) === '') {
                     this.allowAnnotate = false;
                  } else {
                     this.allowAnnotate = true;
                  }
                  this.namelist = this.dataPages[index].name;
                  this.docidlist = this.dataPages[index].docId;
                  if ((this.mimType === 'application/msword' || this.mimType === 'application/pdf' || this.mimType === 'application/vnd.ms-excel' || this.mimType === 'application/vnd.ms-powerpoint'
                     || this.mimType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                     || this.mimType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                     || this.mimType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || this.mimType === 'image/tiff'
                     || this.mimType === 'image/jpeg' || this.mimType === 'image/png' || this.mimType === 'image/bmp' || this.mimType.indexOf('text/') === 0)
                     && this.dataPages[index].totalPages > 0) {
                     if (this.dataPages[index].canTransform) {
                        this.isHideCommentPdf = false;
                        this.canNotPreview = false;
                     } else {
                        this.canNotPreview = true;
                        this.isHideCommentPdf = true;
                     }
                  } else {
                     this.canNotPreview = true;
                     this.isHideCommentPdf = true;
                  }
                  if (this.maxWidth < this.dataPages[index].maxWidth) {
                     this.maxWidth = this.dataPages[index].maxWidth;
                  }
                  this.setLeftComment();
                  this.maxHeight += this.dataPages[index].maxHeight;
                  this._totalPages = this.dataPages[index].totalPages;
                  for (let i = 0; i < this._totalPages; i++) {
                     this._statusInitial.push({'isInitial': false});
                  }
                  for (let i = 0; i < this.taskAttribute.docList.length && i < this.dataPages.length; i++) {
                     this.taskAttribute.docList[i].totalPages = this.dataPages[i].totalPages;
                     // เอกสารที่ยังแปลงไม่เสร็จ totalPages = 0 ชั่วคราว ห้ามกรองตำแหน่งลายเซ็นทิ้ง
                     if (this.taskAttribute.docList[i].signItems && !PdfRenditionWatcher.isConverting(this.dataPages[i])) {
                        this.taskAttribute.docList[i].signItems = this.taskAttribute.docList[i].signItems
                           .filter(item => Number(item.pageNum) <= this.dataPages[i].totalPages);
                     }
                  }

                  if (this.isZoom || this.isFitPage) { // fix case zoom before rotate
                     this.maxHeight *= this.getCountZoom();
                     this.maxWidth *= this.getCountZoom();
                  }
                  this.setDataRotate(this.dataPages);
                  if (this._totalPages > 0) {
                     this.setMaxHeight(this.dataPages[index]);
                  }
                  this.checkPositionPage = true;
                  for (let i = 0; i < this._totalPages; i++) {
                     if (this.itemRotates[this.currentIndex].itemRotate[i]) {
                        if (this.itemRotates[this.currentIndex].itemRotate[0].item.height
                           > this.itemRotates[this.currentIndex].itemRotate[0].item.width) {
                           if (this.itemRotates[this.currentIndex].itemRotate[i].item.width
                              > this.itemRotates[this.currentIndex].itemRotate[i].item.height) {
                              this.checkPositionPage = false;
                              break;
                           }
                        }
                        if (this.itemRotates[this.currentIndex].itemRotate[0].item.width
                           > this.itemRotates[this.currentIndex].itemRotate[0].item.height) {
                           if (this.itemRotates[this.currentIndex].itemRotate[i].item.height
                              > this.itemRotates[this.currentIndex].itemRotate[i].item.width) {
                              this.checkPositionPage = false;
                              break;
                           }
                        }
                     }
                  }
                  if (this._totalPages > 0) {
                     this.addItemPage(this.dataPages[index], 0, this.itemRotates[this.currentIndex].itemRotate[0].item.transformHeight, this.maxWidth);
                  }

                  this.page = 1;
                  if (localStorage.getItem('first_sign-off_open') !== 'true') {
                     this.onStartTutorial();
                     localStorage.setItem('first_sign-off_open', 'true');
                  }
                  if (!this.isToggleLeftOpened) {
                     this.toggleLeft.emit();
                  }
                  if (this.isToggleRightOpened) {
                     this._isComment = true;
                     this.toggleRight.emit();
                  }
                  this.viewDocumentComp.canZoomOut = false;
                  this.handleWaitAction(false);
               },
               err => {
                  this.handleWaitAction(false);
                  console.error(err);
               });
         this.isInitail = true;
      }
      if (document.getElementById('pdftronView')) {
         document.getElementById('main-page').style.display = 'flex';
         document.getElementById('pdftronView').style.display = 'none';
      }
   }

   /** poll เอกสารที่ยังแปลงไม่เสร็จ แสดงผลทันทีเมื่อเอกสารที่เปิดอยู่แปลงเสร็จ */
   private watchRendition(data: any[], taskId: number) {
      this.renditionWatcher.watch(data, ids => this.service.transformPdf(ids, taskId, true), (doc, i) => {
         if (!this.dataPages) {
            return;
         }
         this.dataPages[i] = doc;
         if (this.taskAttribute.docList[i]) {
            this.taskAttribute.docList[i].totalPages = doc.totalPages;
         }
         if (i === this.currentIndex) {
            this.changeDrawPage(i);
         }
      }, () => this.currentIndex);
   }

   ngOnDestroy() {
      // ออกจากหน้า/cancel: เอาไฟล์ที่ยังรอแปลงออกจากคิวของ backend (ไฟล์ที่กำลังแปลงอยู่จะทำต่อจนเสร็จ)
      this.renditionWatcher.release(ids => this.service.releasePdfTransform(ids));
   }

   /** เมื่อทำการกดที่รายการเอกสารจะทำการ bind data เป็นค่าเริ่มต้นใหม่ */
   refreshPage() {
      this.commentboxComp.clearCommentComponent();
      this.getMaxPageDocuments();
      if (this.indexPage === 0) {
         this.clearAllPage();
      }
      // เอกสารเพิ่งแปลงเสร็จหลังโหลดหน้า (ยังไม่มีข้อมูลหน้า) หรือยังแปลงอยู่: โหลดสถานะใหม่และเริ่ม poll รอบใหม่
      // (กรณี watcher เลิก poll ไปแล้วเพราะเกินเวลาสูงสุด ผู้ใช้กดเปิดเอกสารเองก็จะเช็คต่อ)
      if (this.renditionWatcher.isStale(this.currentIndex) || this.isConverting) {
         this.changeDrawPage(this.currentIndex);
         return;
      }
      const token = this.service.user.token;
      this._docIds = [];
      if (this.taskAttribute.docList.length > 0) {
         this.onlistClickEvent.emit(this.getDocId());
         this.handleWaitAction(true);
         this.listPageNo = 1;
         this.countpage = 0;
         this._pageCount = 1;
         this.zoomRatio = 1.0;
         this.countZoom = 0;
         this.isClickPage = true;
         this.isLoopPage = false;
         this._statusInitial = [];
         this.transformHeight = 0;

         this._totalPages = this.dataPages[this.currentIndex].totalPages;
         if (this._totalPages > 0) {
            if (this.maxWidth < this.dataPages[this.currentIndex].maxWidth) {
               this.maxWidth = this.dataPages[this.currentIndex].maxWidth;
            }
            this.maxHeight += this.dataPages[this.currentIndex].maxHeight;
         }
         this.setLeftComment();
         for (let i = 0; i < this._totalPages; i++) {
            this._statusInitial.push({'isInitial': false});
         }
         for (let i = 0; i < this.taskAttribute.docList.length; i++) {
            if (this.dataPages[i]) {
               this.taskAttribute.docList[i].totalPages = this.dataPages[i].totalPages;
            }
         }

         if (this.isZoom || this.isFitPage) { // fix case zoom before rotate
            this.maxHeight *= this.getCountZoom();
            this.maxWidth *= this.getCountZoom();
         }
         if (this._totalPages > 0) {
            this.setdatarotaterefreshPage(this.dataPages);
            this.setMaxHeight(this.dataPages[this.currentIndex]);
         }
         this.checkPositionPage = true;
         for (let i = 0; i < this._totalPages; i++) {
            if (this.itemRotates[this.currentIndex].itemRotate[0].item.height > this.itemRotates[this.currentIndex].itemRotate[0].item.width) {
               if (this.itemRotates[this.currentIndex].itemRotate[i].item.width > this.itemRotates[this.currentIndex].itemRotate[i].item.height) {
                  this.checkPositionPage = false;
                  break;
               }
            }
            if (this.itemRotates[this.currentIndex].itemRotate[0].item.width > this.itemRotates[this.currentIndex].itemRotate[0].item.height) {
               if (this.itemRotates[this.currentIndex].itemRotate[i].item.height > this.itemRotates[this.currentIndex].itemRotate[i].item.width) {
                  this.checkPositionPage = false;
                  break;
               }
            }
         }
         if (this._totalPages > 0) {
            this.addItemPage(this.dataPages[this.currentIndex], 0,
               this.itemRotates[this.currentIndex].itemRotate[0].item.transformHeight, this.maxWidth);
         }
         this.isPageLoadFinish = true;
         this.page = 1;
         if (!this.isToggleLeftOpened) {
            this.toggleLeft.emit();
         }
         if (this.isToggleRightOpened) {
            this._isComment = true;
            this.toggleRight.emit();
         }
         this.viewDocumentComp.canZoomOut = false;
         this.isInitail = true;
         this.handleWaitAction(false);
      }
   }

   /**
    *
    *  ฟังคก์ั่นไว้สำหรับเช็ต data เมื่อมีการ refreshpage
    */
   setdatarotaterefreshPage(items) {
      for (let j = 0; j < this._totalPages; j++) {
         this.itemRotates[this.currentIndex].itemRotate[j].item.scale = 0;
         this.itemRotates[this.currentIndex].itemRotate[j].item.posy = 0;
         this.itemRotates[this.currentIndex].itemRotate[j].item.posx = 0;
         this.itemrotatenum2[this.currentIndex].itemRotate[j].item.scale = 0;
         this.itemrotatenum2[this.currentIndex].itemRotate[j].item.posy = 0;
         this.itemrotatenum2[this.currentIndex].itemRotate[j].item.posx = 0;
      }
   }

   /**
    *
    *  ฟังคก์ั่นไว้สำหรับเช็ต data เริ่มต้นให้แต่ละหน้า
    */
   setDataRotate(items) {
      this.itemRotates = [];
      this.itemrotatenum2 = [];
      for (let i = 0; i < this.taskAttribute.docList.length; i++) {
         this.itemRotates.push({itemRotate: [], docId: ''});
         this.itemRotates[i].docId = this.taskAttribute.docList[i].docId;
         for (let j = 0; j < this.taskAttribute.docList[i].totalPages; j++) {
            this.itemRotates[i].itemRotate.push({
               item: {
                  scale: 0,
                  posx: 0,
                  posy: 0,
                  transformHeight: 0,
                  width: 0,
                  height: 0,
                  pageNo: j + 1,
                  directRotate: ''
               }
            });
         }
      }
      for (let i = 0; i < this.taskAttribute.docList.length; i++) {
         for (let j = 0; j < this.taskAttribute.docList[i].totalPages; j++) {
            if (j === 0) {
               this.itemRotates[i].itemRotate[j].item.transformHeight = 0;
            } else {
               this.itemRotates[i].itemRotate[j].item.transformHeight =
                  (Number(items[i].pages[j - 1].height) + 30) + this.itemRotates[i].itemRotate[j - 1].item.transformHeight;
            }
            this.itemRotates[i].itemRotate[j].item.width = (Number(items[i].pages[j].width));
            this.itemRotates[i].itemRotate[j].item.height = (Number(items[i].pages[j].height));
         }
      }
      for (let i = 0; i < this.taskAttribute.docList.length; i++) {
         this.itemrotatenum2.push({itemRotate: [], docId: ''});
         this.itemrotatenum2[i].docId = this.taskAttribute.docList[i].docId;
         for (let j = 0; j < this.taskAttribute.docList[i].totalPages; j++) {
            this.itemrotatenum2[i].itemRotate.push({
               item: {
                  scale: 0,
                  posx: 0,
                  posy: 0,
                  transformHeight: 0,
                  width: 0,
                  height: 0,
                  pageNo: j + 1,
                  directRotate: '',
                  isLoading: false
               }
            });
         }
      }
      for (let i = 0; i < this.taskAttribute.docList.length; i++) {
         for (let j = 0; j < this.taskAttribute.docList[i].totalPages; j++) {
            if (j === 0) {
               this.itemrotatenum2[i].itemRotate[j].item.transformHeight = 0;
            } else {
               this.itemrotatenum2[i].itemRotate[j].item.transformHeight =
                  (Number(items[i].pages[j - 1].height) + 30) + this.itemrotatenum2[i].itemRotate[j - 1].item.transformHeight;
            }
            this.itemrotatenum2[i].itemRotate[j].item.width = (Number(items[i].pages[j].width));
            this.itemrotatenum2[i].itemRotate[j].item.height = (Number(items[i].pages[j].height));
         }
      }
   }

   setMaxHeight(items) {
      this.widthMax = this.itemRotates[this.currentIndex].itemRotate[0].item.width;
      this.heightMax = 0;
      for (let j = 0; j < this.taskAttribute.docList[this.currentIndex].totalPages; j++) {
         this.checkImgLoaded[j] = false;
         if (j === 0) {
            this.itemRotates[this.currentIndex].itemRotate[j].item.transformHeight = 0;
         } else {
            this.itemRotates[this.currentIndex].itemRotate[j].item.transformHeight =
               (this.itemRotates[this.currentIndex].itemRotate[j - 1].item.height + 30) +
               this.itemRotates[this.currentIndex].itemRotate[j - 1].item.transformHeight;
         }
         this.heightMax += this.itemRotates[this.currentIndex].itemRotate[j].item.height + 30;
         if (this.itemRotates[this.currentIndex].itemRotate[j].item.width > this.widthMax) {
            this.widthMax = this.itemRotates[this.currentIndex].itemRotate[j].item.width;
         }
      }
      this.maxWidth = this.widthMax;
      this.setLeftComment();
      this.maxHeight = this.heightMax;
      this.sendWidthHeight.emit(this.itemRotates[this.currentIndex]);
   }

   setDocName(docName) {
      this._docName = this.taskAttribute.taskName + ' - ' + docName;
   }

   SetPositionZoom($object, img, i, ratio) {
      const Rotate = this.getValueTransform($object.attr('transform'));
      if (img === 'zoomin') {
         Rotate[1] = Rotate[1] * ratio;
         Rotate[2] = Rotate[2] * ratio;
      }

      if (img === 'zoomout') {
         Rotate[1] = Rotate[1] / ratio;
         Rotate[2] = Rotate[2] / ratio;
      }
      return 'rotate(' + Rotate.toString() + ')';
   }

   onZoomIn($event) {
      if (this.countZoom < 4) {
         this.checkheightpage = this.checkheightpage * 2;
         this.isZoom = true; // only click from zoom icon
         isZoom = true;
         if (!this.isDrawing) {
            this.deselectAll();
            if (this._objDraw) {
               this._objectDrag = this._objDraw.node;
            }
            this._objDraw = '';
            this.commentboxComp.setDeselectComment(false);
         }
         this.ZoomPage(true, 2.0, 'current');
      }
   }

   onZoomOut($event) {
      if (this.countZoom > 0) {
         this.checkheightpage = this.checkheightpage / 2;
         if (!this.isDrawing) {
            this.deselectAll();
            if (this._objDraw) {
               this._objectDrag = this._objDraw.node;
            }
            this._objDraw = '';
            this.commentboxComp.setDeselectComment(false);
         }
         this.ZoomPage(false, 2.0, 'current');
      }
   }

   /** เมื่อมีการทำ action zoom page */
   ZoomPage(isZoomIn: boolean, ratio: number, actionType: 'prev' | 'current') {
      let indexDoc = this.currentIndex;
      if (actionType === 'prev') {
         indexDoc = this.currentIndex;
      }
      if (this.countZoom >= 0 || this.countZoom <= 4) {
         this.ZoomContainerImage(isZoomIn, ratio);
         const $sideNavContent = $('#sideNavContent');
         if (isZoomIn) {
            for (let i = 0; i < $('#all-image').children().length; i++) {
               const $parent = $($('#all-image').children()[i]);
               $($parent.children()[0]).attr('transform', this.SetPositionZoom($($parent.children()[0]), 'zoomin', i, ratio));
            }
            this.ZoomItemAll(true, ratio);
            this.setHeightObject($('#svg-page'), $('#svg-page').attr('height') * ratio);
            this.setWidthObject($('#svg-page'), $('#svg-page').attr('width') * ratio);
            this.countZoom += 2;
            if (this.countZoom === 4) {
               this.viewDocumentComp.canZoomIn = false;
            } else {
               this.viewDocumentComp.canZoomOut = true;
            }
            $sideNavContent.scrollTop($sideNavContent.scrollTop() * ratio);
         } else {
            for (let i = 0; i < $('#all-image').children().length; i++) {
               const $parent = $($('#all-image').children()[i]);
               $($parent.children()[0]).attr('transform', this.SetPositionZoom($($parent.children()[0]), 'zoomout', i, ratio));
            }
            $sideNavContent.scrollTop($sideNavContent.scrollTop() / ratio);
            this.ZoomItemAll(false, ratio);
            this.setHeightObject($('#svg-page'), $('#svg-page').attr('height') / ratio);
            this.setWidthObject($('#svg-page'), $('#svg-page').attr('width') / ratio);
            this.countZoom -= 2;
            if (this.countZoom === 0) {
               this.viewDocumentComp.canZoomOut = false;
               this.isZoom = false;
               isZoom = false;
            } else {
               this.viewDocumentComp.canZoomIn = true;
            }
         }
         this.calculateZoomRotate(isZoomIn, ratio, actionType, indexDoc);
      }
   }

   /**
    *
    *
    * param: isZoomIn
    */
   calculateZoomRotate(isZoomIn, ratio, actionType, indexDoc) {
      if (isZoomIn) {
         for (let j = 0; j < this.taskAttribute.docList[this.currentIndex].totalPages; j++) {
            this.itemRotates[this.currentIndex].itemRotate[j].item.width = this.itemRotates[this.currentIndex].itemRotate[j].item.width * ratio;
            this.itemRotates[this.currentIndex].itemRotate[j].item.height = this.itemRotates[this.currentIndex].itemRotate[j].item.height * ratio;

         }
      } else {
         for (let j = 0; j < this.taskAttribute.docList[this.currentIndex].totalPages; j++) {
            this.itemRotates[this.currentIndex].itemRotate[j].item.width = this.itemRotates[this.currentIndex].itemRotate[j].item.width / ratio;
            this.itemRotates[this.currentIndex].itemRotate[j].item.height = this.itemRotates[this.currentIndex].itemRotate[j].item.height / ratio;

         }
      }
      for (let j = 0; j < this.taskAttribute.docList[this.currentIndex].totalPages; j++) {
         if (j === 0) {
            this.itemRotates[this.currentIndex].itemRotate[j].item.transformHeight = 0;
         } else {
            if (this.countZoom === 0) {
               this.itemRotates[this.currentIndex].itemRotate[j].item.transformHeight =
                  (this.itemRotates[this.currentIndex].itemRotate[j - 1].item.height + 30) +
                  this.itemRotates[this.currentIndex].itemRotate[j - 1].item.transformHeight;
            }
            if (this.countZoom === 2) {
               this.itemRotates[this.currentIndex].itemRotate[j].item.transformHeight =
                  (this.itemRotates[this.currentIndex].itemRotate[j - 1].item.height + 60) +
                  this.itemRotates[this.currentIndex].itemRotate[j - 1].item.transformHeight;
            }
            if (this.countZoom === 4) {
               this.itemRotates[this.currentIndex].itemRotate[j].item.transformHeight =
                  (this.itemRotates[this.currentIndex].itemRotate[j - 1].item.height + 120) +
                  this.itemRotates[this.currentIndex].itemRotate[j - 1].item.transformHeight;
            }
         }
      }
      if (this.itemRotates[this.currentIndex].itemRotate[0]?.item.width) {
         this.widthMax = this.itemRotates[this.currentIndex].itemRotate[0].item.width;
         for (let j = 0; j < this.taskAttribute.docList[this.currentIndex].totalPages; j++) {
            if (this.itemRotates[this.currentIndex].itemRotate[j].item.width > this.widthMax) {
               this.widthMax = this.itemRotates[this.currentIndex].itemRotate[j].item.width;
            }
         }
      }
      this.heightMax = 0;
      for (let j = 0; j < this.taskAttribute.docList[this.currentIndex].totalPages; j++) {
         if (this.countZoom === 0) {
            this.heightMax += this.itemRotates[this.currentIndex].itemRotate[j].item.height + 30;
         }
         if (this.countZoom === 2) {
            this.heightMax += this.itemRotates[this.currentIndex].itemRotate[j].item.height + 60;
         }
         if (this.countZoom === 4) {
            this.heightMax += this.itemRotates[this.currentIndex].itemRotate[j].item.height + 120;
         }
      }
      for (let i = 0; i < $('#all-image').children().length; i++) {
         const $parent = $($('#all-image').children()[i]);
         const $imageChild = $($parent.children()[0]);
         const $textChild = $($parent.children()[1]);
         const pageNo = parseInt($parent.attr('id').split('_')[1], 10);

         this.setXobject($textChild, this.calculateXtext(this.itemRotates[this.currentIndex]
            .itemRotate[i].item.width, pageNo, this._totalPages));
         this.setYobject($textChild, this.calculateYtext(parseFloat(this.itemRotates[this.currentIndex].itemRotate[i].item.height)));
      }
      this.maxHeight = this.heightMax;
      this.maxWidth = this.widthMax;
      this.setLeftComment();
      this.updateItemsSignCurrentPage();
   }

   /** ทำการ zoom ทุก object ที่แสดงอยู่ */
   ZoomItemAll(isZoomIn, ratio) {
      if (this._objectSVG) {
         for (const obj of this._objectSVG) {
            if (obj.svg) {
               for (const item of obj.svg.children()) {
                  this.zoomItem(item, isZoomIn, ratio);
               }
            }
         }
      }
   }

   zoomItem(item, isZoomIn, ratio) {
      const fieldType = $(item.node).attr('class');
      const width = item.attr('width');
      const height = item.attr('height');
      const x = item.attr('x');
      const y = item.attr('y');
      if (item.type === 'g' && (fieldType === 'signature' || fieldType === 'name' || fieldType === 'initSignature'
         || fieldType === 'date' || fieldType === 'text')) {
         const wRectChild = item.children()[0].attr('width');
         const hRectChild = item.children()[0].attr('height');
         const wRectChild2 = item.children()[1].attr('width');
         const hRectChild2 = item.children()[1].attr('height');
         const xText = item.children()[1].attr('x');
         const yText = item.children()[1].attr('y');
         const fontSize = item.children()[1].attr('font-size');
         item.attr('transform', this.ZoomTransform(isZoomIn, item, ratio));
         if (isZoomIn) {
            item.attr('width', wRectChild * ratio);
            item.attr('height', hRectChild * ratio);
            item.attr('x', x * ratio);
            item.attr('y', y * ratio);
            item.children()[0].attr('width', wRectChild * ratio);
            item.children()[0].attr('height', hRectChild * ratio);
            item.children()[1].attr('width', wRectChild2 * ratio);
            item.children()[1].attr('height', hRectChild2 * ratio);
            item.children()[1].attr('x', xText * ratio);
            item.children()[1].attr('y', yText * ratio);
            item.children()[1].attr('font-size', fontSize * ratio);
            if (fieldType === 'text') { //fix font-size when zoom in
               const fontFamily = item.children()[1].node.lastChild.style.fontFamily;
               const fontStyle = item.children()[1].node.lastChild.style.fontStyle;
               const fontWeight = item.children()[1].node.lastChild.style.fontWeight;
               this.isRecalText = false;
               if((fontFamily === 'Charmonman' || fontStyle === 'italic' || fontWeight === 'bold') && x === 0){
                  item.children()[1].attr('x', 3 * ratio);
               }
               item.children()[1].node.lastChild.style.fontSize = fontSize * ratio + 'px';
               let dy = item.children()[1].node.lastChild.getAttribute('dy');
               item.children()[1].attr('y', ((fontSize*ratio)-Number(dy)).toString());
            }
         } else {
            item.attr('width', wRectChild / ratio);
            item.attr('height', hRectChild / ratio);
            item.attr('x', x / ratio);
            item.attr('y', y / ratio);
            item.children()[0].attr('width', wRectChild / ratio);
            item.children()[0].attr('height', hRectChild / ratio);
            item.children()[1].attr('width', wRectChild2 / ratio);
            item.children()[1].attr('height', hRectChild2 / ratio);
            item.children()[1].attr('x', xText / ratio);
            item.children()[1].attr('y', yText / ratio);
            item.children()[1].attr('font-size', fontSize / ratio);
            if (fieldType === 'text') { //fix font-size when zoom out
               const fontFamily = item.children()[1].node.lastChild.style.fontFamily;
               const fontStyle = item.children()[1].node.lastChild.style.fontStyle;
               const fontWeight = item.children()[1].node.lastChild.style.fontWeight;
               this.isRecalText = false;
               if((fontFamily === 'Charmonman' || fontStyle === 'italic' || fontWeight === 'bold') && x === 0){
                     item.children()[1].attr('x', 3 * ratio);
               }
               let y = 0;
               item.children()[1].node.lastChild.style.fontSize = fontSize / ratio + 'px';
               let dy = item.children()[1].node.lastChild.getAttribute('dy');
               item.children()[1].attr('y', ((fontSize/ratio)-Number(dy)).toString());
            }
         }
      } else if (item.type === 'g' && (item.attr('class') === 'comment' || item.attr('class') === 'image')) {
         const wRectChild = item.children()[0].attr('width');
         const hRectChild = item.children()[0].attr('height');
         const xText = item.children()[1].attr('x');
         const yText = item.children()[1].attr('y');
         item.attr('transform', this.ZoomTransform(isZoomIn, item, ratio));
         if (isZoomIn) {
            item.attr('width', wRectChild * ratio);
            item.attr('height', hRectChild * ratio);
            item.attr('x', x * ratio);
            item.attr('y', y * ratio);
            item.children()[0].attr('width', wRectChild * ratio);
            item.children()[0].attr('height', hRectChild * ratio);
            item.children()[1].attr('x', xText * ratio);
            item.children()[1].attr('y', yText * ratio);
            item.children()[1].attr('width', wRectChild * ratio);
            item.children()[1].attr('height', hRectChild * ratio);
         } else {
            item.attr('width', wRectChild / ratio);
            item.attr('height', hRectChild / ratio);
            item.attr('x', x / ratio);
            item.attr('y', y / ratio);
            item.children()[0].attr('width', wRectChild / ratio);
            item.children()[0].attr('height', hRectChild / ratio);
            item.children()[1].attr('x', xText / ratio);
            item.children()[1].attr('y', yText / ratio);
            item.children()[1].attr('width', wRectChild / ratio);
            item.children()[1].attr('height', hRectChild / ratio);
         }
      } else if (item.type === 'image') {
         if (isZoomIn) {
            item.attr('width', width * ratio);
            item.attr('height', height * ratio);
            item.attr('x', x * ratio);
            item.attr('y', y * ratio);
         } else {
            item.attr('width', width / ratio);
            item.attr('height', height / ratio);
            item.attr('x', x / ratio);
            item.attr('y', y / ratio);
         }
      } else if (item.type === 'text') {
         const fontSize = item.attr('font-size');
         if (isZoomIn) {
            item.attr('x', x * ratio);
            item.attr('y', y * ratio);
            item.attr('font-size', fontSize * ratio);
         } else {
            item.attr('x', x / ratio);
            item.attr('y', y / ratio);
            item.attr('font-size', fontSize / ratio);
         }
      } else if (item.type === 'g' && fieldType === 'checkbox') {
         const wRectChild = item.children()[0].attr('width');
         const hRectChild = item.children()[0].attr('height');
         const wRectChild1 = item.children()[1].attr('width');
         const hRectChild1 = item.children()[1].attr('height');
         const wRectChild2 = item.children()[2].attr('width');
         const hRectChild2 = item.children()[2].attr('height');
         const xBox = item.children()[1].attr('x');
         const yBox = item.children()[1].attr('y');
         const xCheck = item.children()[2].attr('x');
         const yCheck = item.children()[2].attr('y');
         item.attr('transform', this.ZoomTransform(isZoomIn, item, ratio));
         if (isZoomIn) {
            item.attr('width', width * ratio);
            item.attr('height', height * ratio);
            item.attr('x', x * ratio);
            item.attr('y', y * ratio);
            item.children()[0].attr('width', wRectChild * ratio);
            item.children()[0].attr('height', hRectChild * ratio);
            item.children()[1].attr('x', xBox * ratio);
            item.children()[1].attr('y', yBox * ratio);
            item.children()[1].attr('width', wRectChild1 * ratio);
            item.children()[1].attr('height', hRectChild1 * ratio);
            item.children()[2].attr('x', xCheck * ratio);
            item.children()[2].attr('y', yCheck * ratio);
            item.children()[2].attr('width', wRectChild2 * ratio);
            item.children()[2].attr('height', hRectChild2 * ratio);
         } else {
            item.attr('width', width / ratio);
            item.attr('height', height / ratio);
            item.attr('x', x / ratio);
            item.attr('y', y / ratio);
            item.children()[0].attr('width', wRectChild / ratio);
            item.children()[0].attr('height', hRectChild / ratio);
            item.children()[1].attr('x', xBox / ratio);
            item.children()[1].attr('y', yBox / ratio);
            item.children()[1].attr('width', wRectChild1 / ratio);
            item.children()[1].attr('height', hRectChild1 / ratio);
            item.children()[2].attr('x', xCheck / ratio);
            item.children()[2].attr('y', yCheck / ratio);
            item.children()[2].attr('width', wRectChild2 / ratio);
            item.children()[2].attr('height', hRectChild2 / ratio);
         }
      }
   }

   setHeightObject($object, height) {
      $object.attr('height', height);
   }

   setWidthObject($object, width) {
      $object.attr('width', width);
   }

   setXobject($object, x) {
      $object.attr('x', x);
   }

   setYobject($object, y) {
      $object.attr('y', y);
   }

   setHeaderWidth(width) {
      $('.viewdoc-toolbar').css('padding-left', width);
   }

   /** add รูปภาพต่อท้ายรูปที่แสดงทั้งหมดในปัจจุบัน */
   append(imgUrl: string, width: number, height: number, tranHeight: number, pageNo: number, maxWidth: number) {
      if (this.isZoom || this.isFitPage || !this.isToggleRightOpened) {
         width *= this.getCountZoom();
         height *= this.getCountZoom();
         maxWidth *= this.getCountZoom();
      }
      if (this.checkPositionPage) {
         if (this.maxWidth > this.itemRotates[this.currentIndex].itemRotate[Number(pageNo - 1)].item.width) {
            this.position = (this.maxWidth - this.itemRotates[this.currentIndex].itemRotate[Number(pageNo - 1)].item.width) / 2;
         } else {
            this.position = 0;
         }
      }

      if (!this.checkPositionPage) {
         if (this.itemRotates[this.currentIndex].itemRotate[Number(pageNo - 1)].item.width >=
            this.itemRotates[this.currentIndex].itemRotate[Number(pageNo - 1)].item.height &&
            this.itemRotates[this.currentIndex].itemRotate[Number(pageNo - 1)].item.width === this.maxWidth) {
            this.position = 0;
         } else {
            this.position = (this.maxWidth - this.itemRotates[this.currentIndex].itemRotate[Number(pageNo - 1)].item.width) / 2;
         }
      }

      const $_img = $('#img_' + pageNo);
      if ($_img.length === 0) {
         // change to dynamic append and prepend
         const svgNS = "http://www.w3.org/2000/svg";
         // <g>
         const g = document.createElementNS(svgNS, "g");
         g.setAttribute("class", "imageSign");
         g.setAttribute("draggable", "false");
         g.setAttribute("id", `img_${pageNo}`);
         g.setAttribute("transform", `matrix(1,0,0,1,${this.position},${tranHeight})`);

         // <image>
         const img = document.createElementNS(svgNS, "image");
         img.setAttribute("id", `test_img_${pageNo}`);
         img.setAttribute("draggable", "false");

         const rotateData = this.itemRotates[this.currentIndex].itemRotate;
         const item = rotateData[pageNo - 1].item;
         const scaleItem = rotateData[this.countpage].item;

         // width / height
         img.setAttribute("width", `${item.width}`);
         img.setAttribute("height", `${item.height}`);

         // image URL
         img.setAttribute("href", imgUrl);

         // transform (rotate)
         img.setAttribute(
         "transform",
         `rotate(${scaleItem.scale}, ${scaleItem.posx}, ${scaleItem.posy})`
         );

         // onload event
         img.addEventListener("load", () => this.checkSpinner(pageNo));

         // <text> หน้า x of y
         const txt = document.createElementNS(svgNS, "text");
         txt.setAttribute("class", "doNotPrint");

         txt.setAttribute(
         "y",
         `${this.calculateYtext(item.height)}`
         );

         txt.setAttribute(
         "x",
         `${this.calculateXtext(item.width, pageNo, this._totalPages)}`
         );

         txt.textContent = `${pageNo} ${this.textPageOf} ${this._totalPages}`;

         // WATERMARK
         const watermarkNode = this.createWatermarkNode(pageNo);

         // APPEND CHILD
         g.appendChild(img);
         g.appendChild(txt);
         if (watermarkNode) g.appendChild(watermarkNode);
         this.allImages.nativeElement.appendChild(g);
      } else {
         $($_img.find('image')[0]).attr('href', imgUrl);
      }
      const id = 'test_img_' + pageNo;
      $('#' + id).on('load', () => {
         let pageload = Number(pageNo);
         pageload = pageload - 1;
         this.checkImgLoaded[pageload] = true;
         if (this.checkImgLoaded[0] === true) {
            this.isPageLoadFinish = true;
            this.onloadPageEnd.emit();
         }
         if (this._statusInitial[this.page - 1].isInitial === true) {
            if (this.checkImgLoaded[this.page - 1] === false) {
               this.onloadedByPage.emit(this.checkImgLoaded);
               this.onloadedPage.emit(false);
               this.checkloadrotate = false;
            } else {
               this.onloadedByPage.emit(this.checkImgLoaded);
               this.onloadedPage.emit(true);
               this.checkloadrotate = true;
            }
         }
         setTimeout(() => {
            this.changeDetector.detectChanges();
         },100);
      }).each(function () {
         if (this.complete) {
            $(this).trigger('load'); // For jQuery >= 3.0
         }
      });
      this.countpage += 1;
   }

   createWatermarkNode(pageNo: number) {

      const svgNS = "http://www.w3.org/2000/svg";
      const watermarkHtml = this.createWatermark(pageNo);
      const temp = document.createElementNS(svgNS, "g");
      temp.innerHTML = watermarkHtml;

      return temp.firstChild as Node;
   }

   createWatermark(pageNo) {
      let watermarkHTML = '';
      if (this.watermark && this.watermark != null) {
         let fontFamily = 'sans-serif';
         let color = '#33BBE6';
         let fontSize = '60';
         let opacity = 0.25;
         if (this.watermark.fontFamily) {
            fontFamily = this.watermark.fontFamily;
         }
         if (this.watermark.color) {
            color = this.watermark.color;
         }
         if (this.watermark.fontSize) {
            fontSize = this.watermark.fontSize;
         }
         if (this.watermark.opacity) {
            opacity = this.watermark.opacity / 100;
         }
         const width = this.itemRotates[this.currentIndex].itemRotate[Number(pageNo - 1)].item.width;
         const height = this.itemRotates[this.currentIndex].itemRotate[Number(pageNo - 1)].item.height;

         watermarkHTML = '<text dominant-baseline="middle" text-anchor="middle" ' +
            'fill="' + color + '" transform="translate(' + (width / 2) + ',' + (height / 2) + ') rotate(-45)" ' +
            'fill-opacity="' + opacity + '" font-size="' + (parseInt(fontSize, 10) * this.getCountZoom()) + '" font-family="' + fontFamily + '">' + this.watermark.text + '</text>';
      }
      return watermarkHTML;
   }

   checkSpinner(pageNo) {
      // This is intentional.
      return "";
   }

   appendPrint(imgUrl: string, width: number, height: number, tranHeight: number, pageNo: number) {
      if (pageNo === 1) {
         this.numprint = 20;
      } else {
         this.numprint = 25;
      }
      if (this.itemRotates[this.currentIndex].itemRotate[this.countpageprint].item.width >
         this.itemRotates[this.currentIndex].itemRotate[this.countpageprint].item.height) {
         this.print.nativeElement
            .insertAdjacentHTML('beforeEnd',
               '<img src=' + imgUrl + ' width=' + '100%' + ' height=' + '170%' + '' +
               ' style="padding-top:' + this.numprint + 'px;" class="landscape "  />'
            );
      }
      if (this.itemRotates[this.currentIndex].itemRotate[this.countpageprint].item.height >
         this.itemRotates[this.currentIndex].itemRotate[this.countpageprint].item.width) {
         this.print.nativeElement
            .insertAdjacentHTML('beforeEnd',
               '<img src=' + imgUrl + ' width=' + '100%' + ' height=' + '170%' + '' +
               ' style="padding-top:' + this.numprint + 'px;" class="portrait"  />'
            );
      }
      this.countpageprint += 1;
   }

   /** ลบรูปภาพสุดท้ายออก */
   remove() {
      this.allImages.nativeElement.lastChild.remove(); // TODO : remove element
   }

   /** เมื่อแทบ navigation มีการเปลี่ยนแปลงจะเข้า function callback นี้ */
   navChange(component, drawer) {
      this._isVisible = drawer._elementRef.nativeElement.style.visibility;
      if (drawer.opened) { // TODO : change position of menu on headerbar
         this.isHideArrowLeft = true;
         this.isHideArrowRight = false;
         this.handleToggleOpend();
         if (!this.isZoom && this.isToggleRightOpened) {
            this.isFitPage = true;
            this.handleFitPage(true);
         }
      } else {
         this.isHideArrowLeft = false;
         this.isHideArrowRight = true;
         this.handleToggleClosed();
         this.onscrollTum.emit(this.page);
         if (!this.isZoom && this.isToggleRightOpened) {
            this.isFitPage = false;
            this.handleFitPage(false);
         }
      }
      this.setLeftComment();
   }

   /** ตั้งค่าเริ่มต้นให้ object ที่ถูกส่งมาตาม signItem ใน taskAttribute */
   InitialDrawSvg(item) {
      const id = 'img_' + item.pageNum;
      this._draw = null;
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            if (id === object.id) {
               // Remove old signItem, if exist
               if(item.idSignItem && $('#'+item.idSignItem)) {
                  $('#'+item.idSignItem).remove();
               }

               this._draw = object.svg;
               break;
            }
         }
      }
      if (this._draw) {
         this.initialTypeNotSign(item, this.getCountZoom());
         if (this.show && !this.viewMode) {
            this._objDraw.on('click', (e) => {
               if (item.fieldType === this._keyFieldType.comment
                  || item.fieldType === this._keyFieldType.checkbox) {
                  this.isHideProperties = true;
               } else {
                  this.isHideProperties = false;
               }
               if(item.fieldType === this._keyFieldType.image){
                  this.isHidepageType = true;
               } else {
                  this.isHidepageType = false;
               }
            });

            this._objDraw.on('beforedrag', (e) => {
               this.setVisibleTextProperties(e);
               this.handleChangeTab();
               if (!this.isDrawing) {
                  this._objDraw = '';
               }
               this._objectDrag = e.target;
               const $id = e.target.id;
               this.deselectAllWithOutMatchId($id);
               if (this.taskAttribute.docList[this.currentIndex].signItems) {
                  for (const signItem of this.taskAttribute.docList[this.currentIndex].signItems) {
                     if (signItem.idSignItem === $id) {
                        this.setProperties(signItem, $id);
                        if (this.leftPanelComp.toolsComp &&  this.leftPanelComp.toolsComp.signers) {
                           let index = this.leftPanelComp.toolsComp.signers.findIndex((data) => parseInt(data.taskContactId, 10) === parseInt(item.taskContactId, 10));
                           if (index < 0) {
                              index = 0;
                           }
                           this.leftPanelComp.toolsComp.selected = index;
                           this.signerSelected.signer = this.leftPanelComp.toolsComp.signers[index];
                           this.signerSelected.index = index;
                           break;
                        }
                     }
                  }
               }
            });
            this._objDraw.on('beforedrag', function (e) {
               if (!item.flagSign) {
                  this.attr({'cursor': 'move'});
                  if (item.fieldType !== 'image') {
                     this.children()[0].attr({'cursor': 'move'});
                     this.children()[1].attr({'cursor': 'move'});
                  }
                  if (item.fieldType === 'comment') {
                     this.selectize({
                        points: ['lt', 'rt', 'rb', 'lb'],
                        rotationPoint: false
                     });
                  } else if (item.fieldType === 'signature' || item.fieldType === 'initSignature') {
                     this.children()[1].selectize({
                        points: ['lt', 'rt', 'rb', 'lb'],
                        rotationPoint: false
                     }).resize({saveAspectRatio: true});
                  } else {
                     this.selectize({
                        points: false,
                        rotationPoint: false
                     });
                  }
               }
            });
            this._objDraw.on('dragstart.namespace', (e) => {
               this.setVisibleTextProperties(e);
               this._onDrag = true;
               onDrag = true;
            });

            this._objDraw.on('dragmove.namespace', function (e) { // need to calculdate diffent Y
               if (changeImage) {
                  e.preventDefault();
                  this.move(e.detail.event.offsetX, e.detail.event.offsetY - imageHeight);
               }
            });
            this._objDraw.on('dragend.namespace', function (e) {
               if(this.type === 'image'){
                  this.attr({'cursor': 'pointer'});
               } else {
                  this.attr({'cursor': 'pointer'});
                  this.children()[0].attr({'cursor': 'pointer'});
                  this.children()[1].attr({'cursor': 'pointer'});
               }
               if (item.fieldType === 'comment') {
                  this.selectize({
                     points: ['lt', 'rt', 'rb', 'lb'],
                     rotationPoint: false
                  });
               } else if (this.type === 'image') {
                  this.selectize({
                     points: ['lt', 'rt', 'rb', 'lb'],
                     rotationPoint: false
                  }).resize({saveAspectRatio: true});
               } else if (item.fieldType === 'signature' || item.fieldType === 'initSignature') {
                  this.children()[1].selectize({
                     points: ['lt', 'rt', 'rb', 'lb'],
                     rotationPoint: false
                  }).resize({saveAspectRatio: true});
               } else {
                  this.selectize({
                     points: false,
                     rotationPoint: false
                  });
               }
               changeImage = false;
               onDrag = false;
            });

            if ($(this._objDraw.node).attr('fieldType') === this._keyFieldType.signature || $(this._objDraw.node).attr('fieldType') === this._keyFieldType.initSignature) {
               $($(this._objDraw.node).children()[1]).on('resizedone', (e) => { // เมื่อ resize จบจะเข้า action นี้
                  if (this._objDraw) {
                     let transforms = this.getValueTransform(this._objDraw.attr('transform'));
                     let xItem = parseFloat(transforms[4]), yItem = parseFloat(transforms[5]);
                     let xItem2, yItem2, calX, calY;

                     $($(this._objDraw.node).children()[0]).attr('width',$($(this._objDraw.node).children()[1]).attr('width'));
                     $($(this._objDraw.node).children()[0]).attr('height',$($(this._objDraw.node).children()[1]).attr('height'));
                     xItem2 = $($(this._objDraw.node).children()[1]).attr('x');
                     yItem2 = $($(this._objDraw.node).children()[1]).attr('y');
                     calX = Number(xItem) + Number(xItem2);
                     calY = Number(yItem) + Number(yItem2);
                     this.setPositionCurrentSignItem(this._objDraw, calX, calY);
                     $($(this._objDraw.node).children()[1]).attr('x', 0);
                     $($(this._objDraw.node).children()[1]).attr('y', 0);
                     this.updateItemsSignCurrentPage();
                  } else if (this._objectDrag) {
                     let transforms = this.getValueTransform($(this._objectDrag).attr('transform'));
                     let xItem = parseFloat(transforms[4]), yItem = parseFloat(transforms[5]);
                     let xItem2, yItem2, calX, calY;
                     $($(this._objectDrag).children()[0]).attr('width',$($(this._objectDrag).children()[1]).attr('width'));
                     $($(this._objectDrag).children()[0]).attr('height',$($(this._objectDrag).children()[1]).attr('height'));

                     xItem2 = $($(this._objectDrag).children()[1]).attr('x');
                     yItem2 = $($(this._objectDrag).children()[1]).attr('y');
                     calX = Number(xItem) + Number(xItem2);
                     calY = Number(yItem) + Number(yItem2);

                     this.setPositionCurrentSignItem($(this._objectDrag), calX, calY);
                     $($(this._objectDrag).children()[1]).attr('x', 0);
                     $($(this._objectDrag).children()[1]).attr('y', 0);
                     this.updateItemsSignCurrentPage();
                  }
               });
            } else if ($(this._objDraw.node).attr('fieldType') === this._keyFieldType.image) { // ต้องแยก Type Image เนื่องจาก Tag Group ไม่เหมือน Type อื่น
               if (this._objDraw) {
                  this._objDraw.on('resizedone', (e) => { // fieldType Image เมื่อ resize จบจะเข้า action นี้
                     this.updateItemsSignCurrentPage();
                  });
               }
            }

            this._objDraw.on('dragend.namespace', (e) => { // เมื่อการลาก object จบจะเข้า event นี้
               this.checkImgFocus(e);
               this.isDrawing = false; // ตั้งค่าตัวแปร flag ของ drawing เพื่อให้รู้ว่า drawing จบแล้ว
               if(item.fieldType === 'image' && item.idImageItem){
                  this.calculateOutBoundItemImage(e);
               } else {
                  this.calculateOutBoundItem(e);
               }
               this.setCheckBoxInclude(e);
               if ($(e.target).attr('fieldType') === this._keyFieldType.text) {
                  this.setTextStyle();
               }
               this.updateItemsSignCurrentPage();
               this.finishSVG('');
               this.setVisibleTextProperties(e);
               this._onDrag = false; // ตั้งค่าตัวแปร flag ของ drag เพื่อให้รู้ว่า drag จบแล้ว
            });
            this._objDraw.draggable();
            item.idSignItem = this._objDraw.attr('id');
         }
         if ($(this._objDraw.node).attr('fieldType') === this._keyFieldType.text) {
            this.setTextStyle();
         }
         this.setFontSignText();
         if ($(this._objDraw.node).attr('fieldType') === this._keyFieldType.comment
 || $(this._objDraw.node).attr('fieldType') === this._keyFieldType.checkbox) {
            this.isHideProperties = true;
         } else {
            this.isHideProperties = false;
         }
         if($(this._objDraw.node).attr('fieldType') === this._keyFieldType.image){
            this.isHidepageType = true;
         } else {
            this.isHidepageType = false;
         }
      }
   }

   /** เมื่อคลิกที่ comment list จะทำการ select ที่ comment icon */
   onSelectDrawComment($event) {
      if (this._objectSVG) {
         this.deselectAll();
         for (const object of this._objectSVG) {
            for (const item of object.svg.children()) {
               if ((item.type === 'text' || item.type === 'image' || item.type === 'g')) {
                  if (item.attr('signer') && item.attr('id') === $event.id) {
                     if ($event.isActive) {
                        this.handleChangeTab();
                        this._onDrag = true; // ตั้งค่าตัวแปร flag drag
                        onDrag = true;
                        this._objectDrag = item.node;
                        this._idSignitems =  $event.id; // เก็บค่า id ของ object ล่าสุด
                        this.fieldType = item.attr('fieldType');
                        if (item.attr('signer') === this.service.user.email) {
                           this.isHideDeleteBtn = false;
                        } else {
                           this.isHideDeleteBtn = true;
                        }
                        if (item.attr('fieldType') === this._keyFieldType.comment) {
                           this.isHideProperties = true;
                        } else {
                           this.isHideProperties = false;
                        }
                        this.setVisibleProperty(true);
                        setTimeout(() => {
                           item.selectize({
                              points: ['lt', 'rt', 'rb', 'lb'],
                              rotationPoint: false,
                           });
                        }, 0);
                        break;
                     }
                  }
               }
            }
         }
      }
   }

   /** เมื่อมีการอัพเดท comment จะทำการกลับมาอัพเดทค่าให้ signItem */
   saveCommentTask($event) {
      const data = Object.assign({}, $event);
      data.signItems.fieldWidth /= this.getCountZoom();
      data.signItems.fieldHeight /= this.getCountZoom();
      data.signItems.coordinateX /= this.getCountZoom();
      data.signItems.coordinateY /= this.getCountZoom();
      const comment = JSON.stringify(data.signItems.comment);
      if (!this.isDrawing) {
         if (this._objDraw) {
            this._objDraw.attr({'comment': comment});
         } else if (this._objectDrag) {
            const $objectDrag = $(this._objectDrag);
            $objectDrag.attr({'comment': comment});
         }
         if (this.taskAttribute.docList[this.currentIndex]) {
            this.addItemSignerSelect(this.currentIndex);
         }
      }
   }

   /** เมื่อมีการ reply comment จะทำการกลับมาอัพเดทค่าให้ signItem */
   saveReplyTask($event) {
      const data = Object.assign({}, $event);
      const signItems = data.signItems;
      const comment = JSON.stringify(signItems.comment);
      if (!this.isDrawing) {
         if (this._objDraw) {
            this._objDraw.attr({'comment': comment});
         } else if (this._objectDrag) {
            const $objectDrag = $(this._objectDrag);
            $objectDrag.attr({'comment': comment});
         }
         if (this.taskAttribute.docList[this.currentIndex]) {
            this.addItemSignerSelect(this.currentIndex);
         }
      }
   }

   /** วาด object ลายเซ็น ชื่อ วันที่ พร้อม ผูก event ให้แต่ละ object */
   drawSVG($event) {
      if (!this._eventMouseOver) {
         this._eventMouseOver = $event;
      }
      if (this.startDrawing) {
         if ($event.target.parentNode.id && !this.isDrawing) {
            this.setInitialPositionType();
            this.setInitialPageType();
            const id = this.checkImgFocus($event);
            if (this._objectSVG) {
               for (const object of this._objectSVG) {
                  if (id === object.id) {
                     this._draw = object.svg;
                     break;
                  }
               }
            }
            this.drawTypeNotSign(id);
            this._objDraw.on('beforedrag', (e) => { // หลัง object วาดเสร็จตั้งค่า event เมื่อคลิกที่ object
               this.setVisibleTextProperties(e);
               this.handleChangeTab();
               if (!this.isDrawing) {
                  this._objDraw = '';
               }
               this._objectDrag = e.target;
               const id_target = $(e.target).attr('id');
               this.deselectAllWithOutMatchId(id_target);
               if (this.taskAttribute.docList[this.currentIndex].signItems) {
                  for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
                     if (item.idSignItem === id_target) {
                        this.setProperties(item, id_target);
                        if (this.leftPanelComp.toolsComp &&  this.leftPanelComp.toolsComp.signers) {
                           let index = this.leftPanelComp.toolsComp.signers.findIndex((data) => parseInt(data.taskContactId, 10) === parseInt(item.taskContactId, 10));
                           if (index < 0) {
                              index = 0;
                           }
                           this.leftPanelComp.toolsComp.selected = index;
                           this.signerSelected.signer = this.leftPanelComp.toolsComp.signers[index];
                           this.signerSelected.index = index;
                           break;
                        }
                     }
                  }
               }
            });
            this._objDraw.on('beforedrag', function (e) { // หลัง object วาดเสร็จตั้งค่า event เมื่อคลิกที่ object
               this.attr({'cursor': 'move'});
               this.children()[0].attr({'cursor': 'move'});
               this.children()[1].attr({'cursor': 'move'});
               if ($(this.node).attr('fieldType') === 'comment') {
                  this.selectize({
                     points: ['lt', 'rt', 'rb', 'lb'],
                     rotationPoint: false
                  });
               } else if ($(this.node).attr('fieldType') === 'signature' || $(this.node).attr('fieldType') === 'initSignature') {
                  this.children()[1].selectize({
                     points: ['lt', 'rt', 'rb', 'lb'],
                     rotationPoint: false
                  }).resize({saveAspectRatio: true});
               } else {
                  this.selectize({
                     points: false,
                     rotationPoint: false
                  });
               }
            });
            this._objDraw.on('dragstart.namespace', (e) => { // เมื่อเริ่มลาก object จะทำ event ตามนี้
               this.setVisibleTextProperties(e);
               if (this._draw) {
                  for (const item of this._draw.children()) {
                     if (item.type !== 'g') { // ซ่อนกรอบ select object อื่นทิ้ง
                        item.selectize(false);
                        if(item.children){
                           if (item.children()[1]) {
                              item.children()[1].selectize(false);
                           }
                        }
                     }
                  }
               }
               this._onDrag = true; // ตั้งค่าตัวแปร flag drag
               onDrag = true;
               this._objectDrag = e.target; // เก็บ object drag ที่เลือกปัจจุบันล่าสุด
            });
            this._objDraw.on('dragmove.namespace', function (e) { // คำนวณการเคลื่อนไหวไหมของ object
               if (changeImage) {
                  e.preventDefault();
                  this.move(e.detail.event.offsetX, e.detail.event.offsetY - imageHeight);
               }
            });
            this._objDraw.on('dragend.namespace', function (e) { // เมื่อการลาก object จบจะเข้า event นี้
               this.attr({'cursor': 'pointer'}); // เปลี่ยนรูปเมาส์กลับเป็นปกติ
               this.children()[0].attr({'cursor': 'pointer'});
               this.children()[1].attr({'cursor': 'pointer'});
               if ($(this.node).attr('fieldType') === 'comment') {
                  this.selectize({
                     points: ['lt', 'rt', 'rb', 'lb'],
                     rotationPoint: false
                  });
               } else if ($(this.node).attr('fieldType') === 'signature' || $(this.node).attr('fieldType') === 'initSignature') {
                  this.children()[1].selectize({
                     points: ['lt', 'rt', 'rb', 'lb'],
                     rotationPoint: false
                  }).resize({saveAspectRatio: true});
               } else {
                  this.selectize({
                     points: false,
                     rotationPoint: false
                  });
               }
               changeImage = false;
               onDrag = false; // ตั้งค่าตัวแปร flag ของ drag เพื่อให้รู้ว่า drag จบแล้ว
            });

            if ($(this._objDraw.node).attr('fieldType') === this._keyFieldType.signature || $(this._objDraw.node).attr('fieldType') === this._keyFieldType.initSignature) {
               $($(this._objDraw.node).children()[1]).on('resizing', (e) => { // เมื่อ resize จบจะเข้า action นี้
                  if (!this.isDrawing) {
                     this._objDraw = ''; // เคลียร์ค่า object นี้ทิ้งเพื่อไม่ให้ซ้ำซ้อนตอนที่เก็บ object เข้า taskAttribute
                  }
                  this._objectDrag = e.target; // เก็บ object drag ที่เลือกปัจจุบันล่าสุด
               });
            }

            if ($(this._objDraw.node).attr('fieldType') === this._keyFieldType.signature || $(this._objDraw.node).attr('fieldType') === this._keyFieldType.initSignature) {
               $($(this._objDraw.node).children()[1]).on('resizedone', (e) => { // เมื่อ resize จบจะเข้า action นี้
                  if (this._objDraw) {
                     let transforms = this.getValueTransform(this._objDraw.attr('transform'));
                     let xItem = parseFloat(transforms[4]), yItem = parseFloat(transforms[5]);
                     let xItem2, yItem2, calX, calY;

                     $($(this._objDraw.node).children()[0]).attr('width',$($(this._objDraw.node).children()[1]).attr('width'));
                     $($(this._objDraw.node).children()[0]).attr('height',$($(this._objDraw.node).children()[1]).attr('height'));

                     xItem2 = $($(this._objDraw.node).children()[1]).attr('x');
                     yItem2 = $($(this._objDraw.node).children()[1]).attr('y');

                     calX = Number(xItem) + Number(xItem2);
                     calY = Number(yItem) + Number(yItem2);

                     this.setPositionCurrentSignItem(this._objDraw, calX, calY);

                     $($(this._objDraw.node).children()[1]).attr('x', 0);
                     $($(this._objDraw.node).children()[1]).attr('y', 0);
                     this.updateItemsSignCurrentPage();
                  } else if (this._objectDrag) {
                     let transforms = this.getValueTransform($(this._objectDrag.parentNode).attr('transform'));
                     let xItem = parseFloat(transforms[4]), yItem = parseFloat(transforms[5]);
                     let xItem2, yItem2, calX, calY;

                     $($(this._objectDrag.parentNode).children()[0]).attr('width',$($(this._objectDrag.parentNode).children()[1]).attr('width'));
                     $($(this._objectDrag.parentNode).children()[0]).attr('height',$($(this._objectDrag.parentNode).children()[1]).attr('height'));

                     xItem2 = $($(this._objectDrag.parentNode).children()[1]).attr('x');
                     yItem2 = $($(this._objectDrag.parentNode).children()[1]).attr('y');

                     calX = Number(xItem) + Number(xItem2);
                     calY = Number(yItem) + Number(yItem2);

                     this.setPositionCurrentSignItem($(this._objectDrag.parentNode), calX, calY);

                     $($(this._objectDrag.parentNode).children()[1]).attr('x', 0);
                     $($(this._objectDrag.parentNode).children()[1]).attr('y', 0);

                     this.updateItemsSignCurrentPage();
                  }
               });
            }

            this._objDraw.on('dragend.namespace', (e) => { // เมื่อการลาก object จบจะเข้า event นี้
               this.checkImgFocus(e);
               this.isDrawing = false; // ตั้งค่าตัวแปร flag ของ drawing เพื่อให้รู้ว่า drawing จบแล้ว
               if($(this._objDraw.node).attr('fieldType') === this._keyFieldType.image){
                  this.calculateOutBoundItemImage(e);
               } else {
                  this.calculateOutBoundItem(e);
               }
               if ($(e.target).attr('fieldType') === this._keyFieldType.text) {
                  this.setTextStyle();
               }
               this.updateItemsSignCurrentPage();
               this.finishSVG('');
               this.setVisibleTextProperties(e);
               this._onDrag = false; // ตั้งค่าตัวแปร flag ของ drag เพื่อให้รู้ว่า drag จบแล้ว
            });
            this._objDraw.on('dragover', (e) => { // เมื่อลาก object มาวางไว้ที่หน้าเอกสารต้องเคลียร์ event ให้ไม่ขึ้นรูปห้าม drag
               e.preventDefault();
               e.stopPropagation();

            });
            if ($(this._objDraw.node).attr('fieldType') === this._keyFieldType.text) {
               this.setTextStyle();
            }
            this.setFontSignText();
            if ($(this._objDraw.node).attr('fieldType') === this._keyFieldType.comment) {
               this._objDraw.selectize({
                  points: ['lt', 'rt', 'rb', 'lb'],
                  rotationPoint: false
               });
            } else if ($(this._objDraw.node).attr('fieldType') === this._keyFieldType.signature || $(this._objDraw.node).attr('fieldType') === this._keyFieldType.initSignature) {
               $($(this._objDraw.node).children()[1])[0].instance.selectize({
                  points: ['lt', 'rt', 'rb', 'lb'],
                  rotationPoint: false
               }).resize({saveAspectRatio: true});
            } else {
               this._objDraw.selectize({
                  points: false,
                  rotationPoint: false
               });
            }
            this._objDraw.draggable(); // ตั้งค่าให้ object สามารถ drag ได้
            if (!this._isDrag) { // เช็คกรณีที่วาดรูปลงหน้าเอกสาร
               this.isDrawing = true; // ตั้งค่า flag drawing เพื่อให้รู้ว่ากำลังวาด object อยู่
            } else {
               this.calculateMove($event);
               this._isDrag = false;
               this.isDrawing = false;
               this.updateItemsSignCurrentPage();
            }
            this.startDrawing = false; // ตั้งค่า flag เพื่อให้รู้ว่าเริ่มการวาดแล้ว
            this._idSignitems = $(this._objDraw.node).attr('id'); // เก็บค่า id ของ object ล่าสุด
            this._isHideProp = false; // ตั้งค่า flag ว่าจะให้ซ่อนตัวตั้งค่า properties ไหม
            this.isHideDeleteBtn = false; // ตั้งค่า flag ว่าจะให้ซ่อนปุ่ม delete ไหม

            if ($(this._objDraw.node).attr('fieldType') === this._keyFieldType.comment
            || $(this._objDraw.node).attr('fieldType') === this._keyFieldType.checkbox) {
               this.isHideProperties = true;
            } else {
               this.isHideProperties = false;
            }
            if($(this._objDraw.node).attr('fieldType') === this._keyFieldType.image){
               this.isHidepageType = true;
            } else {
               this.isHidepageType = false;
            }
         }
      }
   }

   /** สร้าง comment list */
   drawCommentBox(item: any, objDraw: any, y: any) {
      let setDrawCommentY: number;
      try {
         if (item) {
            if (objDraw.attr('pageNum') === 1 ) {
               setDrawCommentY = y;

            } else {
               let $imageCurrentPage, imgHeightCurrentPage, $objectDrag;
               if (this._objDraw) {
                  $objectDrag = $(this._objDraw.node);
               } else if (this._objectDrag) {
                  $objectDrag = $(this._objectDrag);
               }
               if ($objectDrag) {
                  $imageCurrentPage = this.findParentImageBySignItem($objectDrag);
                  imgHeightCurrentPage = parseFloat($imageCurrentPage.attr('height'));
                  setDrawCommentY = (imgHeightCurrentPage + (this._margin * this.getCountZoom())) * (item.pageNum - 1) + y;
               } else {
                  setDrawCommentY = (this.itemRotates[this.currentIndex].itemRotate[item.pageNum].item.height + (this._margin * this.getCountZoom())) * (item.pageNum - 1) + y;
               }
            }
            this.commentboxComp.createComponent(item, objDraw.attr('id'), setDrawCommentY, false);
         }
      } catch (e) {
         console.error(e);
      }
   }

   /** update ตำแหน่ง comment list เมื่อมีการ active */
   updatePositionCommentBox(item: any, y: any) {
      let setDrawCommentY: number;
      try {
         if (item) {
            if (item.pageNum === 1) {
               setDrawCommentY = y;
            } else {
               let $imageCurrentPage, imgHeightCurrentPage, $objectDrag;
               if (this._objDraw) {
                  $objectDrag = $(this._objDraw.node);
               } else if (this._objectDrag) {
                  $objectDrag = $(this._objectDrag);
               }
               if ($objectDrag) {
                  $imageCurrentPage = this.findParentImageBySignItem($objectDrag);
                  imgHeightCurrentPage = parseFloat($imageCurrentPage.attr('height'));
                  setDrawCommentY = (imgHeightCurrentPage + (this._margin * this.getCountZoom())) * (item.pageNum - 1) + y;
               } else {
                  setDrawCommentY = (this.itemRotates[this.currentIndex].itemRotate[item.pageNum].item.height + (this._margin * this.getCountZoom())) * (item.pageNum - 1) + y;
               }
            }
            this.commentboxComp.setPosition(item.idSignItem, setDrawCommentY);
         }
      } catch (e) {
         console.error(e);
      }
   }

   /** วาดรูป object ในรูปแบบที่เป็น template */
   drawTypeNotSign(id) {
      let rect, text, image, ratio;
      const pageNum = id.split('_')[1];
      const ratioZoom = this.getCountZoom();
      const that = this;
      switch (this._fieldType) {
         case 'signature':
            this._objDraw = this._draw.group().addClass(this._keyFieldType.signature).attr({
               'positionType': this.positionType,
               'pageType': this.pageType,
            });
            this._objDraw.attr({
               'signer': this.signerSelected.signer.signerEmail, 'pageNum': pageNum,
               'fieldType': this._keyFieldType.signature,
               'stepOrder': this.signerSelected.signer.stepOrder,
               'taskContactId': this.signerSelected.signer.taskContactId
            });
            this._objDraw.attr({
               'chkName': this.includeName,
               'chkDate': this.includeDate
            });
            let width = 0;
            if (this.includeName || this.includeDate) {
               width = 50;
            }
            rect = this._draw.rect((this._widthInit + width) * ratioZoom,
               this._heightInit * ratioZoom).fill(this.colors[this.signerSelected.index]).attr({
               opacity: 0.5,
               'cursor': 'pointer'
            });
            this._objDraw.add(rect);
            image = this._draw.image(this.picSignature).loaded(function (loader) {
               ratio = loader.width / (widthInit + width);
               if (loader.height / ratio <= heightInit) {
                  this.size((widthInit + width) * ratioZoom, (loader.height / ratio) * ratioZoom);
               } else {
                  ratio = loader.height / heightInit;
                  this.size(((loader.width + width) / ratio) * ratioZoom, heightInit * ratioZoom);
               }
            }).attr({
               fill: 'none',
               stroke: this.colors[0],
               'stroke-width': 10,
               'cursor': 'pointer'
            });
            this._objDraw.add(image);

            this._addAllSignature.push(this._objDraw);
            this._objDraw.attr({width: (100 + width) * ratioZoom, height: 50 * ratioZoom});
            this.getProfile();
            break;
         case 'initSignature': //
            rect = this._draw.rect(this._widthInitialSign * ratioZoom,
               this._heightInitialSign * ratioZoom).fill(this.colors[this.signerSelected.index]).attr({
               opacity: 0.5,
               'cursor': 'pointer'
            });
            image = this._draw.image(this.picInitSignature).loaded(function (loader) {
               ratio = loader.width / (that._widthInitialSign );
               if (loader.height / ratio <= that._heightInitialSign) {
                  this.size(that._widthInitialSign * ratioZoom, (loader.height / ratio) * ratioZoom);

               } else {
                  ratio = loader.height / that._heightInitialSign;
                  this.size((loader.width / ratio) * ratioZoom, that._heightInitialSign * ratioZoom);
               }
            }).attr({
               fill: 'none',
               stroke: this.colors[0],
               'stroke-width': 10,
               'cursor': 'pointer'
            });
            this._objDraw = this._draw.group().addClass(this._keyFieldType.initSignature).attr({
               'positionType': this.positionType,
               'pageType': this.pageType,
               'chkName': this.chkName,
               'chkDate': this.chkDate,
            });
            this._objDraw.attr({
               'signer': this.signerSelected.signer.signerEmail, 'pageNum': pageNum,
               'fieldType': this._keyFieldType.initSignature,
               'stepOrder': this.signerSelected.signer.stepOrder,
               'taskContactId': this.signerSelected.signer.taskContactId
            });
            this._objDraw.add(rect);
            this._objDraw.add(image);
            this._addAllSignature.push(this._objDraw);
            this._objDraw.attr({width: 80 * ratioZoom, height: 40 * ratioZoom});
            break;
         case 'name':
            rect = this._draw.rect(this._widthInitName * ratioZoom,
               this._heightInitNameDate * ratioZoom).fill(this.colors[this.signerSelected.index]).attr({
               opacity: 0.5,
               'cursor': 'pointer'
            });
            text = this._draw.text(this._fullName).attr({
               x: 0,
               y: this._y * ratioZoom,
               'font-weight': 'bold',
               'cursor': 'pointer'
            }).font({size: this._fontSize * ratioZoom});
            this._objDraw = this._draw.group().addClass(this._keyFieldType.name).attr({
               'positionType': this.positionType,
               'pageType': this.pageType
            });
            this._objDraw.attr({
               'signer': this.signerSelected.signer.signerEmail,
               'pageNum': pageNum,
               'fieldType': this._keyFieldType.name,
               'stepOrder': this.signerSelected.signer.stepOrder,
               'taskContactId': this.signerSelected.signer.taskContactId
            });
            this._objDraw.add(rect);
            this._objDraw.add(text);
            this._addAllSignature.push(this._objDraw);
            break;
         case 'date':
            const day = moment().format('DD/MM/YYYY');
            rect = this._draw.rect(this._widthInitDate * ratioZoom,
               this._heightInitNameDate * ratioZoom).fill(this.colors[this.signerSelected.index]).attr({
               opacity: 0.5,
               'cursor': 'pointer'
            });
            text = this._draw.text(this._date).attr({
               x: 0,
               y: this._y * ratioZoom,
               'font-weight': 'bold',
               'cursor': 'pointer'
            }).font({size: this._fontSize * ratioZoom});
            this._objDraw = this._draw.group().addClass(this._keyFieldType.date).attr({
               'positionType': this.positionType,
               'pageType': this.pageType, 'fieldType': this._keyFieldType.date,
               'stepOrder': this.signerSelected.signer.stepOrder,
               'taskContactId': this.signerSelected.signer.taskContactId
            });
            this._objDraw.attr({'signer': this.signerSelected.signer.signerEmail, 'pageNum': pageNum});
            this._objDraw.add(rect);
            this._objDraw.add(text);
            this._addAllSignature.push(this._objDraw);
            break;
         case 'text':
            rect = this._draw.rect(this._widthInitTextarea * ratioZoom,
               this._heightInitTextarea * ratioZoom).fill(this.colors[this.signerSelected.index]).attr({
               opacity: 0.5,
               'cursor': 'pointer'
            });
            text = this._draw.text(this._text).attr({
               x: 0,
               y: this._y * ratioZoom ,
               'font-weight': 'bold',
               'cursor': 'pointer'
            }).font({size: this._fontSize * ratioZoom});
            this._objDraw = this._draw.group().addClass(this._keyFieldType.text).attr({
               'positionType': this.positionType,
               'pageType': this.pageType,
               'fieldType': this._keyFieldType.text,
               'fontStyle': 'THSarabunNew',
               'fontSize': this._fontSize,
               'fontColor': '#000000',
               'fontBold': false,
               'fontItalic': false,
               'fontUnderline': false,
               'textRequired': false,
               'stepOrder': this.signerSelected.signer.stepOrder,
               'taskContactId': this.signerSelected.signer.taskContactId
            });
            this._objDraw.attr({'signer': this.signerSelected.signer.signerEmail, 'pageNum': pageNum});
            this.generateTextControl(this._objDraw, this._text);

            this._objDraw.add(rect);
            this._objDraw.add(text);
            this._addAllSignature.push(this._objDraw);
            break;
         case 'comment':
            rect = this._draw.rect(this._widthInitIcon * ratioZoom,
               this._heightInitIcon * ratioZoom).fill(this.colors[0]).attr({
               opacity: 0,
               'cursor': 'pointer'
            });
            image = this._draw.image(this.picComment).loaded(function (loader) {
               ratio = loader.width / widthIconInit;
               if (loader.height / ratio <= heightIconInit) {
                  this.size(widthIconInit * ratioZoom, (loader.height / ratio) * ratioZoom);
               } else {
                  ratio = loader.height / heightIconInit;
                  this.size((loader.width / ratio) * ratioZoom, heightIconInit * ratioZoom);
               }
            }).attr({
               fill: 'none',
               stroke: this.colors[0],
               'stroke-width': 10,
               'cursor': 'pointer'
            });
            this._objDraw = this._draw.group().addClass(this._keyFieldType.comment).attr({
               'positionType': this.positionType,
               'pageType': this.pageType, 'fieldType': this._keyFieldType.comment,
               'stepOrder': 0,
               'taskContactId': 0
            });
            this._objDraw.attr({'signer': this.service.user.email, 'pageNum': pageNum});
            this._objDraw.add(rect);
            this._objDraw.add(image);
            this._addAllSignature.push(this._objDraw);
            break;
         case 'image':
            rect = this._draw.rect(this._widthInitAttach * ratioZoom,
               this._heightInitAttach * ratioZoom).fill(this.colors[this.signerSelected.index]).attr({
               opacity: 0.5,
               'cursor': 'pointer'
            });

            image = this._draw.image(this.picAttachImg).loaded(function (loader) {
               ratio = loader.width / widthAttachInit;
               if (loader.height / ratio <= heightAttachInit) {
                  this.size(widthAttachInit * ratioZoom, (loader.height / ratio) * ratioZoom);
               } else {
                  ratio = loader.height / heightAttachInit;
                  this.size((loader.width / ratio) * ratioZoom, heightAttachInit * ratioZoom);
               }
            }).attr({
               fill: 'none',
               stroke: this.colors[0],
               'stroke-width': 10,
               'cursor': 'pointer',
               'class': 'image'
            });
            this._objDraw = this._draw.group().addClass(this._keyFieldType.image).attr({
               'fieldType': this._keyFieldType.image,
               'positionType': this.positionType,
               'pageType': this.pageType,
               'stepOrder': this.signerSelected.signer.stepOrder,
               'taskContactId': this.signerSelected.signer.taskContactId
            });
            this._objDraw.attr({'signer': this.signerSelected.signer.signerEmail, 'pageNum': pageNum});
            this._objDraw.add(rect);
            this._objDraw.add(image);
            this._addAllSignature.push(this._objDraw);
            break;
         case 'checkbox':
            rect = this._draw.rect(this._heightInitCheckBox * ratioZoom,
               this._widthInitCheckBox * ratioZoom).fill(this.colors[this.signerSelected.index]).attr({
               opacity: 0.5,
               'cursor': 'pointer'
            });
            const moveX = (this._widthInitCheckBox / 2) - (this._widthInitBox / 2);
            const moveY = (this._heightInitCheckBox / 2) - (this._heightInitBox / 2);
            const checkbox = this._draw.rect(this._widthInitBox * ratioZoom,
               this._heightInitBox * ratioZoom).move(moveX * ratioZoom, moveY * ratioZoom)
               .fill('transparent').stroke({ color: '#000', width: 1 });
            const flag = this._draw.image(this.picCheckBox).loaded(function (loader) {
               ratio = loader.width / that._widthInitCheck;
               if (loader.height / ratio <= that._heightInitCheck) {
                  this.size(that._widthInitCheck * ratioZoom, (loader.height / ratio) * ratioZoom);
               } else {
                  ratio = loader.height / that._heightInitCheck;
                  this.size((loader.width / ratio) * ratioZoom, that._heightInitCheck * ratioZoom);
               }
            }).attr({
               x: ((this._widthInitCheckBox / 2) - (this._widthInitCheck / 2))  * ratioZoom,
               y: ((this._heightInitCheckBox / 2) - (this._heightInitCheck / 2))  *  ratioZoom,
               fill: 'none',
               stroke: this.colors[0],
               'stroke-width': 10,
               'cursor': 'pointer',
               'class': 'image'
            });
            this._objDraw = this._draw.group().addClass(this._keyFieldType.checkbox).attr({
               'positionType': this.positionType,
               'pageType': this.pageType,
               'fieldType': this._keyFieldType.checkbox,
               'flagCheckbox': false,
               'stepOrder': this.signerSelected.signer.stepOrder,
               'taskContactId': this.signerSelected.signer.taskContactId
            });
            this._objDraw.attr({'signer': this.signerSelected.signer.signerEmail, 'pageNum': pageNum});

            this.renderCheckBox(this._objDraw, checkbox, flag);

            this._objDraw.add(rect);
            this._objDraw.add(checkbox);
            this._objDraw.add(flag);
            this._addAllSignature.push(this._objDraw);
            break;
         default:
            break;
      }
      this.signatureDefaultValue.push(this._objDraw);
   }


   renderCheckBox(item, checkbox, flag, yMarginSign?) {
      const that = this;
      let pageNo, img, fieldType, pageType, positionType, idSignItem, y, newX, x, chkName, chkDate, certId,
         content, comment, idImageItem, fontStyle, fontSize, fontColor, fontBold, fontItalic, fontUnderline, textRequired, flagCheckbox, stepOrder, taskContactId;
      flagCheckbox = ($(item.node).attr('flagCheckbox')  === 'true');

      if (flagCheckbox) {
         $(flag.node).attr('style', 'visibility: visible');
      } else {
         $(flag.node).attr('style', 'visibility: hidden');
      }

      const fnClickCheckbox = (e) => {
         if (flagCheckbox) {
            $(flag.node).attr('style', 'visibility: visible');
         } else {
            $(flag.node).attr('style', 'visibility: hidden');
         }
         $(item.node).attr('flagCheckbox', flagCheckbox);
         pageNo = $(item.node).attr('pageNum');
         pageType = $(item.node).attr('pageType');
         positionType = $(item.node).attr('positionType');
         chkName = ($(item.node).attr('chkName') === 'true');
         chkDate = ($(item.node).attr('chkDate') === 'true');
         certId = parseInt($(item.node).attr('certId'), 10);
         idSignItem = $(item.node).attr('id');
         stepOrder = $(item.node).attr('stepOrder');
         taskContactId = $(item.node).attr('taskContactId');
         if (yMarginSign) {
            y = item.y() + yMarginSign;
         } else {
            y = item.y();
         }
         newX = item.attr('newX');
         x = item.x();
         that._signer = $(item.node).attr('signer');
         fieldType = $(item.node).attr('class');
         content = '';
         if (fieldType === 'text') {
            content = item.node.textContent;
            fontStyle = $(item.node).attr('fontStyle');
            fontSize = Number($(item.node).attr('fontSize'));
            fontColor = $(item.node).attr('fontColor');
            fontBold = ($(item.node).attr('fontBold') === 'true');
            fontItalic = ($(item.node).attr('fontItalic') === 'true');
            fontUnderline = ($(item.node).attr('fontUnderline') === 'true');
            textRequired = ($(item.node).attr('textRequired') === 'true');
         } else if (fieldType === 'comment'){
            comment =  $(item.node).attr('comment') ? JSON.parse($(item.node).attr('comment')) : null;
         } else if (fieldType === 'image'){
            idImageItem = $(item.node).attr('ref');
         }
         that.setSignItem(that._signer
            , fieldType
            , pageType
            , pageNo
            , positionType
            , chkName
            , chkDate
            , certId
            , x
            , y
            , item.children()[1].width()
            , item.children()[1].height()
            , idSignItem
            , item.attr('order')
            , content
            , false
            , comment
            , idImageItem
            , fontStyle
            , fontSize
            , fontColor
            , fontBold
            , fontItalic
            , fontUnderline
            , textRequired
            , flagCheckbox
            , stepOrder
            , taskContactId
         );
         if (that.taskAttribute.docList[that.currentIndex].signItems) {
            for (let i = 0; i < that.taskAttribute.docList[that.currentIndex].signItems.length; i++) {
               if (that.taskAttribute.docList[that.currentIndex].signItems[i].idSignItem === idSignItem) {
                  that.taskAttribute.docList[that.currentIndex].signItems[i] = that._signItem;
                  break;
               }
            }
         }
         e.preventDefault();
      };

      checkbox.node.addEventListener('click', function (e) {
         fnClickCheckbox(e);
      });

      flag.node.addEventListener('click', function (e) {
         fnClickCheckbox(e);
      });


   }

   /** วาดรูปค่าตั้งต้นเป็น template ให้กด sign */
   initialTypeNotSign(item, ratioZoom) {
      const that = this;
      const setCoordinateX = item.coordinateX * this.getCountZoom();
      const setCoordinateY = item.coordinateY * this.getCountZoom();
      let rect, text, indexColor, ratio, image;
      if (item.fieldType !== this._keyFieldType.comment) {
         indexColor = this.setIndexColorDocList(item);
      }
      switch (item.fieldType) {
         case 'signature':
            let width_ext = 0;
            if (item.chkName || item.chkDate) {
               width_ext = 50;
            }
            rect = this._draw.rect(item.fieldWidth * this.getCountZoom(), item.fieldHeight * this.getCountZoom()).fill(this.colors[indexColor]).attr({
               opacity: 0.5,
               'cursor': 'pointer'
            }); // TODO change color initial
            this._objDraw = this._draw.group().addClass(this._keyFieldType.signature);
            this._objDraw.attr({
               'signer': item.signer,
               'positionType': item.positionType,
               'pageType': item.pageType,
               'chkName': item.chkName,
               'chkDate': item.chkDate,
               x: setCoordinateX,
               y: setCoordinateY,
               'pageNum': item.pageNum,
               'fieldType': this._keyFieldType.signature,
               'stepOrder': item.stepOrder,
               'taskContactId': item.taskContactId
            });
            this._objDraw.add(rect);
            image = this._draw.image(this.picSignature, item.fieldWidth * this.getCountZoom(), item.fieldHeight * this.getCountZoom()).attr({
               fill: 'none',
               stroke: this.colors[0],
               'stroke-width': 10,
               'cursor': 'pointer'
            });
            this._objDraw.add(image);
            this._objDraw.x(setCoordinateX);
            this._objDraw.y(setCoordinateY);
            break;
         case 'initSignature':
            rect = this._draw.rect(item.fieldWidth * ratioZoom, item.fieldHeight * ratioZoom).fill(this.colors[indexColor]).attr({
               opacity: 0.5,
               'cursor': 'pointer'
            });
            image = this._draw.image(this.picInitSignature, item.fieldWidth * this.getCountZoom(), item.fieldHeight * this.getCountZoom()).attr({
               fill: 'none',
               stroke: this.colors[0],
               'stroke-width': 10,
               'cursor': 'pointer'
            });
            this._objDraw = this._draw.group().addClass(this._keyFieldType.initSignature);
            this._objDraw.attr({
               'signer': item.signer,
               'positionType': item.positionType,
               'pageType': item.pageType,
               'chkName': item.chkName,
               'chkDate': item.chkDate,
               x: setCoordinateX,
               y: setCoordinateY,
               'pageNum': item.pageNum,
               'fieldType': this._keyFieldType.initSignature,
               'stepOrder': item.stepOrder,
               'taskContactId': item.taskContactId
            });
            this._objDraw.add(rect);
            this._objDraw.add(image);
            this._objDraw.x(setCoordinateX);
            this._objDraw.y(setCoordinateY);
            break;
         case 'name':
            rect = this._draw.rect(this._widthInitName * ratioZoom,
               this._heightInitNameDate * ratioZoom).fill(this.colors[indexColor]).attr({
               opacity: 0.5,
               'cursor': 'pointer'
            });
            text = this._draw.text(this._fullName).attr({
               x: 0,
               y: this._y * ratioZoom,
               'font-weight': 'bold',
               'cursor': 'pointer'
            }).font({size: this._fontSize * ratioZoom});
            this._objDraw = this._draw.group().addClass(this._keyFieldType.name);
            this._objDraw.attr({
               'signer': item.signer,
               'positionType': item.positionType,
               'pageType': item.pageType,
               'pageNum': item.pageNum,
               'fieldType': this._keyFieldType.name,
               'stepOrder': item.stepOrder,
               'taskContactId': item.taskContactId
            });
            this._objDraw.add(rect);
            this._objDraw.add(text);
            this._objDraw.x(setCoordinateX);
            this._objDraw.y(setCoordinateY);
            break;
         case 'date':
            const day = moment().format('DD/MM/YYYY');
            rect = this._draw.rect(this._widthInitDate * ratioZoom,
               this._heightInitNameDate * ratioZoom).fill(this.colors[indexColor]).attr({
               opacity: 0.5,
               'cursor': 'pointer'
            });
            text = this._draw.text(this._date).attr({
               x: 0,
               y: this._y * ratioZoom,
               'font-weight': 'bold',
               'cursor': 'pointer'
            }).font({size: this._fontSize * ratioZoom});
            this._objDraw = this._draw.group().addClass(this._keyFieldType.date);
            this._objDraw.attr({
               'signer': item.signer,
               'positionType': item.positionType,
               'pageType': item.pageType,
               'pageNum': item.pageNum,
               'fieldType': this._keyFieldType.date,
               'stepOrder': item.stepOrder,
               'taskContactId': item.taskContactId
            });
            this._objDraw.add(rect);
            this._objDraw.add(text);
            this._objDraw.x(setCoordinateX);
            this._objDraw.y(setCoordinateY);
            break;
         case 'text':
            let txtValue = '';
            if (item.content) {
               txtValue = item.content;
            } else {
               txtValue = this._text;
            }
            let width = this.calculateLenStrSign(txtValue);
            if (width < this._widthInitTextarea * ratioZoom) {
               width = this._widthInitTextarea * ratioZoom;
            }
            rect = this._draw.rect(this._widthInitTextarea * ratioZoom,
               this._heightInitTextarea * ratioZoom).fill(this.colors[indexColor]).attr({
               opacity: 0.5,
               'cursor': 'pointer',
               'width': width
            });
            text = this._draw.text(txtValue).attr({
               x: 0,
               y: this._y * ratioZoom ,
               // 'font-weight': 'bold',
               'cursor': 'pointer'
            }).font({size: Number(item.fontSize) * ratioZoom});
            this._objDraw = this._draw.group().addClass(this._keyFieldType.text);
            this._objDraw.attr({
               'signer': item.signer,
               'positionType': item.positionType,
               'pageType': item.pageType,
               'pageNum': item.pageNum,
               'fieldType': this._keyFieldType.text,
               'fontStyle': item.fontStyle,
               'fontSize': Number(item.fontSize),
               'fontColor': item.fontColor,
               'fontBold': item.fontBold,
               'fontItalic': item.fontItalic,
               'fontUnderline': item.fontUnderline,
               'textRequired': item.textRequired,
               'stepOrder': item.stepOrder,
               'taskContactId': item.taskContactId
            });
            this.generateTextControl(this._objDraw, this._text);

            this._objDraw.add(rect);
            this._objDraw.add(text);
            this._objDraw.x(setCoordinateX);
            this._objDraw.y(setCoordinateY);
            let widthText = text.node.getBoundingClientRect().width;
            if (widthText < this._widthInitTextarea * ratioZoom) {
               widthText = this._widthInitTextarea * ratioZoom;
            }
            break;
         case 'comment' :
            rect = this._draw.rect(this._widthInitIcon * ratioZoom,
               this._heightInitIcon * ratioZoom).fill(this.colors[indexColor]).attr({
               opacity: 0,
               'cursor': 'pointer'
            });
            image = this._draw.image(this.picComment).loaded(function (loader) {
               ratio = loader.width / widthIconInit;
               if (loader.height / ratio <= heightIconInit) {
                  this.size(widthIconInit * ratioZoom, (loader.height / ratio) * ratioZoom);
               } else {
                  ratio = loader.height / heightIconInit;
                  this.size((loader.width / ratio) * ratioZoom, heightIconInit * ratioZoom);
               }
            }).attr({
               fill: 'none',
               stroke: this.colors[0],
               'stroke-width': 10,
               'cursor': 'pointer',
            });

            this._objDraw = this._draw.group().addClass(this._keyFieldType.comment);
            this._objDraw.attr({
               'signer': item.signer,
               'positionType': item.positionType,
               'pageType': item.pageType,
               'pageNum': item.pageNum,
               'fieldType': item.fieldType,
               'comment': JSON.stringify(item.comment),
               'stepOrder': item.stepOrder,
               'taskContactId': item.taskContactId
            });
            this._objDraw.add(rect);
            this._objDraw.add(image);
            this._objDraw.x(setCoordinateX);
            this._objDraw.y(setCoordinateY);
            this.drawCommentBox(item, this._objDraw, setCoordinateY);
            break;
         case 'image' :
            if(item.idImageItem && item.idImageItem !== this.picAttachImg){
               this._objDraw = this._draw.image(this.getImageContent(item.idImageItem), item.fieldWidth * this.getCountZoom(), item.fieldHeight * this.getCountZoom())
                  .addClass(this._keyFieldType.image).attr({
                     'signer': item.signer,
                     'positionType': item.positionType,
                     'pageType': item.pageType,
                     'cursor': 'pointer',
                     'pageNum': item.pageNum,
                     'width': item.fieldWidth * this.getCountZoom(),
                     'height': item.fieldHeight * this.getCountZoom(),
                     'fieldType': this._keyFieldType.image,
                     'class': 'image',
                     'ref': item.idImageItem,
                     'stepOrder': item.stepOrder,
                     'taskContactId': item.taskContactId
                  });
               this._objDraw.x(item.coordinateX * this.getCountZoom());
               this._objDraw.y(item.coordinateY * this.getCountZoom());
               break;
            } else {
               let newX = item.coordinateX * this.getCountZoom();
               let newY = item.coordinateY * this.getCountZoom();
               let rect = this._draw.rect(this._widthInitAttach * this.getCountZoom(),
                  this._heightInitAttach * this.getCountZoom()).fill(this.colors[indexColor]).attr({
                  opacity: 0.5,
                  'cursor': 'pointer'
               });
               let image = this._draw.image(this.picAttachImg, widthAttachInit * this.getCountZoom(), heightAttachInit * this.getCountZoom())
                  .attr({
                     fill: 'none',
                     stroke: this.colors[0],
                     'stroke-width': 10,
                     'cursor': 'pointer'
                  });

               this._objDraw = this._draw.group().addClass(this._keyFieldType.image);
               this._objDraw.attr({
                  'signer': item.signer.toLowerCase(),
                  'positionType': item.positionType,
                  'pageType': item.pageType,
                  'pageNum': item.pageNum,
                  'fieldType': this._keyFieldType.image,
                  'class': 'image',
                  x: newX,
                  y: newY,
                  'stepOrder': item.stepOrder,
                  'taskContactId': item.taskContactId
               });
               this._objDraw.x(item.coordinateX * this.getCountZoom());
               this._objDraw.y(item.coordinateY * this.getCountZoom());
               this._objDraw.add(rect);
               this._objDraw.add(image);
               break;
            }
         case 'checkbox':
            rect = this._draw.rect(this._heightInitCheckBox * ratioZoom,
               this._widthInitCheckBox * ratioZoom).fill(this.colors[indexColor]).attr({
               opacity: 0.5,
               'cursor': 'pointer'
            });
            const x = (this._widthInitCheckBox / 2) - (this._widthInitBox / 2);
            const y = (this._heightInitCheckBox / 2) - (this._heightInitBox / 2);
            const checkbox = this._draw.rect(this._widthInitBox * ratioZoom,
               this._heightInitBox * ratioZoom).move(x * ratioZoom, y * ratioZoom)
               .fill('transparent').stroke({ color: '#000', width: 1 });
            const flag = this._draw.image(this.picCheckBox).loaded(function (loader) {
               ratio = loader.width / that._widthInitCheck;
               if (loader.height / ratio <= that._heightInitCheck) {
                  this.size(that._widthInitCheck * ratioZoom, (loader.height / ratio) * ratioZoom);
               } else {
                  ratio = loader.height / that._heightInitCheck;
                  this.size((loader.width / ratio) * ratioZoom, that._heightInitCheck * ratioZoom);
               }
            }).attr({
               x: ((this._widthInitCheckBox / 2) - (this._widthInitCheck / 2))  * ratioZoom,
               y: ((this._heightInitCheckBox / 2) - (this._heightInitCheck / 2))  *  ratioZoom,
               fill: 'none',
               stroke: this.colors[0],
               'stroke-width': 10,
               'cursor': 'pointer',
               'class': 'image'
            });

            this._objDraw = this._draw.group().addClass(this._keyFieldType.checkbox);
            this._objDraw.attr({
               'signer': item.signer,
               'positionType': item.positionType,
               'pageType': item.pageType,
               'pageNum': item.pageNum,
               'fieldType': item.fieldType,
               'flagCheckbox': item.flagCheckbox,
               'stepOrder': item.stepOrder,
               'taskContactId': item.taskContactId
            });

            this.renderCheckBox(this._objDraw, checkbox, flag);

            this._objDraw.add(rect);
            this._objDraw.add(checkbox);
            this._objDraw.add(flag);
            this._objDraw.x(setCoordinateX);
            this._objDraw.y(setCoordinateY);
            break;
         default:
            break;
      }
      this.signatureDefaultValue.push(this._objDraw);
   }

   getImageContent(id){
      if(id !== this.picAttachImg){
         return this.service.url + '/share-public/content?id=' + id;
      } else {
         return this.picAttachImg;
      }
   }

   calculateLenStrSign(str) {
      const widthChar = 5;
      let len = 0;
      for (let i = 0; i < str.length; i++) {
         if ((str[i] === 'ำ' || str[i] === 'ณ' || str[i] === 'ฏ' || str[i] === 'ฐ')) {
            len += 5.3;
         } else if ((str[i] >= 'a' && str[i] <= 'z') || (str[i] >= 'A' && str[i] <= 'Z') || (str[i] >= '0' && str[i] <= '9')
            || (str[i] === '/') || (str[i] >= 'ก' && str[i] <= 'ฮ') || (str[i] >= 'เ' && str[i] <= 'ๆ') || (str[i] === 'ะ')
            || (str[i] === ' ') || str[i] >= 'า' && str[i] <= 'ำ') {
            len += widthChar;
         }
      }
      return len;
   }

   /** คำนวณว่ารูปที่วางลงนั้นหลุดออกนอกหรอบหรือไม่ */
   calculateOutBoundItem(e) {
      const target = $(e.target);
      const fieldType = target.attr('fieldType');
      let itemWidth, itemHeight;
      itemWidth = parseFloat($(target.find('rect')[0]).attr('width'));
      itemHeight = parseFloat($(target.find('rect')[0]).attr('height'));
      const transforms = this.getValueTransform(target.attr('transform'));
      let xItem = parseFloat(transforms[4]), yItem = parseFloat(transforms[5]);
      // ใช้ pageNum attribute จาก target เพื่อหา page group โดยตรง แทนการ traverse DOM ที่ขึ้นกับโครงสร้าง SVG.js
      const pageNum = target.attr('pageNum');
      const $pageImg = $('#img_' + pageNum + ' > image').first();
      const imgWidth = parseFloat($pageImg.attr('width'));
      const imgHeight = parseFloat($pageImg.attr('height'));
      const transform = Math.abs(this.getValueTransform($pageImg.attr('transform'))[0]);
      let widthReal = 0, heightReal = 0;
      switch (transform) {
         case 0:
            widthReal = imgWidth;
            heightReal = imgHeight;
            break;
         case 90:
            widthReal = imgHeight;
            heightReal = imgWidth;
            break;
         case 180:
            widthReal = imgWidth;
            heightReal = imgHeight;
            break;
         case 270:
            widthReal = imgHeight;
            heightReal = imgWidth;
            break;
         default:
            widthReal = imgWidth;
            heightReal = imgHeight;
            break;
      }
      const calShiftXitem = widthReal - itemWidth; // เมื่อลากลายเซ็นต์นอกขอบขวาของกระดาษต้องขยับความกว้างของลายเซ็นต์ออกมาจากขอบกระดาษ
      const calShiftYitem = heightReal - itemHeight;
      const calXitem = xItem + itemWidth;
      const calYitem = yItem + itemHeight;
      if (xItem < 0) {
         if (yItem < 0) {
            yItem = 0;
         } else if (yItem + itemHeight > heightReal) {
            yItem = calShiftYitem;
         }
         this.setPositionCurrentSignItem($(e.target), 0, yItem);
      } else if (calXitem > widthReal) {
         if (yItem < 0) {
            yItem = 0;
         } else if (yItem + itemHeight > heightReal) {
            yItem = calShiftYitem;
         }
         this.setPositionCurrentSignItem($(e.target), calShiftXitem, yItem);
      } else if (yItem < 0) {
         if (xItem < 0) {
            xItem = 0;
         } else if (xItem + itemWidth > widthReal) {
            xItem = calShiftXitem;
         }
         this.setPositionCurrentSignItem($(e.target), xItem, 0);
      } else if (calYitem > heightReal) {
         if (xItem < 0) {
            xItem = 0;
         } else if (xItem + itemWidth > widthReal) {
            xItem = calShiftXitem;
         }
         this.setPositionCurrentSignItem($(e.target), xItem, calShiftYitem);
      }
   }

   calculateOutBoundItemImage(e) {
      const target = $(e.target);
      const fieldType = target.attr('fieldType');
      let itemWidth, itemHeight
      itemWidth = target.attr('width') ? parseFloat(target.attr('width')) : 0;
      itemHeight = target.attr('height') ? parseFloat(target.attr('height')) : 0;
      const xItem = parseFloat(target.attr('x')), yItem = parseFloat(target.attr('y'));
      const imgWidth = this._imgFocusCal.width ? this._imgFocusCal.width.baseVal.value : 0;
      const imgHeight = this._imgFocusCal.height ? this._imgFocusCal.height.baseVal.value : 0;
      let calShiftXitem;
      let calShiftYitem;
      let calXitem;
      let calYitem;
      if (fieldType === this._keyFieldType.image) {
         // เมื่อลากลายเซ็นต์นอกขอบขวาของกระดาษต้องขยับความกว้างของลายเซ็นต์ออกมาจากขอบกระดาษ
         if ((fieldType === this._keyFieldType.text) || (fieldType === this._keyFieldType.image)) {
            calShiftXitem = imgWidth - itemWidth;
            calShiftYitem = imgHeight - itemHeight;
            calXitem = xItem + itemWidth;
            calYitem = yItem + itemHeight;
         } else {
            calShiftXitem = imgWidth - (itemWidth * this.getCountZoom());
            calShiftYitem = imgHeight - (itemHeight * this.getCountZoom());
            calXitem = xItem + (itemWidth * this.getCountZoom());
            calYitem = yItem + (itemHeight * this.getCountZoom());
         }
         if (xItem < 0) {
            $(e.target).attr('x', 0);
            $($(e.target).children()[0]).attr('x', 0);
         } else if (calXitem > imgWidth) {
            $(e.target).attr('x', calShiftXitem);
            $($(e.target).children()[0]).attr('x', calShiftXitem);
         }

         if (yItem < 0) {
            $(e.target).attr('y', 0);
         } else if (calYitem > imgHeight) {
            $(e.target).attr('y', calShiftYitem);
         }
      }
   }
   setIndexColorDocList(item) {
      let indexColor = 0;
      if (this.leftPanelComp.toolsComp) {
         indexColor = this.leftPanelComp.toolsComp.signers.findIndex((data) => parseInt(data.taskContactId, 10) === parseInt(item.taskContactId, 10));
         // กรณีหาค่า contactId ไม่เจอ หรือ ค่าไม่ตรงกันเลย จะให้ไปหาด้วย email แทน
         if (indexColor === -1) {
            indexColor = this.leftPanelComp.toolsComp.signers.findIndex((data) => data.signerEmail === item.signer);
            this.signerSelected = indexColor
            if (indexColor === -1) {
               indexColor = 5;
               this.signerSelected.index = 5;
            }
         }
      } else if (this.taskAttribute.apvLevel) {
         const getSigners = [];
         for (const signers of this.taskAttribute.apvLevel) {
            for (const signer of signers.signerList) {
               if (signer.action === 'Need to Sign') {
                  getSigners.push(signer);
               }
            }
         }
         indexColor = getSigners.findIndex((data) => parseInt(data.taskContactId, 10) === parseInt(item.taskContactId, 10));
         if (indexColor === -1) {
            // กรณีหาค่า contactId ไม่เจอ หรือ ค่าไม่ตรงกันเลย จะให้ไปหาด้วย email แทน
            indexColor = getSigners.findIndex((data) => data.signerEmail === item.signer);
            this.signerSelected.index = indexColor;
            if (this.signerSelected) {
               if (indexColor === -1) {
                  indexColor = 5;
                  this.signerSelected.index = 5;
               }
            }
         }
      }
      return indexColor;
   }

   setVisibleTextProperties(e) {
      const fieldType = $(e.target).attr('fieldType');
      if (fieldType === this._keyFieldType.comment
      || fieldType === this._keyFieldType.checkbox) {
         this.isHideProperties = true;
      } else {
         this.isHideProperties = false;
      }
      if(fieldType === this._keyFieldType.image){
         this.isHidepageType = true;
      } else {
         this.isHidepageType = false;
      }
   }

   /** หา id ที่รูปที่เลือกอยู่ focus ไว้ */
   checkImgFocus($event) {
      this._imgFocus = $event;
      let id, imgTarget;
      if (this._imgFocus.target.parentNode.className !== 'imageSign') {
         imgTarget = this.findImageParent(this._imgFocus.target);
         id = imgTarget.parentNode.id;
         this._imgFocusCal = imgTarget;
      } else {
         id = this._imgFocus.target.parentNode.id;
         this._imgFocusCal = this._imgFocus.target;
      }
      return id;
   }

   /** เคลื่อนที่ของรูป object */
   moveSVG($event) {
      if (this.isDrawing) {
         if (this.isDrawing) {
            this._moveOnPage = true;
            this.calculateMove($event);
         }
      }
      if (this._onDrag) {
         const $objectDrag = $(this._objectDrag);
         const id = $objectDrag.attr('id');
         $objectDrag.attr('positionType', 'CT');
         if (this.taskAttribute.docList[this.currentIndex].signItems) {
            for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
               if (item.idSignItem === id) {
                  this.setInitialPositionType();
                  break;
               }
            }
         }
      }
   }

   /** คำนวณเคลื่อนที่ของรูป object มีการตรวจสอบว่าชิดขอบหรือไม่ชิดขอบ */
   calculateMove($event) {
      const id = this._imgFocusCal.parentNode.id;
      const h = this.calculatePageHeightMargin(id);
      const $object = $('#' + id);
      const $objectImg = $($object.children()[0]);
      const imgWidth = parseFloat($objectImg.attr('width'));
      const imgHeight = parseFloat($objectImg.attr('height'));
      const transform = Math.abs(this.getValueTransform($objectImg.attr('transform'))[0]);
      let widthReal = 0, heightReal = 0;
      switch (transform) {
         case 0:
            widthReal = imgWidth;
            heightReal = imgHeight;
            break;
         case 90:
            widthReal = imgHeight;
            heightReal = imgWidth;
            break;
         case 180:
            widthReal = imgWidth;
            heightReal = imgHeight;
            break;
         case 270:
            widthReal = imgHeight;
            heightReal = imgWidth;
            break;
         default:
            widthReal = imgWidth;
            heightReal = imgHeight;
            break;
      }
      const calDiffMaxWidth = (this.maxWidth - widthReal) / 2;
      const realX = $event.layerX - calDiffMaxWidth;
      const type = $(this._objDraw.node).attr('class');
      let width = $(this._objDraw.node).attr('width');
      let height = $(this._objDraw.node).attr('height');
      let difX, difY, inBoundX, inBoundY;
      const borderWidth = 10 * this.getCountZoom();
      const borderHeight = 5 * this.getCountZoom();
      if (type === 'signature' || type === 'initSignature') {
         difX = (width / 2);
         difY = (height / 2);
         inBoundX = (width / 2);
         inBoundY = (height / 2);
         if ($event.layerY + inBoundY < heightReal + h && realX +
            inBoundX < widthReal && realX - inBoundX > 0 && $event.layerY - inBoundY > h) {
            this._objDraw.center(realX - borderWidth, $event.layerY - h - borderHeight);
         } else {
            if ($event.layerY + difY >= heightReal + h) { // bottom
               if (realX - difX > 0) {
                  if (realX + difX <= widthReal) { // bottom
                     this._objDraw.center(realX, heightReal - difY);
                  } else { // bottom right corner
                     this._objDraw.center(widthReal - difX, heightReal - difY);
                  }
               } else { // bottm left corner
                  this._objDraw.center(difX, heightReal - difY);
               }
            } else if (realX + difX >= widthReal) { // right
               if ($event.layerY - difY > h) {
                  if ($event.layerY + difY <= heightReal + h) { // right
                     this._objDraw.center(widthReal - difX, $event.layerY - h);
                  } else {
                     this._objDraw.center(widthReal - difX, difY);
                  }
               } else { // top right corner
                  this._objDraw.center(widthReal - difX, difY);
               }
            } else if (realX - difX <= 0) { // left
               if ($event.layerY - difY > h) {  // left
                  this._objDraw.center(difX, $event.layerY - h);
               } else { // top left corner
                  this._objDraw.center(difX, difY);
               }
            } else if ($event.layerY - difY <= h) { // top
               this._objDraw.center(realX, difY);
            }
         }
      } else if (type === 'image') {
         let width = $($(this._objDraw.node).children()[0]).attr('width');
         let height = $($(this._objDraw.node).children()[0]).attr('height');
         difX = width / 2 * this.getCountZoom();
         difY = height / 2 * this.getCountZoom();
         inBoundX = width / 2 * this.getCountZoom();
         inBoundY = height / 2 * this.getCountZoom();
         if ($event.layerY + inBoundY < this._imgFocusCal.height.baseVal.value  + h && realX +
            inBoundX < this._imgFocusCal.width.baseVal.value && realX - inBoundX > 0 && $event.layerY - inBoundY > h) {
            this._objDraw.center(realX, $event.layerY - h);
         } else {
            if ($event.layerY + difY >= this._imgFocusCal.height.baseVal.value + h) { // bottom
               if (realX - difX > 0) {
                  if (realX + difX <= this._imgFocusCal.width.baseVal.value) {
                     this._objDraw.center(realX, this._imgFocusCal.height.baseVal.value - difY);
                  } else {
                     this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, this._imgFocusCal.height.baseVal.value - difY);
                  }
               } else {
                  this._objDraw.center(difX, this._imgFocusCal.height.baseVal.value - difY);
               }
            } else if (realX + difX >= this._imgFocusCal.width.baseVal.value) { // right
               if ($event.layerY - difY > h) {
                  if ($event.layerY + difY <= this._imgFocusCal.height.baseVal.value + h) {
                     this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, $event.layerY - h);
                  } else {
                     this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, difY);
                  }
               } else {
                  this._objDraw.center(this._imgFocusCal.width.baseVal.value - difX, difY);
               }
            } else if (realX - difX <= 0) { // left
               if ($event.layerY - difY > h) {
                  this._objDraw.center(difX, $event.layerY - h);
               } else {
                  this._objDraw.center(difX, difY);
               }
            } else if ($event.layerY - difY <= h) {
               this._objDraw.center(realX, difY);
            }
         }
      } else {
         width = $($(this._objDraw.node).children()[0]).attr('width');
         height = $($(this._objDraw.node).children()[0]).attr('height');
         difX = width / 2;
         difY = 10 * this.getCountZoom();
         inBoundX = width / 2;
         inBoundY = 10 * this.getCountZoom();
         if ($event.layerY + inBoundY < heightReal + h && realX +
            inBoundX < widthReal && realX - inBoundX > 0 && $event.layerY - inBoundY > h) {
            this._objDraw.center(realX, $event.layerY - h);
         } else {
            if ($event.layerY + difY >= heightReal + h) { // bottom
               if (realX - difX > 0) {
                  if (realX + difX <= widthReal) {
                     this._objDraw.center(realX, heightReal - difY + 5 * this.getCountZoom());
                  } else {
                     this._objDraw.center(widthReal - difX, heightReal - difY + 5 * this.getCountZoom());
                  }
               } else {
                  this._objDraw.center(difX, heightReal - difY + 5 * this.getCountZoom());
               }
            } else if (realX + difX >= widthReal) { // right
               if ($event.layerY - difY > h) {
                  if ($event.layerY + difY <= heightReal + h) {
                     this._objDraw.center(widthReal - difX, $event.layerY - h);
                  } else {
                     this._objDraw.center(widthReal - difX, difY);
                  }
               } else {
                  this._objDraw.center(widthReal - difX, difY);
               }
            } else if (realX - difX <= 0) { // left
               if ($event.layerY - difY > h) {
                  this._objDraw.center(difX, $event.layerY - h);
               } else {
                  this._objDraw.center(difX, difY);
               }
            } else if ($event.layerY - difY <= h) {
               this._objDraw.center(realX, difY);
            }
         }
      }
   }

   /** เมื่อวาด object เสร็จแล้วจะทำการตั้งค่าเริ่มต้นต่างๆให้กับ object นั้น */
   finishSVG($event) {
      if (this.startDrawing) {
         this._moveOnPage = false;
         this.isDrawing = false;
         if (this._objDraw) {
            this._objDraw.selectize({
               points: ['lt', 'rt', 'rb', 'lb'],
               rotationPoint: false
            }).resize({saveAspectRatio: true});
         }
         this.startDrawing = false;
      }
      if (!this._isDeselect) {
         if (this.leftPanelComp.toolsComp) {
            this.leftPanelComp.toolsComp.isExpanded = true;
         }
         if (this._isHideProp) {
            this.setVisibleProperty(false);
         } else {
            this.setVisibleProperty(true);
         }
      }
      this._isDeselect = false;
   }

   /** ตั้งค่าเริ่มต้นต่างๆเมื่อวาง object ที่ drag ลง กรณีที่ปล่อยเมาส์ข้างนอกเอกสาร */
   outzoneSVG($event) {
      if (this._objDraw) {
         if (this.leftPanelComp.toolsComp) {
            this.leftPanelComp.toolsComp.isExpanded = true;
         }
         if (this._isHideProp) {
            this.setVisibleProperty(false);
         } else {
            this.setVisibleProperty(true);
         }
      }
   }

   /** ตั้งค่าเมื่อมีการยกเลิกการ select object นั้น */
   setDeselectItem($event) {
      this._isDeselect = true;
      if (this.leftPanelComp.toolsComp) {
         this.leftPanelComp.toolsComp.isExpanded = true;
      }
      this.leftPanelComp.visiblityState = false;
      if (!this.isDrawing) {
         this.deselectAll();
         if (!this.isDrawing) {
            this._objDraw = '';
         }
         this._objectDrag = '';
      }
   }

   /** ยกเลิกการ select ของทุก object */
   deselectAll() {
      this.commentboxComp.setDeselectComment(false);
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            for (const item of object.svg.children()) {
               if ((item.type === 'text' || item.type === 'image' || item.type === 'g')) {
                  if (item.attr('signer')) {
                     item.selectize(false);
                     if (item.type === 'g' && item.children) {
                        for (const child of item.children()) {
                           if (child.type === 'text' || child.type === 'image') {
                              child.selectize(false);
                           }
                        }
                     }
                     if ((item.attr('fieldType') === this._keyFieldType.comment) && !item.attr('comment')) {
                        this._onDeleteComment = true;
                        this.onClickDelete({ fieldType: item.attr('fieldType')}, true);
                     }
                  }
               }
            }
         }
      }
   }

   /** ยกเลิกการ select ของทุก object ยกเว้น id ที่รับเข้ามา */
   deselectAllWithOutMatchId(id) {
      this.commentboxComp.setDeselectComment(false);
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            for (const item of object.svg.children()) {
               if ((item.type === 'text' || item.type === 'image' || item.type === 'g')) {
                  if (item.attr('signer') && item.attr('id') !== id) {
                     item.selectize(false);
                     if (item.type === 'g' && item.children) {
                        for (const child of item.children()) {
                           if (child.type === 'text' || child.type === 'image') {
                              child.selectize(false);
                           }
                        }
                     }
                     if ((item.attr('fieldType') === this._keyFieldType.comment) && !item.attr('comment')) {
                        this.onDeleteComment(item.attr('id'));
                        item.remove();
                     }
                  }
               }
            }
         }
      }
   }

   /** ตั้งค่าต่างๆเมื่อคลิกเมนูเพื่อทำการวาด object */
   handleMenuClick() {
      const signMenuClick = this.signMenuClick
         .subscribe((data) => {
            this._flagMouseOver = false;
            this._fieldType = data;
            this.startDrawing = true;
            this.isDrawing = false;
            this.fieldType = data;
            this._objDraw = '';
            this._objectDrag = '';
            if (this.commentboxComp) {
               this.commentboxComp.setDeselectComment(false);
            }
            if (this._draw) {
               for (const item of this._draw.children()) {
                  if (item.type === 'image' || item.type === 'text' || item.type === 'g') {
                     if (item._event) {
                        item.selectize(false);
                        if (item.children){
                           if (item.children()[1]) {
                              item.children()[1].selectize(false);
                           }
                        }
                        if ((item.attr('fieldType') === 'comment') && !item.attr('comment')) {
                           this.onDeleteComment(item.attr('id'));
                           item.remove();
                        }
                     }
                  }
               }
            }
         });
   }

   /** ตั้งค่าต่างๆเมื่อลากที่เมนูเพื่อทำการวาด object */
   handleMenuDrag() {
      const signMenuDrag = this.signMenuDrag
         .subscribe((data) => {
            this._fieldType = data;
            this._objDraw = '';
            this._objectDrag = '';
            if (this.commentboxComp) {
               this.commentboxComp.setDeselectComment(false);
            }
            if (this._draw) {
               for (const item of this._draw.children()) {
                  if (item.type === 'image' || item.type === 'text' || item.type === 'g') {
                     if (item._event) {
                        item.selectize(false);
                        if (item.children()[1]) {
                           item.children()[1].selectize(false);
                        }
                        if ((item.attr('fieldType') === 'comment') && !item.attr('comment')) {
                           this.onDeleteComment(item.attr('id'));
                           item.remove();
                        }
                     }
                  }
               }
            }
         });
   }

   /** ตั้งค่า object ให้ signItem ของ taskAttribute ที่จะทำการส่งไปฝั่ง service */
   setSignItem(signer, fieldType, pageType, pageNum, positionType, chkName, chkDate, certId,
               coordinateX, coordinateY, fieldWidth, fieldHeight, id, order, content?, flagSign?, comment?, idImageItem?,
               fontStyle?, fontSize?, fontColor?, fontBold?, fontItalic?, fontUnderline?, textRequired?, flagCheckbox?, stepOrder?, taskContactId?) {
      this._signItem = {
         'signer': signer
         , 'fieldType': fieldType
         , 'pageType': pageType
         , 'pageNum': pageNum
         , 'positionType': positionType
         , 'chkName': chkName
         , 'chkDate': chkDate
         , 'certId': certId
         , 'coordinateX': coordinateX
         , 'coordinateY': coordinateY
         , 'fieldWidth': fieldWidth
         , 'fieldHeight': fieldHeight
         , 'idSignItem': id
         , 'order': order
         , 'flagSign': flagSign
         , 'content': content
         , 'comment': comment
         , 'idImageItem': idImageItem
         , 'fontStyle': fontStyle
         , 'fontSize': fontSize
         , 'fontColor': fontColor
         , 'fontBold': fontBold
         , 'fontItalic': fontItalic
         , 'fontUnderline': fontUnderline
         , 'textRequired': textRequired
         , 'flagCheckbox': flagCheckbox
         , 'stepOrder': stepOrder
         , 'taskContactId': taskContactId
      };
   }

   /** เมื่อมีการวาด object ลงบนเอกสารจะทำการ bind data เข้า object signItem ใน taskAttribute */
   addItemSign(index, yMarginSign?) {
      let pageNo, img, id;

      if (!this.taskAttribute.docList[index].signItems) {
         this.taskAttribute.docList[index].signItems = [];
      }

      if (!this._onClickDelete) {
         if (this._objectSVG) {
            for (const object of this._objectSVG) {
               for (const item of object.svg.children()) {
                  if (item.attr('id') && ((item.type === 'text' || item.type === 'image' || item.type === 'g') && $(item.node).attr('signer') && !this.isDrawing)) { // check case when draw Sign
                     let fieldType, pageType, positionType, idSignItem, y, newX, x, chkName, chkDate, certId, content, comment, idImageItem, fontStyle, fontSize, fontColor, fontBold, fontItalic, fontUnderline, textRequired, flagCheckbox, stepOrder, taskContactId;
                     pageNo = $(item.node).attr('pageNum');
                     pageType = $(item.node).attr('pageType');
                     positionType = $(item.node).attr('positionType');
                     chkName = ($(item.node).attr('chkName') === 'true');
                     chkDate = ($(item.node).attr('chkDate') === 'true');
                     certId = parseInt($(item.node).attr('certId'), 10);
                     idSignItem = $(item.node).attr('id');
                     stepOrder = $(item.node).attr('stepOrder');
                     taskContactId = $(item.node).attr('taskContactId');
                     if (yMarginSign) {
                        y = item.y() + yMarginSign;
                     } else {
                        y = item.y();
                     }
                     newX = item.attr('newX');
                     x = item.x();
                     this._signer = $(item.node).attr('signer'); // check why signer Email change
                     fieldType = $(item.node).attr('class');
                     content = '';
                     if (fieldType === 'text') {
                        content = item.node.textContent;
                        fontStyle = $(item.node).attr('fontStyle');
                        fontSize = Number($(item.node).attr('fontSize'));
                        fontColor = $(item.node).attr('fontColor');
                        fontBold = ($(item.node).attr('fontBold') === 'true');
                        fontItalic = ($(item.node).attr('fontItalic') === 'true');
                        fontUnderline = ($(item.node).attr('fontUnderline') === 'true');
                        textRequired = ($(item.node).attr('textRequired') === 'true');
                     } else if (fieldType === 'comment') {
                        comment =  $(item.node).attr('comment') ? JSON.parse($(item.node).attr('comment')) : null;
                     } else if (fieldType === 'image'){
                        idImageItem = $(item.node).attr('ref');
                     } else if (fieldType === 'checkbox') {
                        flagCheckbox = ($(item.node).attr('flagCheckbox') === 'true');
                     }
                     if (item.type === 'g') {
                        let itemWidth = item.children()[0].width();
                        let itemHeight = item.children()[0].height();
                        if (fieldType === 'checkbox') {
                           itemWidth = item.children()[1].width();
                           itemHeight = item.children()[1].height();
                        }
                        this.setSignItem(this._signer
                           , fieldType
                           , pageType
                           , pageNo
                           , positionType
                           , chkName
                           , chkDate
                           , certId
                           , x
                           , y
                           , itemWidth
                           , itemHeight
                           , idSignItem
                           , item.attr('order')
                           , content
                           , false
                           , comment
                           , idImageItem
                           , fontStyle
                           , fontSize
                           , fontColor
                           , fontBold
                           , fontItalic
                           , fontUnderline
                           , textRequired
                           , flagCheckbox
                           , stepOrder
                           , taskContactId
                        );
                     } else {
                        if (!fieldType) {
                           switch (item.type) {
                              case 'image' :
                                 if ($(item.node).attr('fieldType')  === 'initSignature') {
                                    fieldType = 'initSignature';
                                 } else if ($(item.node).attr('fieldType')  === 'signature') {
                                    fieldType = 'signature';
                                 }
                                 break;
                              default:
                                 break;
                           }
                        }
                        this.setSignItem(this._signer
                           , fieldType
                           , pageType
                           , pageNo
                           , positionType
                           , chkName
                           , chkDate
                           , certId
                           , x
                           , y
                           , item.width()
                           , item.height()
                           , idSignItem
                           , item.attr('order')
                           , content
                           , true
                           , comment
                           , idImageItem
                           , fontStyle
                           , fontSize
                           , fontColor
                           , fontBold
                           , fontItalic
                           , fontUnderline
                           , textRequired
                           , flagCheckbox
                           , stepOrder
                           , taskContactId
                        );
                     }
                     if (this._objDraw && (this._objDraw.attr('id') === item.attr('id'))) {
                        let itemIndex = this.taskAttribute.docList[index].signItems.findIndex(x => x.idSignItem === this._signItem.idSignItem);
                        if (itemIndex >= 0){
                           this.taskAttribute.docList[index].signItems[itemIndex] = this._signItem;
                        }
                        else {
                           this.taskAttribute.docList[index].signItems.push(this._signItem);
                        }
                        if (this._objDraw.attr('class') === 'comment') {
                           this.drawCommentBox(this._signItem, this._objDraw, y);
                        }
                     } else {
                        this.taskAttribute.docList[index].signItems.forEach((data, i) => {
                           if (data.idSignItem && data.idSignItem === item.attr('id')) {
                              this.taskAttribute.docList[index].signItems[i] = this._signItem;
                           }
                           if (item.attr('class') === 'comment') {
                              this.updatePositionCommentBox(this._signItem, y);
                           }
                        });
                     }
                  }
               }
            }
         }
         if (this.taskAttribute.docList[this.currentIndex].signItems) {
            for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
               if (this._idSignitems !== item.idSignItem) {
                  if (document.activeElement instanceof HTMLElement) {
                     document.activeElement.blur();
                  }
               }
            }
         }
         if(this.leftPanelComp.show){
            setTimeout(() => {
               this.leftPanelComp.scrollDown();
            },50);
         }
      }
   }

   deleteItemSign(index, id) {
      if (this.taskAttribute.docList[index].signItems) {
         const indexSignItem = this.taskAttribute.docList[index].signItems.findIndex(signItem => {
            return signItem.idSignItem === id;
         });
         if (indexSignItem !== -1) {
            for (let i = 0; i < this.taskAttribute.docList[index].signItems.length; i++) {
               if (this.taskAttribute.docList[index].signItems[i].idImageItem) {
                  if (this.taskAttribute.docList[index].signItems[i].idSignItem === id) {
                     this.imgDeleted.push(this.taskAttribute.docList[index].signItems[i].idImageItem);
                  }
               }
            }
            this.taskAttribute.docList[index].signItems.splice(indexSignItem, 1);
         }
      }
   }

   /** เมื่อมีการเปลี่ยน signer ของ object จะทำการ bind data เข้า object signItem ใน taskAttribute */
   addItemSignerSelect(index, yMarginSign?) {
      let pageNo, img;
      if (!this.taskAttribute.docList[index].signItems) {
         this.taskAttribute.docList[index].signItems = [];
      }

      if (!this._onClickDelete) {
         if (this._objectSVG) {
            for (const object of this._objectSVG) {
               for (const item of object.svg.children()) {
                  // check case when draw Sign
                  if (item.attr('id') && ((item.type === 'text' || item.type === 'image' || item.type === 'g') && $(item.node).attr('signer'))) {
                     let fieldType, pageType, positionType, idSignItem, y, newX, x, chkName, chkDate, certId, content, comment, idImageItem, fontStyle, fontSize, fontColor, fontBold, fontItalic, fontUnderline, textRequired, flagCheckbox, stepOrder, taskContactId;
                     pageNo = $(item.node).attr('pageNum');
                     pageType = $(item.node).attr('pageType');
                     positionType = $(item.node).attr('positionType');
                     chkName = ($(item.node).attr('chkName') === 'true');
                     chkDate = ($(item.node).attr('chkDate') === 'true');
                     certId = parseInt($(item.node).attr('certId'), 10);
                     idSignItem = $(item.node).attr('id');
                     stepOrder = $(item.node).attr('stepOrder');
                     taskContactId = $(item.node).attr('taskContactId');
                     if (yMarginSign) {
                        y = item.y() + yMarginSign;
                     } else {
                        y = item.y();
                     }
                     newX = item.attr('newX');
                     x = item.x();
                     this._signer = $(item.node).attr('signer'); // check why signer Email change
                     fieldType = $(item.node).attr('class');
                     content = '';
                     if (fieldType === 'text') {
                        content = item.node.textContent;
                        fontStyle = $(item.node).attr('fontStyle');
                        fontSize = Number($(item.node).attr('fontSize'));
                        fontColor = $(item.node).attr('fontColor');
                        fontBold = ($(item.node).attr('fontBold') === 'true');
                        fontItalic = ($(item.node).attr('fontItalic') === 'true');
                        fontUnderline = ($(item.node).attr('fontUnderline') === 'true');
                        textRequired = ($(item.node).attr('textRequired') === 'true');
                     } else if (fieldType === 'comment') {
                        comment =  $(item.node).attr('comment') ? JSON.parse($(item.node).attr('comment')) : null;
                     } else if (fieldType === 'image'){
                        idImageItem = $(item.node).attr('ref');
                     } else if (fieldType === 'checkbox') {
                        flagCheckbox = ($(item.node).attr('flagCheckbox') === 'true');
                     }
                     if (item.type === 'g') {
                        let itemWidth = item.children()[0].width();
                        let itemHeight = item.children()[0].height();
                        if (fieldType === 'checkbox') {
                           itemWidth = item.children()[1].width();
                           itemHeight = item.children()[1].height();
                        }
                        this.setSignItem(this._signer
                           , fieldType
                           , pageType
                           , pageNo
                           , positionType
                           , chkName
                           , chkDate
                           , certId
                           , x
                           , y
                           , itemWidth
                           , itemHeight
                           , idSignItem
                           , item.attr('order')
                           , content
                           , false
                           , comment
                           , idImageItem
                           , fontStyle
                           , fontSize
                           , fontColor
                           , fontBold
                           , fontItalic
                           , fontUnderline
                           , textRequired
                           , flagCheckbox
                           , stepOrder
                           , taskContactId
                        );
                     } else {
                        if (!fieldType) {
                           switch (item.type) {
                              case 'image' :
                                 if ($(item.node).attr('fieldType')  === 'initSignature') {
                                    fieldType = 'initSignature';
                                 } else if ($(item.node).attr('fieldType')  === 'signature') {
                                    fieldType = 'signature';
                                 }
                                 break;
                              default:
                                 break;
                           }
                        }
                        this.setSignItem(this._signer
                           , fieldType
                           , pageType
                           , pageNo
                           , positionType
                           , chkName
                           , chkDate
                           , certId
                           , x
                           , y
                           , item.width()
                           , item.height()
                           , idSignItem
                           , item.attr('order')
                           , content
                           , true
                           , comment
                           , idImageItem
                           , fontStyle
                           , fontSize
                           , fontColor
                           , fontBold
                           , fontItalic
                           , fontUnderline
                           , textRequired
                           , flagCheckbox
                           , stepOrder
                           , taskContactId
                        );
                     }
                     this.taskAttribute.docList[index].signItems.forEach((data, i) => {
                        if (data.idSignItem && data.idSignItem === item.attr('id')) {
                           this.taskAttribute.docList[index].signItems[i] = this._signItem;
                           this.idImgUpdateValue.push(this._signItem.idSignItem);
                           if (this.flagImg) {
                              if (this._signItem.fieldType === 'image') {
                                 this.idImgDefaultValue.push(this._signItem.idSignItem);
                              }
                           }
                        }
                        this.flagImg = false;
                     });
                  }
               }
            }
         }
      }
   }

   /** bind data เข้า signItem หลังมีการวาด object เข้าใหม่ หรือมีการเปลี่ยนแปลง object นั้น */
   updateItemsSignCurrentPage() {
      this.addItemSign(this.currentIndex);
   }

   /** filter กรณีที่ชนิดของหน้าไม่เป็น CP */
   getSignConflictRotatePage() {
      const signConflicts = [];
      if (this.taskAttribute.docList[this.currentIndex].signItems) {
         for (const signItem of this.taskAttribute.docList[this.currentIndex].signItems) {
            if (signItem.pageType !== 'CP') {
               signConflicts.push(signItem.idSignItem);
            }
         }
      }
      return signConflicts;
   }


   clearSignConflict(signConflicts) {
      this._onClickDelete = true;
      if (this._objectSVG) {
         for (const obj of this._objectSVG) {
            for (const item of obj.svg.children()) {
               const idItem = $(item.node).attr('id');
               const index = signConflicts.indexOf(idItem);
               if (index !== -1) {
                  item.selectize(false);
                  if (item.children()[1]) {
                     item.children()[1].selectize(false);
                  }
                  item.remove();
                  this.deleteItemSign(this.currentIndex, idItem);
               }
            }
         }
      }
      this._onClickDelete = false;
   }

   /** ลบ object ที่วาดอยู่ทิ้งทั้งหมด */
   clearAllSign() {
      if (this._objectSVG) {
         for (const obj of this._objectSVG) {
            obj.svg.clear();
         }
      }
   }

   /** ลบ object ตามหน้าที่รับเข้ามา */
   clearSignPage(page, direction) {
      this.setDeselectItem('');
      this._onClickDelete = true;
      if (this._objectSVG) {
         for (const obj of this._objectSVG) {
            if (obj.pageNo === page) {
               for (const item of obj.svg.children()) {
                  let oldX, oldY, newX, newY, fieldType;
                  const idItem = $(item.node).attr('id');
                  fieldType = $(item.node).attr('fieldType');
                  if (fieldType === 'comment') {
                     oldX = item.x();
                     oldY = item.y();
                     const hIcon = 25;
                     if (direction === 'left') {
                        const hTmp = this.itemRotates[this.currentIndex].itemRotate[page - 1].item.height;
                        newX = oldY;
                        newY = hTmp - oldX - hIcon;
                     } else if (direction === 'right') {
                        const wTmp = this.itemRotates[this.currentIndex].itemRotate[page - 1].item.width;
                        newX = wTmp - oldY - hIcon;
                        newY = oldX;
                     }
                     item.x(newX);
                     item.y(newY);
                  } else {
                     this.deleteItemSign(this.currentIndex, idItem);
                     item.remove();
                  }
               }
            }
         }
      }
      this._onClickDelete = false;
      this.updateItemsSignCurrentPage();
   }

   /** ลบรูปเอกสารทิ้งทั้งหมด */
   clearAllPage() {
      $('.imageSign').remove();
      this._objectSVG = [];
      this.maxWidth = 0;
      this.maxHeight = 0;

   }

   allowDrop() {
      $('.imageSign').on('mouseover', (e) => {
         if (onDrag) {
            if ($(e.target.parentNode).attr('class') === 'imageSign') {
               if (this._objectDrag) {
                  let id;
                  $(this._objectDrag).appendTo($(e.target.parentNode).find('svg')[0]);
                  id = e.target.parentNode.id;
                  if (this._objectSVG) {
                     for (const object of this._objectSVG) {
                        if (id === object.id) {
                           this._draw = object.svg;
                           break;
                        }
                     }
                  }
                  imageHeight = $(e.target.parentNode).attr('transform').split(',')[5].slice(0, -1);
                  if (currentImageHeight !== imageHeight) {
                     currentImageHeight = imageHeight;
                     changeImage = true;
                  }
               }
            }
         }
      });
   }

   zoomOutAndUpdateSign() {
      this._isDrag = false;
      this.startDrawing = false;
      this.setDeselectItem('');
      this.finishSVG('');
      if (this.countZoom > 0) {
         this.checkheightpage = this.checkheightpage / 2;
         this.ZoomPage(false, parseFloat(this.countZoom.toFixed(1)), 'current');
      }
      this.isZoom = false;
      this.countZoom = 0;
      this.checkheightpage = 0;
   }

   /**
    * คลิกเอกสาร: เอกสารหลายพันหน้าใช้เวลาคำนวณ/สร้างหน้าพักหนึ่ง ระหว่างนั้นหน้าจอดูเหมือนค้าง
    * จึงแสดง loading ก่อน แล้วค่อยทำงานใน task ถัดไป (ให้ browser วาด loading ทัน)
    */
   onListClick(object: {
      index: number;
      docId?: any;
      docName?: any;
      formName?: string;
      form?: Form;
   }) {
      this.handleWaitAction(true);
      const drawSeq = this.drawPageSeq;
      setTimeout(() => {
         try {
            this.applyListClick(object);
         } finally {
            // ถ้าไม่ได้โหลดเอกสารใหม่จาก server (changeDrawPage ปิด loading เองเมื่อได้ผล) ให้ปิด loading
            // หลัง Angular render เสร็จ (task ถัดไป)
            if (this.drawPageSeq === drawSeq) {
               setTimeout(() => this.handleWaitAction(false));
            }
         }
      });
   }

   /** ตั้งค่าต่างๆเริ่มต้นใหม่ต่างๆ เมื่อทำการคลิกที่ list document */
   private applyListClick(object: {
      index: number;
      docId?: any;
      docName?: any;
      formName?: string;
      form?: Form;
   }) {
      this.currentIndex = object.index;
      if (this.fieldName && object.index !== 0) {
         this.fieldName = undefined;
      }
      if (this.taskAttribute.docList[object.index].isForm
         || this.taskAttribute.docList[object.index].docName.endsWith('.zdox')) {
         this.flagDownload = false;
         for (const signer of this.setSelectedList) {
            if (signer.color) {
               setTimeout(() => {
                  const element = document.getElementById('holder'+signer.fieldName);
                  if (element) {
                     element.style.backgroundColor = signer.color;
                     element.style.opacity = '0.5';
                  }
               },200);
            }
         }
         this.updateSignValid.emit(this.setSelectedList);
      } else {
         this.flagDownload = true;
      }
      if (this.taskAttribute.docList[0].isForm
         || this.taskAttribute.docList[0].docName.endsWith('.zdox')) {
         if (this.dynamicFormComp) {
            this.isValueFormatError();
         } else {
            setTimeout(()=> { this.isValueFormatError(); }, 200);
         }
      }
      if (object.formName) {
         this.isFormName = true;
         this.form = object.form;
      } else {
         this.isFormName = false;
         if (this.countZoom > 0) {
            this.checkheightpage = this.checkheightpage / 2;
            this.ZoomPage(false, parseFloat(this.countZoom.toFixed(1)), 'prev');
         }
         this.isZoom = false;
         this.countZoom = 0;
         this.checkheightpage = 0;
         this.isAttFile = this.taskAttribute.docList[this.currentIndex].isAttachFile;
         this.mimType = this.dataPages[this.currentIndex]?.mimType;
         if (!this.mimType || Mimetype.checkMimeType(this.mimType) === '') {
            this.allowAnnotate = false;
         } else {
            this.allowAnnotate = true;
         }
         this.namelist = this.dataPages[this.currentIndex].name;
         this.docidlist = this.dataPages[this.currentIndex].docId;
         if ((this.mimType === 'application/msword' || this.mimType === 'application/pdf' || this.mimType === 'application/vnd.ms-excel' || this.mimType === 'application/vnd.ms-powerpoint'
            || this.mimType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || this.mimType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            || this.mimType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || this.mimType === 'image/tiff'
            || this.mimType === 'image/jpeg' || this.mimType === 'image/png' || this.mimType === 'image/bmp' || this.mimType.indexOf('text/') === 0)
            && this.dataPages[this.currentIndex].totalPages > 0) {
            if (this.dataPages[this.currentIndex].canTransform) {
               this.canNotPreview = false;
               this.isHideCommentPdf = false;
            } else {
               this.canNotPreview = true;
               this.isHideCommentPdf = true;
            }
         } else {
            this.canNotPreview = true;
            this.isHideCommentPdf = true;
         }
         if (object.index === 0) {
            this.viewDocumentComp.isCompleteTask = this.isCompleteTask;
         } else {
            this.viewDocumentComp.isCompleteTask = false;
         }
         this.setDocId(object.docId);
         this.setDeselectItem('');
         this._isDrag = false;
         this.startDrawing = false;
         this.finishSVG('');

         this.countpageprint = 0;
         this.checkclicklist = false;
         this.listPageNo = 1;
         this.countpage = 0;

         this.pageNo1 = 1;
         this.page = 1;
         this._pageCount = 1;
         this.onscrollTum.emit(this.page);
         this.viewDocumentComp.canZoomIn = true;
         this.viewDocumentComp.canZoomOut = false;
         this.setTextContent();
         this.clearAllSign();
         this.isClickPage = true;
         this.isLoopPage = false;
         this.addItemSign(object.index);
         this.refreshPage();
         if (this.leftPanelComp.signListComp) {
            this.leftPanelComp.signListComp.setSignList(object.index, this.typeName);
         }
      }
   }

   setTextContent() {
      for (const doc of this.taskAttribute.docList) {
         if (doc.signItems) {
            for (const item of doc.signItems) {
               if (item.fieldType === 'text' && item.idSignItem) {
                  const svgText = document.querySelector('svg [id="' + item.idSignItem + '"]');
                  if (svgText) {
                     let textValue = svgText.closest('g').querySelector('tspan').textContent;
                     if (textValue === 'Input Text' || textValue === 'กรอกข้อความ') {
                        textValue = '';
                     }
                     item.content = textValue;
                  }
               }
            }
         }
      }
   }

   download() {
      location.href = this.service.downloadFileUrl(this.docidlist) + '&token=' + this.service.user.token;
   }
   setDocId(docId) {
      this._docId = docId;
   }

   getDocId() {
      return this._docId;
   }

   /** เมื่อคลิกเปลี่ยน dropdown signer */
   onSignerChange($event) {
      this.signerSelected = $event;
      this.getProfile();
      if (this._objDraw) {
         if (this._objDraw.attr('fieldType') !== 'comment') {
            this._objDraw.attr('signer', this.signerSelected.signer.signerEmail);
            this._objDraw.attr('stepOrder', this.signerSelected.signer.stepOrder);
            this._objDraw.attr('taskContactId', this.signerSelected.signer.taskContactId);
            this._objDraw.children()[0].fill(this.colors[this.signerSelected.index]);
         }
      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         if ($objectDrag.attr('fieldType') !== 'comment') {
            $objectDrag.attr('signer', this.signerSelected.signer.signerEmail);
            $objectDrag.attr('stepOrder', this.signerSelected.signer.stepOrder);
            $objectDrag.attr('taskContactId', this.signerSelected.signer.taskContactId);
            $($objectDrag.children()[0]).attr('fill', this.colors[this.signerSelected.index]);
         }
      }
      if (this.taskAttribute.docList[this.currentIndex]) {
         this.addItemSignerSelect(this.currentIndex);
      }
   }

   getHeight() {
      return 'height-page-sign';
   }

   onClickDelete(objItem, flagDeselect?) {
      if (!this.isDrawing) {
         this._onClickDelete = true;
         let id;
         this.startDrawing = false;
         if (objItem.fieldType === 'comment' && this._objectDrag) {
            this.onDeleteObjDrag(flagDeselect);
         } else {
            if (this._objDraw) {
               this._objDraw.selectize(false);
               id = $(this._objDraw.node).attr('id');
            }
            if (this._objDraw) {
               if (this._objectSVG) {
                  for (const obj of this._objectSVG) {
                     if (obj.svg) {
                        for (const item of obj.svg.children()) {
                           const idItem = $(item.node).attr('id');
                           if (idItem === id) {
                              if (!flagDeselect) {
                                 this.setDeselectItem('');
                              }
                              this.finishSVG('');
                              if ($(item.node).attr('class') === 'comment') {
                                 this.onDeleteComment(id);
                              }
                              item.remove();
                           }
                        }
                     }
                  }
               }
               this.deleteItemSign(this.currentIndex, id);
            } else if (this._objectDrag) {
               this.onDeleteObjDrag(flagDeselect);
            }
         }
      }
      this._onClickDelete = false;
   }

   onDeleteObjDrag(flagDeselect) {
      const $objectDrag = $(this._objectDrag);
      const id = $objectDrag.attr('id');
      if (!flagDeselect) {
         this.setDeselectItem('');
      }
      this.finishSVG('');
      if ($objectDrag.attr('class') === 'comment') {
         this.onDeleteComment(id);
      }
      $objectDrag.remove();
      this.deleteItemSign(this.currentIndex, id);
   }

   onDeleteComment(id) {
      this._onDeleteComment = false;
      this.commentboxComp.remove(id);
      this._isDeselect = true;
      if (this.leftPanelComp.toolsComp) {
         this.leftPanelComp.toolsComp.isExpanded = true;
      }
      this.leftPanelComp.visiblityState = false;
      if (!this.isDrawing) {
         if (!this.isDrawing) {
            this._objDraw = '';
         }
         this._objectDrag = '';
      }
      this.deleteItemSign(this.currentIndex, id);
   }

   onSelectPositionTypeChange(positionTypeValue) {
      let $imageCurrentPage, imgWidthCurrentPage, imgHeightCurrentPage, position, $objectDrag, objectDrag;
      if (this._objDraw) {
         $objectDrag = $(this._objDraw.node);
         objectDrag = this._objDraw.node;
         this._objDraw.attr('positionType', positionTypeValue);
      } else if (this._objectDrag) {
         $objectDrag = $(this._objectDrag);
         objectDrag = this._objectDrag;
         $objectDrag.attr('positionType', positionTypeValue);
      }
      this.positionType = positionTypeValue;
      if (positionTypeValue !== 'CT' && $objectDrag) {
         $imageCurrentPage = this.findParentImageBySignItem($objectDrag);
         const pageNo = $objectDrag.parent().parent().attr('id').split('_');
         imgWidthCurrentPage = parseFloat(this.itemRotates[this.currentIndex].itemRotate[Number(pageNo[1]) - 1].item.width);
         imgHeightCurrentPage = parseFloat(this.itemRotates[this.currentIndex].itemRotate[Number(pageNo[1]) - 1].item.height);
         this.setSizeCurrentSignItem($objectDrag);
         position = this.calculatePosition(positionTypeValue, imgWidthCurrentPage, imgHeightCurrentPage);
         this.setPositionCurrentSignItem($objectDrag, position.coordinateX, position.coordinateY);
         const imgCurrentId = $objectDrag.parent().parent().attr('id');
         let heightTotal, scrollTop, scrollLeft;
         heightTotal = this.getTotalPageHeight(imgCurrentId);
         scrollTop = (position.coordinateY + heightTotal - 200);
         scrollLeft = position.coordinateX;
         $('#sideNavContent').scrollTop(scrollTop);
         $('#sideNavContent').scrollLeft(scrollLeft);
      }
      if (this.taskAttribute.docList[this.currentIndex].signItems) {
         for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
            if (this._idSignitems === item.idSignItem) {
               item.positionType = positionTypeValue;
               if (position) {
                  item.coordinateX = position.coordinateX;
                  item.coordinateY = position.coordinateY;
               }
            }
         }
      }
   }

   onSelectPageTypeChange(value) {
      if (this._objDraw) {
         this._objDraw.attr('pageType', value);
      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         $objectDrag.attr('pageType', value);
      }
      this.pageType = value;
      if (this.taskAttribute.docList[this.currentIndex].signItems) {
         for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
            if (this._idSignitems === item.idSignItem) {
               item.pageType = value;
            }
         }
      }
   }

   onSelectCertChange(value) {
      if (this._objDraw) {
         this._objDraw.attr('certId', value);
      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         $objectDrag.attr('certId', value);
      }
      this.certId = value;
      if (this.taskAttribute.docList[this.currentIndex].signItems) {
         for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
            if (this._idSignitems === item.idSignItem) {
               item.certId = value;
            }
         }
      }
   }

   getFileNameExt(value){
      return value.replace(/(.*)\//g, '');
   }
   setCheckBoxInclude(e) {
      const target = $(e.target);
      this.chkName = (target.attr('chkName') === 'true');
      this.chkDate = (target.attr('chkDate') === 'true');
      this.chkApplyAll = (target.attr('chkApplyAll') === 'true');
   }

   onCheckboxIncludeChange(value) {
      this.chkName = value.chkName;
      this.chkDate = value.chkDate;
      this.chkApplyAll = value.chkApplyAll;

      if (!value.chkApplyAll) {
         let $objectDrag;

         if (this._objDraw) {
            $objectDrag = $(this._objDraw.node);
            this._objDraw.attr('chkName', value.chkName);
            this._objDraw.attr('chkDate', value.chkDate);
         } else if (this._objectDrag) {
            $objectDrag = $(this._objectDrag);
            $objectDrag.attr('chkName', value.chkName);
            $objectDrag.attr('chkDate', value.chkDate);
         }
         if (this.taskAttribute.docList[this.currentIndex].signItems) {
            for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
               if (item.fieldType === 'signature' && item.idSignItem === $objectDrag?.attr('id')) {
                  item.chkName = value.chkName;
                  item.chkDate = value.chkDate;
               }
            }
         }
      } else {
         if (this.taskAttribute.docList[this.currentIndex].signItems) {
            for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
               if (item.fieldType === 'signature') {
                  let obj = $('#' + item.idSignItem);
                  item.chkName = value.chkName;
                  item.chkDate = value.chkDate;
                  obj.attr('chkName', value.chkName);
                  obj.attr('chkDate', value.chkDate);
               }
            }
         }
      }
   }

   onSelectFileuploadChange(files: any){
      const file = files;
      if (files.length === 0) {
         return;
      } else {
         this.uploadDoc(file);
      }
   }

   validateFile(myFile: any) {
      for (let i = 0; i < myFile.length; i++) {
         if (myFile[i] != null) {
            this.ext = myFile[i].type;
            if (this.ext !== '') {
               if (this.validateExtension(this.ext) === false) {
                  this.handleToastError('uploadDoc.errorPdf');
                  return false;
               } else {
                  if (myFile[i].size > this.chunkSize) { // size 15120
                     this.handleToastError('registerSignature.errorFileSize');
                     return false;
                  } else {
                     this.renderImage(myFile);
                     return true;
                  }
               }
            } else {
               this.handleToastError('uploadDoc.errorPdf');
               return false;
            }
         }
      }
      return true;
   }

   //** render แสดงรูปภาพที่หน้าเอกสาร */
   renderImage(files) {
      // generate a new FileReader object
      const reader = new FileReader();
      let objId, id, id_next;
      if (this._objDraw) {
         objId = this._objDraw.attr('id');
         id_next = $('#' + objId).next().attr('id');
         const reader = new FileReader();
         reader.readAsDataURL(files[0]);
         reader.onload = (e: any) => {
            let element = (<HTMLImageElement>document.getElementById(objId));
            this.itemImageId = element.getAttribute('ref');
            id = 'img_' + element.getAttribute('pageNum');
            let rect = (<HTMLImageElement>document.getElementById(id_next));
            for(const obj of this._objectSVG){
               if(id===obj.id) {
                  this._draw = obj.svg;
                  break;
               }
            }
            if(rect){
               element.parentNode.removeChild(element);  // ลบ tag <g> เพื่อเปลี่ยนเป็นรูปเป็น tag <image>
               rect.remove();  /// ลบกรอบของ item
            } else {
               element.parentNode.removeChild(element);  // ลบ tag <g> เพื่อเปลี่ยนเป็นรูปเป็น tag <image>
            }
            this.drawAttachImage(e, objId);
         };
      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         objId = $objectDrag.attr('id');
         const reader = new FileReader();
         reader.readAsDataURL(files[0]);
         reader.onload = (e: any) => {
            let element = (<HTMLImageElement>document.getElementById(objId));
            id = 'img_' + element.getAttribute('pageNum');
            this.itemImageId = element.getAttribute('ref');
            for (const obj of this._objectSVG) {
               if(id===obj.id) {
                  this._draw = obj.svg;
                  for (const item of obj.svg.children()) { /// ลบกรอบของ item กรณีที่มีการ Drag item
                     let rect = $(item.node);
                     if(rect.attr('fieldType') === undefined) {
                        if(rect.attr('class') === undefined) {
                           rect.remove();
                        }
                     }
                  }
                  break;
               }
            }
            element.parentNode.removeChild(element); // ลบ tag <g> เพื่อเปลี่ยนเป็นรูปเป็น tag <image>
            this.drawAttachImage(e, element.id);
         };
      }
   }

   /// วาด image ขึ้นมาใหม่หลังจากมีการแก้ไขพร้อมตั้งค่าต่าง ๆ ให้กับ element
   drawAttachImage(e: any, id: string){
      for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
         if(item.fieldType === 'image' && item.idSignItem === id) {
            this.startDrawing = true;
            this.setVisibleProperty(false);
            const ratioZoom = this.getCountZoom();
            let ratio = 0, maxWidth = 250, maxHeight = 250;
            this._objDraw = this._draw.image(e.target.result).loaded(function (loader) { // คำนวณ ratio รูปภาพให้ขนาด match กัน
               if (loader.width > maxWidth) { // Check if the current width is larger than the max
                  ratio = maxWidth / loader.width;
                  this.size(maxWidth * ratioZoom, (loader.height * ratio) * ratioZoom);
                  loader.height = loader.height * ratio;
                  loader.width = loader.width * ratio;
               } else if (loader.height > maxHeight) { // Check if current height is larger than max
                  ratio = maxHeight / loader.height;
                  this.size((loader.width * ratio) * ratioZoom, maxHeight * ratioZoom);
                  loader.width = loader.width * ratio;
                  loader.height = loader.height * ratio;
               }
               if (item) {
                  this.move((item.coordinateX), (item.coordinateY));
               }
            }).attr({
               'signer': this.signerSelected.signer.signerEmail,
               'positionType': item.positionType,
               'pageType': item.pageType,
               'certId': item.certId,
               'cursor': 'pointer',
               'pageNum': item.pageNum,
               'order': item.order,
               'fieldType': item.fieldType,
               'taskSignId': item.taskSignId,
               'isExists': item.isExists,
               'class': 'image',
               'stepOrder': item.stepOrder,
               'taskContactId': item.taskContactId
            });
            this.controllAttachImage(item);
            break;
         }
      }
   }

   /** ผูก image event ให้แต่ละ object */
   controllAttachImage(item){
      const id = 'img_' + item.pageNum;
      this._draw = null;
      if (this._objectSVG) {
         for (const object of this._objectSVG) {
            if (id === object.id) {
               this._draw = object.svg;
               break;
            }
         }
      }
      if (this._draw) {
         this._objDraw.on('load', (e) => { // โหลดรูปและคำนวณขอบกระดาษกรณี Draft ไว้มุมกระดาษ
            this.calculateOutBoundItemImage(e);
         });
         this._objDraw.on('beforedrag', (e) => {
            this.handleChangeTab();
            if (!this.isDrawing) {
               this._objDraw = ''; // เคลียร์ค่า object นี้ทิ้งเพื่อไม่ให้ซ้ำซ้อนตอนที่เก็บ object เข้า taskAttribute
            }
            this._objectDrag = e.target;
            const $id = e.target.id;
            this.deselectAllWithOutMatchId($id);
            if (this.taskAttribute.docList[this.currentIndex].signItems) {
               for (const signItem of this.taskAttribute.docList[this.currentIndex].signItems) {
                  if (signItem.idSignItem === $id) {
                     this.setProperties(signItem, $id);
                     if (this.leftPanelComp.toolsComp &&  this.leftPanelComp.toolsComp.signers) {
                        let index = this.leftPanelComp.toolsComp.signers.findIndex((data) => parseInt(data.taskContactId, 10) === parseInt(signItem.taskContactId, 10));
                        if (index < 0) {
                           index = 0;
                        }
                        this.leftPanelComp.toolsComp.selected = index;
                        this.signerSelected.signer = this.leftPanelComp.toolsComp.signers[index];
                        this.signerSelected.index = index;
                        break;
                     }
                  }
               }
            }
         });
         this._objDraw.on('beforedrag', function (e) {
            if (!item.flagSign) {
               if(this.type === 'image'){
                  this.attr({'cursor': 'move'});
                  this.selectize({
                     points: false,
                     rotationPoint: false
                  });
               }
            }
         });
         this._objDraw.on('dragstart.namespace', (e) => {
            this._onDrag = true;
            onDrag = true;
            this._objectDrag = e.target; // เก็บ object drag ที่เลือกปัจจุบันล่าสุด
         });
         this._objDraw.on('dragmove.namespace', function (e) { // need to calculdate diffent Y
            if (changeImage) {
               e.preventDefault();
               this.move(e.detail.event.offsetX, e.detail.event.offsetY);
            }
         });
         this._objDraw.on('dragend.namespace', function (e) {
            this.attr({'cursor': 'pointer'});
            if (this.type === 'image') {
               this.selectize({
                  points: ['lt', 'rt', 'rb', 'lb'],
                  rotationPoint: false
               }).resize({saveAspectRatio: true});
            } else {
               this.selectize({
                  points: false,
                  rotationPoint: false
               });
            }
            changeImage = false;
            onDrag = false;
         });
         this._objDraw.on('dragend.namespace', (e) => {
            this.isHideProperties = false;
            this._isHideProp = false;

            this.checkImgFocus(e);
            this._onDrag = false;
            this.isDrawing = false;
            this.calculateOutBoundItemImage(e);
            this.updateItemsSignCurrentPage();
            this.finishSVG('');
         });
         this._objDraw.on('resizing', (e) => {
            if (!this.isDrawing) {
               this._objDraw = '';
            }
            this._objectDrag = e.target;
         });
         this._objDraw.on('resizedone', (e) => {
         this.updateItemsSignCurrentPage();
         });
         this._objDraw.draggable();
         item.idSignItem = this._objDraw.attr('id');
         this.IdAttachItem = this._objDraw.attr('id');
         this._idSignitems = item.idSignItem;
         this.startDrawing = false;
      }
   }

   private init(i: any): Observable<any> {
      return this.service.get('/init/upload/' + i);
   }

   //** upload file แนบรูปเอกสารบน Alfresco */
   uploadDoc(files: any) {
      const dateNow = moment(Date.now());
      let dateName = dateNow.format('yyyyMMDD_HHmmssSSS');
      if (this.validateFile(files)) {
         if (this.itemImageId === undefined || this.itemImageId === null) {
            this.itemImageId = undefined;
         }
         for (let i = 0; i < files.length; i++) {
            let typeName = "."+/[^/]*$/.exec(files[i].type)[0];
            files[i].fullPath = files[i].webkitRelativePath;
            files[i].fileName = dateName+typeName;
            this.init(i).subscribe(result => {
               const key = result.key;
               const fileNo = result.fileNo;
               let offset = 0;
               const file: any = files[i];
               const xhr = new XMLHttpRequest();
               const send = () => {
                  const end = Math.min(offset + this.chunkSize, file.size);
                  xhr.open('PUT', this.service.url + '/upload/' + result.key, true);
                  xhr.setRequestHeader('x-auth-token', this.service.user.token);
                  xhr.setRequestHeader('Content-Range', 'bytes ' + offset + '-' + (end - 1) + '/' + file.size);
                  const blob = file.slice.call(file, offset, end);
                  xhr.send(blob);
               };
               xhr.onload = () => {
                  if (xhr.status === 308) {
                     if (file.canceled) {
                        this.service.post('/cancel/upload/' + result.key, null).subscribe(() => {
                              // This is intentional.
                           },
                           (err) => {
                              console.error(err);
                           });
                        return;
                     }
                     offset += this.chunkSize;
                     send();
                  } else if (xhr.status === 201) {
                     this.finish(key, file, fileNo);
                  }
               };
               send();
            }, error => {
               files.error = error;
            });

            if (this.typeName === 'template') {
               break;
            }
         }
      }
   }

   finish(key: string, file: any, fileNo: any) {
      const body = {
         name: file.fullPath || file.fileName,
         mimeType: file.type,
         id: this.itemImageId
      };
      // TODO body,fileNo, key
      this.service.uploadDocumentTemp("attachImage", body, fileNo, key).subscribe((response) => {
         const docId = response.docId;
         const img = (<HTMLImageElement>document.getElementById(this.IdAttachItem));
         img.setAttribute('ref', docId);
         if (this.taskAttribute.docList[this.currentIndex]) {
            this.addItemSignerSelect(this.currentIndex);
         }
      }, error => {
         if (error.status === 413) {
            this.itemImageId.error = error.message;
         }
         if (error.status === 401) {

         }
      });
   }

   //** ลบไฟล์แนบเอกสาร */
   submitDeleteFile() {
      if(this.imgDeleted !== undefined || this.imgDeleted.length >0){
         for (let i = 0; i < this.imgDeleted.length; i++) {
            this.service.deleteDocument(this.imgDeleted[i])
               .subscribe((response) => {
                  },
                  (err) => {
                     console.error(err);
                  });
         }
      }
   }

   handleToastError(key) {
      this.translate.get(key).subscribe((msg) => {
         this.toast.error(msg);
      });
   }

   validateExtension(v) {
      const allowedExtensions = new Array('image/png', 'image/jpeg', 'image/jpg', 'image/bmp');
      for (let ct = 0; ct < allowedExtensions.length; ct++) {
         const fileSelected = v.toLowerCase().lastIndexOf(allowedExtensions[ct]);
         if (fileSelected !== -1) {
            return true;
         }
      }
      return false;
   }

   handleGetTranslate(key) {
      this.translate.get(key).subscribe((msg) => {
         this.errorMessage = msg;
      });
   }

   setTextStyle() {
      const ratioZoom = this.getCountZoom();
      if (this._objDraw) {
         this.fontDetail.fontStyle = this._objDraw.attr('fontStyle');
         this.fontDetail.fontSize = Number(this._objDraw.attr('fontSize'));
         this.fontDetail.fontColor = this._objDraw.attr('fontColor');
         this.fontDetail.fontBold = (this._objDraw.attr('fontBold')  === 'true');
         this.fontDetail.fontItalic = (this._objDraw.attr('fontItalic') === 'true');
         this.fontDetail.fontUnderline = (this._objDraw.attr('fontUnderline') === 'true');
         this.fontDetail.textRequired = (this._objDraw.attr('textRequired') === 'true');
      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         this.fontDetail.fontStyle = $objectDrag.attr('fontStyle');
         this.fontDetail.fontSize = Number($objectDrag.attr('fontSize'));
         this.fontDetail.fontColor = $objectDrag.attr('fontColor');
         this.fontDetail.fontBold = ($objectDrag.attr('fontBold') === 'true');
         this.fontDetail.fontItalic = ($objectDrag.attr('fontItalic') === 'true');
         this.fontDetail.fontUnderline = ($objectDrag.attr('fontUnderline') === 'true');
         this.fontDetail.textRequired = ($objectDrag.attr('textRequired') === 'true');

      }
      this.setFontDetail();
   }

   setFontDetail(isChangeFont?) {
      let objId, widthText, heightText;
      const ratioZoom = this.getCountZoom();
      if (this._objDraw) {
         objId = this._objDraw.attr('id');

      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         objId = $objectDrag.attr('id');
      }

      const objElement = document.getElementById(objId);
      for (let i = 0; i < objElement.getElementsByTagName('tspan').length; i++) {
         if (isChangeFont) {
            /** โหลด font เพื่อไม่ให้แสดงตัวอักษรแล้วกระพริบ */
            if (objElement.getElementsByTagName('text')[i]) {
               let o = $('#' + objElement.getElementsByTagName('tspan')[i].id).clone();
               o.attr('id', o.attr('id') + 'tmp');
               o[0].style.fontFamily = this.fontDetail.fontStyle;
               o[0].style.visibility = 'hidden';
               $('#' + objElement.getElementsByTagName('text')[i].id).append(o);
               setTimeout(() => {
                  o.remove();
                  objElement.getElementsByTagName('tspan')[i].style.fontFamily = this.fontDetail.fontStyle;
               },350);
            }
            isChangeFont = false;
         } else {
            objElement.getElementsByTagName('tspan')[i].style.fontFamily = this.fontDetail.fontStyle;
         }
         objElement.getElementsByTagName('tspan')[i].style.fontSize = (this.fontDetail.fontSize * ratioZoom) + 'px';
         objElement.getElementsByTagName('tspan')[i].style.fill = this.fontDetail.fontColor;

         if (this.fontDetail.fontItalic) {
            objElement.getElementsByTagName('tspan')[i].style.fontStyle = 'italic';
         } else {
            objElement.getElementsByTagName('tspan')[i].style.fontStyle = 'normal';
         }

         if (this.fontDetail.fontUnderline) {
            objElement.getElementsByTagName('tspan')[i].style.textDecoration = 'underline';
         } else {
            objElement.getElementsByTagName('tspan')[i].style.textDecoration = 'none';
         }

         if (this.fontDetail.fontBold) {
            objElement.getElementsByTagName('tspan')[i].style.fontWeight = 'bold';
         } else {
            objElement.getElementsByTagName('tspan')[i].style.fontWeight = 'normal';
         }
         widthText = objElement.getElementsByTagName('text')[i].getBoundingClientRect().width;
         heightText = objElement.getElementsByTagName('text')[i].getBoundingClientRect().height;

         if (widthText < this._widthInitTextarea * ratioZoom) {
            widthText = this._widthInitTextarea * ratioZoom;
         }
         if (heightText < this._heightInitTextarea * ratioZoom) {
            heightText = this._heightInitTextarea * ratioZoom;
         }

         const fontFamily = objElement.getElementsByTagName('tspan')[i].style.fontFamily;
         let dx = objElement.getElementsByTagName('tspan')[i].getAttribute('x');
         let dy = objElement.getElementsByTagName('tspan')[i].getAttribute('dy');

         let y = 0;
         if (ratioZoom == 1) {
            y = (this.fontDetail.fontSize)-Number(dy);
         } else {
            if(isZoom) {
               y = (this.fontDetail.fontSize*ratioZoom)-Number(dy);
            } else {
               y = (this.fontDetail.fontSize/ratioZoom)-Number(dy);
            }
         }
         objElement.getElementsByTagName('text')[i].setAttribute('y', y.toString());

         if(this.fontDetail.fontItalic || this.fontDetail.fontBold || fontFamily === 'Charmonman'){ //margin text
            if( dx === "0") {
               objElement.getElementsByTagName('tspan')[i].setAttribute('x', String(3 * ratioZoom))
            }
            widthText = widthText + (3 * ratioZoom);
         }

         objElement.getElementsByTagName('rect')[i].setAttribute('width', widthText.toString());
         objElement.getElementsByTagName('rect')[i].setAttribute('height', String(heightText + (this.fontDetail.fontSize * ratioZoom)));
         objElement.getElementsByTagName('text')[i].setAttribute('font-size', (this.fontDetail.fontSize * ratioZoom).toString()); // cal ratioZoom when click zoom out
         objElement.getElementsByTagName('text')[i].setAttribute('size', this.fontDetail.fontSize.toString());
         objElement.getElementsByTagName('text')[i].setAttribute('textRequired', this.fontDetail.textRequired.toString());

         const objNextElement = objElement.nextElementSibling;
         if (objNextElement) {
            let cnt = 0;
            let intervalId = setInterval(() => {
               if (cnt >= 25) {
                  clearInterval(intervalId);
               }
               let widthTextNew = objElement.getElementsByTagName('text')[i].getBoundingClientRect().width;
               let hightTextNew = objElement.getElementsByTagName('text')[i].getBoundingClientRect().height;
               if (widthText < widthTextNew) {
                  objElement.getElementsByTagName('rect')[i].setAttribute('width', widthTextNew.toString());
                  objElement.getElementsByTagName('rect')[i].setAttribute('height', String(hightTextNew + (this.fontDetail.fontSize * ratioZoom)));
                  objNextElement.getElementsByTagName('rect')[0].setAttribute('width', widthTextNew.toString());
                  objNextElement.getElementsByTagName('rect')[0].setAttribute('height', String(hightTextNew + (this.fontDetail.fontSize * ratioZoom)));
                  clearInterval(intervalId);
               }
               cnt++;
           }, 50);
         }
      }
   }

   onFontDetailTypeChange(value) {
      if (this._objDraw) {
         this._objDraw.attr('fontStyle', value.fontStyle);
         this._objDraw.attr('fontSize', value.fontSize);
         this._objDraw.attr('fontColor', value.fontColor);
         this._objDraw.attr('fontBold', value.fontBold);
         this._objDraw.attr('fontItalic', value.fontItalic);
         this._objDraw.attr('fontUnderline', value.fontUnderline);
         this._objDraw.attr('textRequired', value.textRequired);
      } else if (this._objectDrag) {
         const $objectDrag = $(this._objectDrag);
         $objectDrag.attr('fontStyle', value.fontStyle);
         $objectDrag.attr('fontSize', value.fontSize);
         $objectDrag.attr('fontColor', value.fontColor);
         $objectDrag.attr('fontBold', value.fontBold);
         $objectDrag.attr('fontItalic', value.fontItalic);
         $objectDrag.attr('fontUnderline', value.fontUnderline);
         $objectDrag.attr('textRequired', value.textRequired);
      }
      if (this.taskAttribute.docList[this.currentIndex].signItems) {
         for (const item of this.taskAttribute.docList[this.currentIndex].signItems) {
            if (this._idSignitems === item.idSignItem) {
               item.fontStyle = value.fontStyle;
               item.fontSize = value.fontSize;
               item.fontColor = value.fontColor;
               item.fontBold = value.fontBold;
               item.fontItalic = value.fontItalic;
               item.fontUnderline = value.fontUnderline;
               item.textRequired = value.textRequired;
            }
         }
      }
      this.setFontDetail(true);
   }

   /** หาว่า object ที่รับเข้ามานั้นอยู่ภายในหน้าไหนของเอกสาร */
   findParentImageBySignItem(objectSign) {
      const nameIdImage = 'img_';
      let idImage, isFound = false, $imageObject;
      do {
         objectSign = objectSign.parent();
         idImage = $(objectSign[0]).attr('id');
         isFound = idImage.includes(nameIdImage);
         if (isFound) {
            this.currentPageNo = idImage.split('_')[1];
         }
      } while (!isFound);
      $imageObject = $(objectSign.children()[0]);
      return $imageObject;
   }

   calculatePosition(positionType, width, height) {
      let x, y;
      switch (positionType) {
         case 'TL':
            x = 0;
            y = 0;
            break;
         case 'TR' :
            x = width - this.widthSignItem;
            y = 0;
            break;
         case 'MD' :
            x = (width / 2.0) - (this.widthSignItem / 2.0);
            y = (height / 2.0) - (this.heightSignItem / 2.0);
            break;
         case 'BL' :
            x = 0;
            y = height - this.heightSignItem;
            break;
         case 'BR' :
            x = width - this.widthSignItem;
            y = height - this.heightSignItem;
            break;
         default:

            break;
      }
      return {'coordinateX': x, 'coordinateY': y};
   }

   setPositionCurrentSignItem(groupSignItem, coordinateX, coordinateY) {
      const matrix = 'matrix(1,0,0,1,' + coordinateX + ',' + coordinateY + ')';
      groupSignItem.attr('transform', matrix);
   }

   setSizeCurrentSignItem(objectSign) {
      const $rect = $(objectSign.children()[0]);
      if ($rect.length !== 0 && !$(objectSign).attr('width')) { // case text date
         this.widthSignItem = $rect.attr('width');
         this.heightSignItem = $rect.attr('height');
      } else { // case signature
         this.widthSignItem = $(objectSign).attr('width');
         this.heightSignItem = $(objectSign).attr('height');
      }
   }

   setProperties(item, id) {
      if (item.positionType) {
         this.positionType = item.positionType;
      } else {
         this.setInitialPositionType();
      }
      if (item.pageType) {
         this.pageType = item.pageType;
      } else {
         this.setInitialPageType();
      }
      this.chkName = item.chkName;
      this.chkDate = item.chkDate;
      this.chkApplyAll = item.chkApplyAll;

      this.certId = item.certId;
      this.fieldType = item.fieldType;
      this._idSignitems = id;
   }

   setInitialPositionType() {
      this.positionType = 'CT';
   }

   setInitialPageType() {
      this.pageType = 'CP';
   }

   /**
    *
    *  ฟังคก์ั่นไว้สำหรับเช็คว่า scroll เลื่อนอยู่ที่หน้าไหนแล้วเพื่อที่จะได้ทำการหมุนได้ถูกหน้า
    *  และไว้สำหรับโหลดหน้าเมื่อ scroll ลงมาถึงตำแหน่งนั้นๆ
    */
   onScroll($event) {
      if (!this.isFormName) {
         const currentPage = $($(this.allImages.nativeElement.lastChild).children()[0]);
         const $parent = $($('#all-image').children()[this.page]);
         const $imageChild = $($parent.children()[0]);
         const $parent1 = $($('#all-image').children()[this.page - 1]);
         const $imageChild1 = $($parent1.children()[0]);
         const $parent2 = $($('#all-image').children()[this.page - 2]);
         const $imageChild2 = $($parent2.children()[0]);
         const $parent0 = $($('#all-image').children()[0]);
         const $imageChild0 = $($parent0.children()[0]);
         let scrollTop = $($event.target)[0].scrollTop;
         if (this._statusInitial?.[this.page - 1]?.isInitial) {
            if (this.checkImgLoaded[this.page - 1] === false) {
               this.onloadedByPage.emit(this.checkImgLoaded);
               this.onloadedPage.emit(false);
               this.checkloadrotate = false;
            } else {
               this.onloadedByPage.emit(this.checkImgLoaded);
               this.onloadedPage.emit(true);
               this.checkloadrotate = true;
            }
         }
         if (this.page === 1) {
            this.checkheightpage =
               (this.itemRotates?.[this.currentIndex]?.itemRotate?.[this.page - 1]?.item)
               ? (this.itemRotates[this.currentIndex].itemRotate[this.page - 1].item.height + this._margin) - 120
               : null;
         }
         if (this.checkheightpage < 400) {
            scrollTop = $($event.target)[0].scrollTop + 120;
         }
         if (this.getScrollDirection($event) === 'down') {
            if (this.page < this.dataPages[this.currentIndex].totalPages) {
               if (scrollTop > this.checkheightpage) {
                  this.numLoadpage = 1;
                  this.checkscroll = scrollTop;
                  this.checkheightpage += this.itemRotates[this.currentIndex].itemRotate[this.page].item.height + this._margin;
                  this.page++;
                  if (this.page === this.dataPages[this.currentIndex].totalPages - 1) {
                     this.checkscroll += this.itemRotates[this.currentIndex].itemRotate[this.page].item.height;
                  }
                  if (this.page < this.dataPages[this.currentIndex].totalPages) {
                     while (this.checkscroll > this.itemRotates[this.currentIndex].itemRotate[this.page]
                        .item.height + this._margin + this.checkheightpage) {
                        this.checkheightpage += this.itemRotates[this.currentIndex].itemRotate[this.page].item.height + this._margin;
                        this.page++;
                        this.numLoadpage += 1;
                        if (this.page === this.dataPages[this.currentIndex].totalPages - 1) {
                           this.checkscroll += this.itemRotates[this.currentIndex].itemRotate[this.page].item.height;
                        }
                        if (this.page === this.dataPages[this.currentIndex].totalPages) {
                           break;
                        }
                     }
                  }
               }
            }
         } else {
            let height1, height2;
            if (this.page - 1 > 0) {
               height1 = this.itemRotates[this.currentIndex].itemRotate[this.page - 1].item.height + this._margin;
            }
            if (this.page - 2 > 0) {
               height2 = this.itemRotates[this.currentIndex].itemRotate[this.page - 2].item.height + this._margin;
            }
            let heightTotal = height1 + height2 * 2 / 3;
            if (scrollTop < (this.checkheightpage - heightTotal) + 75) {
               this.checkscrollUp = scrollTop;
               this.checkheightpage -= this.itemRotates[this.currentIndex].itemRotate[this.page - 1].item.height + this._margin;
               this.page--;
               let heightLoop1, heightLoop2;
               if (this.page - 1 > 0) {
                  heightLoop1 = this.itemRotates[this.currentIndex].itemRotate[this.page - 1].item.height + this._margin;
               }
               if (this.page - 2 > 0) {
                  heightLoop2 = this.itemRotates[this.currentIndex].itemRotate[this.page - 2].item.height + this._margin;
               }
               let heightTotalLoop = heightLoop1 + heightLoop2 * 2 / 3;
               heightTotal = heightTotalLoop;
               while (this.checkscrollUp < ((this.checkheightpage - heightTotal) + 75) -
               (this.itemRotates[this.currentIndex].itemRotate[this.page - 1].item.height + 20)) {
                  if (this.page - 1 > 0) {
                     heightLoop1 = this.itemRotates[this.currentIndex].itemRotate[this.page - 1].item.height + this._margin;
                  }
                  if (this.page - 2 > 0) {
                     heightLoop2 = this.itemRotates[this.currentIndex].itemRotate[this.page - 2].item.height + this._margin;
                  }
                  heightTotalLoop = heightLoop1 + heightLoop2 * 2 / 3;
                  heightTotal = heightTotalLoop;
                  this.checkheightpage -= this.itemRotates[this.currentIndex].itemRotate[this.page - 1].item.height + this._margin;
                  this.page--;
                  if (this.page === 2) {
                     break;
                  }
               }
            }
            if (this.page === 2) {
               if (scrollTop < this.itemRotates[this.currentIndex].itemRotate[0].item.height * 2 / 3) {
                  this.page = 1;
               }
            }
         }
         // for (let i = 0; i < this.numLoadpage; i++) {
         if ($(this.allImages.nativeElement.lastChild).attr('id')) {
            const nextPageNo = parseInt($(this.allImages.nativeElement.lastChild).attr('id').split('_')[1], 10);
            const calculate = parseFloat(currentPage.attr('height')) + this._heightDialogShowPage * (nextPageNo - 1);
            if (this._heightDialogShowPage + scrollTop > calculate) {
               if (this.dataPages[this.currentIndex].totalPages > nextPageNo && !this._statusInitial[nextPageNo].isInitial) {
                  this.listPageNo = Number(nextPageNo) + 1;
                  this.addItemPage(this.dataPages[this.currentIndex], (nextPageNo),
                     this.itemRotates[this.currentIndex].itemRotate[nextPageNo].item.transformHeight, this.maxWidth);
               }
            }
         }
         // }
      }
   }

   setTimeLoadThumbnail() {
      this.mytime = setTimeout(() => {
         this.onscrollTum.emit(this.page);
      }, 1000);
   }

   /** add หน้าของเอกสารลงตาม items และ หน้า ที่รับเข้ามา */
   addItemPage(items, indexItem, transformHeight, maxWidth) {
      const token = this.service.user.token;
      const item = items.pages[indexItem];
      const checkType = Mimetype.checkMimeType(this.checkMimeType);
      let flagCheckTempId = false;
      let tempId;
      if (this.objTempId) {
         tempId = this.objTempId[items.docId];
      }
      if (tempId) {
         if (this.mimType === 'application/pdf') {
            this.imgUrl = this.service.url + '/document/' + tempId + '/' + item.pageNo + '?taskId=' + this.taskAttribute.taskId + '&token=' + token + '&lastmodify=' + Date.now();
            flagCheckTempId = true;
         } else {
            this.imgUrl = this.service.url + '/document/' + items.docId + '/' + item.pageNo + '?taskId=' + this.taskAttribute.taskId + '&token=' + token + '&lastmodify=' + Date.now();
            flagCheckTempId = false;
         }
      } else {
         this.imgUrl = this.service.url + '/document/' + items.docId + '/' + item.pageNo + '?taskId=' + this.taskAttribute.taskId + '&token=' + token + '&lastmodify=' + Date.now();
         flagCheckTempId = false;
      }
      this.append(this.imgUrl, item.width, item.height, transformHeight, item.pageNo, maxWidth);
      const imgID = 'img_' + item.pageNo;
      this.transformHeight += item.height + this._margin;
      if (flagCheckTempId) {
         this._objectSVG.push({'id': imgID, 'pageNo': item.pageNo, 'svg': SVG(imgID), 'docId': tempId});
      } else {
         this._objectSVG.push({'id': imgID, 'pageNo': item.pageNo, 'svg': SVG(imgID), 'docId': items.docId});
      }
      this.taskAttribute.docList[this.currentIndex].totalPages = this.dataPages[this.currentIndex].totalPages;
      if (this.taskAttribute.docList[this.currentIndex].signItems) {
         let signItemsList = this.taskAttribute.docList[this.currentIndex].signItems;
         if (!this.show) {
            signItemsList = this.taskAttribute.docList[this.currentIndex].signItems.filter(sign => sign.signer === this.service.user.email);
         }
         if (this.flagTempleteSignatureDefault && signItemsList.length !== 0) { // set size ค่าเริ่มต้น ถ้า user เลืิอก templete มา
            this.signatureDefaultLength = signItemsList.length;
            this.flagTempleteSignatureDefault = false;
         }

         if (signItemsList.length === 0) { // set ค่าใหม่ถ้ากดยกเลิก templete
            this.signatureDefaultLength = 0;
         }

         if (signItemsList) {
            let i = 0;
            for (const signItem of signItemsList) {
               const itemPageNo = signItem.pageNum;
               // clamp coordinateX/Y to page bounds before drawing to prevent signature appearing outside document
               const pageIndex = Number(itemPageNo) - 1;
               const pageInfo = items.pages && items.pages[pageIndex];
               if (pageInfo) {
                  const pageW = Number(pageInfo.width);
                  const pageH = Number(pageInfo.height);
                  const fw = Number(signItem.fieldWidth) || 0;
                  const fh = Number(signItem.fieldHeight) || 0;
                  const cx = Number(signItem.coordinateX);
                  const cy = Number(signItem.coordinateY);
                  if (cx < 0) {
                     signItem.coordinateX = 0;
                  } else if (cx + fw > pageW) {
                     signItem.coordinateX = Math.max(0, pageW - fw);
                  }
                  if (cy < 0) {
                     signItem.coordinateY = 0;
                  } else if (cy + fh > pageH) {
                     signItem.coordinateY = Math.max(0, pageH - fh);
                  }
               }
               if (this.flagSwitchView) { // เคสหลังสลับ เก็บค่า templete
                  i++;
                  if (i <= this.signatureDefaultLength) {
                     if (this._statusInitial[itemPageNo - 1]?.isInitial === false) {
                        this.InitialDrawSvg(signItem);
                     }
                   } else {
                     break;
                   }
               } else { // เคสไม่ได้สลับจอ
                  if (this._statusInitial[itemPageNo - 1]?.isInitial === false) {
                     this.InitialDrawSvg(signItem);
                  }
               }
            }
         }

         if (!this.isDrawing) {
            this._objDraw = '';
            this.commentboxComp.setDeselectComment(false);
         }
      }
      this._statusInitial[indexItem].isInitial = true;
   }

   addItemPagePrint(items, pageNo) {
      const token = this.service.user.token;
      const item = items.pages[pageNo];
      this.imgUrl = this.service.url + '/document/' + items.docId + '/' + item.pageNo + '?taskId=' + this.taskAttribute.taskId + '&token=' + token + '&lastmodify=' + Date.now();
      this.appendPrint(this.imgUrl, item.width * this.zoomRatio,
         item.height * this.zoomRatio, this.transformHeight * this.zoomRatio, item.pageNo);
   }

   getTotalPageHeight(id) {
      let heightTotal;
      if ($('#' + id).attr('transform')) {
         heightTotal = parseFloat($('#' + id).attr('transform').split(',')[5].replace(')', ''));
      } else {
         heightTotal = 0;
      }
      return heightTotal;
   }

   getPageHeight(id) {
      return parseFloat($('#' + id).find('image').attr('height'));
   }

   calculatePageHeightMargin(id) {
      const pageNo = parseInt(id.split('_')[1], 10) - 1;
      let heightTotal = 0;
      for (let index = 0; index < pageNo; index++) {
         heightTotal += this.itemRotates[this.currentIndex].itemRotate[index].item.height + this._margin * this.getCountZoom();
      }
      return heightTotal;
   }

   findImageParent(target) {
      let next, count = 0;
      const maxIterations = 3;
      while (!$(target).hasClass('imageSign')) {
         next = $(target).parent();
         target = next[0];
         count++;
         if (count >= maxIterations) {
            break;
         }
      }
      return $(target).find('image')[0];
   }

   setOutPage($event) {
      this._moveOnPage = false;
      if(!this._objDraw){
         this.isDrawing = false;
      }
   }

   onDragOver($event) {
      $event.preventDefault();
      $event.stopPropagation();
      this.startDrawing = true;
      if (!this._isDrag) {
         this._isDrag = true;
         this.deselectAll();
      }
      if(!this._objDraw){
         this.isDrawing = false;
      }
   }

   onDragOverDisable($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $event.dataTransfer.effectAllowed = 'none';
      $event.dataTransfer.dropEffect = 'none';
   }

   onDrop($event) {
      this.drawSVG($event);
      this._isDrag = false;
      this.startDrawing = false;
      $event.preventDefault();
      $event.stopPropagation();
   }

   onMouseOver($event) {
      if (this.startDrawing) {
         this.drawSVG($event);
      }
   }

   handleGetTranslateSignItem() {
      this.translate.get('signTools').subscribe((msg) => {
         this._signature = msg.signature;
         this._initSignature = msg.initSignature;
         this._fullName = msg.nameItem;
         this._date = msg.dateItem;
         this._text = msg.textItem;
         this._image = msg.imageItem;
      });
   }

   handleChangeTab() {
      this.leftPanelComp.selectedTab = 1;
   }

   handleMovePageLeftWithMenu($event) {
      if ($event !== 1) {
         this.deselectAll();
         this.setVisibleProperty(false);
      }
   }

   handleToggleOpend() {
      $('#sideNavContent').animate({
         marginLeft: '0px'
      }, 100);
   }

   handleToggleClosed() {
      $('#sideNavContent').animate({
         marginLeft: '250px'
      }, 100);
   }

   handleFitPage(isToggleOpen) {
      this.isToggle = isToggleOpen;
      if (isToggleOpen) {
         if (!this.isZoom && this.countZoom < 4) {
            this.zoomRatio = 2.0;
            if (!this.isDrawing) {
               if (this._objDraw) {
                  this._objectDrag = this._objDraw.node;
               }
               this._objDraw = '';
               this.commentboxComp.setDeselectComment(false);
            }
            this.ZoomPage(true, this.zoomRatio, 'current');
         }
      } else {
         if (this.countZoom !== 0) {
            this.zoomRatio = 2.0;
            if (!this.isDrawing) {
               if (this._objDraw) {
                  this._objectDrag = this._objDraw.node;
               }
               this._objDraw = '';
               this.commentboxComp.setDeselectComment(false);
            }
            this.ZoomPage(false, this.zoomRatio, 'current');
         }
      }
   }

   handleCheckLanguage() {
      this.translate.get('langCurrent').subscribe((msg) => {
         if (msg === 'th') {
            this._widthSignature = 23;
            this._widthInitSignature = 26.5;
            this._widthInitName = 26;
            this._widthInitDate = 42;
            this._heightInitNameDate = 13;
            this._y = 0;
            this._fontSize = 9;
         } else if (msg === 'cn'){
            this._widthSignature = 14;
            this._widthInitSignature = 18;
            this._widthInitName = 26;
            this._widthInitDate = 42;
            this._heightInitNameDate = 13;
            this._y = 0;
            this._fontSize = 9;
         }
      });
   }

   setFontSignText() {
      const objElement = document.getElementsByTagName('tspan');

      for (let i = 0; i < objElement.length; i++) {
         if (objElement[i].parentNode.parentElement.getAttribute('class') !== this._keyFieldType.text) {
            objElement[i].style.fontFamily = 'THSarabunNew';
         }
      }
   }

   setVisibleProperty(isShow) {
      if (this._objectDrag || this._objDraw) {
         let $objectDrag;
         if (this._objectDrag) {
            $objectDrag = $(this._objectDrag);
         } else {
            $objectDrag = $(this._objDraw.node);
         }
         if ($objectDrag.attr('class') === 'comment' && !this.isDrawing && ($objectDrag.attr('id') !== '')) {
            const comment = $objectDrag.attr('comment');
            if (comment && JSON.parse(comment).postBy.id !== this.service.user.email) {
               this.isHideDeleteBtn = true;
               this.leftPanelComp.visiblityState = false;
            } else {
               this.isHideDeleteBtn = false;
               this.leftPanelComp.visiblityState = true;
            }
            this.commentboxComp.setSelectComment($objectDrag.attr('id'), true, this.isHideDeleteBtn);
            if (this.isToggleRightOpened) {
               this._isComment = true;
               this.toggleRight.emit();
            }
         } else {
            this.leftPanelComp.visiblityState = isShow;
         }
      } else {
         this.leftPanelComp.visiblityState = isShow;
      }
   }

   getDrawerOpen() {
      return this.drawer.opened;
   }

   calculateLenStr(strlen1, strlen2) {
      return 30 + (strlen1 * 8) + (strlen2 * 8);
   }

   checkThaiLanguage(str) {
      let isThai = false;
      for (let i = 0; i < str.length; i++) {
         if ((str[i] >= 'ก' && str[i] <= 'ฮ') || (str[i] >= 'เ' && str[i] <= 'ๆ') || (str[i] === 'ะ') || str[i] >= 'า' && str[i] <= 'ำ') {
            isThai = true;
            break;
         }
      }
      return isThai;
   }

   getLenNumber(number) {
      return number.toString().length;
   }

   closePage() {
      this.router.navigate(['/tasks/all']);
   }

   /** แสดง ซ่อน loading page */
   handleWaitAction(isShow) {
      if (isShow) {
         $('#pano-sign-task').show();
         $('#main-page').addClass('blur');
      } else {
         $('#pano-sign-task').hide();
         $('#main-page').removeClass('blur');
         if (this.page >= 1) {
            this.warpPage(this.page);
         }
      }
   }

   /** ตั้งค่า tutorial ในหน้านี้ */
   onStartTutorial(): void {
      const isHideSigner = this.leftPanelComp.isHideSigner;
      const enjoyhint_instance = new EnjoyHint({});
      let enjoyhint_script_steps = [];
      this.translate.get('tutorial').subscribe((msg) => {
         if (isHideSigner) {
            enjoyhint_script_steps = [
               {
                  'next .mat-tab-label.mat-ripple.ng-star-inserted:eq(0)': msg.signOff.documentBar,
                  'nextButton': {text: msg.next},
                  'skipButton': {text: msg.close},
               },
               {
                  'click .mat-tab-label.mat-ripple.ng-star-inserted:eq(1)': msg.signOff.toolsBar,
                  'nextButton': {text: msg.next},
                  'skipButton': {text: msg.close},
               },
               {
                  'next #tools-menu-hint': msg.signOff.toolsOption,
                  'nextButton': {text: msg.close},
                  'showSkip': false,
                  'left': -20,
                  'right': 40,
               },
            ];
         } else {
            enjoyhint_script_steps = [
               {
                  'next .mat-tab-label.mat-ripple.ng-star-inserted:eq(0)': msg.signOff.documentBar,
                  'nextButton': {text: msg.next},
                  'skipButton': {text: msg.close},
               },
               {
                  'next .mat-tab-label.mat-ripple.ng-star-inserted:eq(1)': msg.signOff.signBar,
                  'nextButton': {text: msg.close},
                  'showSkip': false,
               },
            ];
         }
         setTimeout(() => {
            enjoyhint_instance.set(enjoyhint_script_steps);
            enjoyhint_instance.run();
         }, 500);
      });
   }

   onSelectedChange($event) {
      this.selectedTab = $event;
   }

   getLenDocument() {
      return this.taskAttribute.docList.length;
   }

   getMaxPageDocuments() {
      return this.taskAttribute.docList[this.currentIndex].totalPages;
   }

   ZoomContainerImage(isZoomIn, ratio) {
      for (let i = 0; i < $('#all-image').children().length; i++) {
         const $parent = $($('#all-image').children()[i]);
         const $imageChild = $($parent.children()[0]);
         const $textChild = $($parent.children()[1]);
         const $textWatermark = $($parent.children()[2]);
         const pageNo = parseInt($parent.attr('id').split('_'), 10);
         $($('#all-image').children()[i]).attr('transform', this.ZoomTransform(isZoomIn, $($('#all-image').children()[i]), ratio));
         if (isZoomIn) {
            this.setHeightObject($imageChild, $imageChild.attr('height') * ratio);
            this.setWidthObject($imageChild, $imageChild.attr('width') * ratio);
         } else {
            this.setHeightObject($imageChild, $imageChild.attr('height') / ratio);
            this.setWidthObject($imageChild, $imageChild.attr('width') / ratio);
         }
         this.setXobject($textChild, this.calculateXtext($imageChild.attr('width'), pageNo, this._totalPages));
         this.setYobject($textChild, this.calculateYtext(parseFloat($imageChild.attr('height'))));

         if ($textWatermark) {
            let fontSize = Number($textWatermark.attr('font-size'));
            let transform = $textWatermark.attr('transform');
            if (transform) {
               const strNum = transform?.replace('translate(', '')?.replace(')', '')?.replace(' rotate(-45)', '').split(',');
               let x = Number(strNum[0]);
               let y = Number(strNum[1]);
               if (isZoomIn) {
                  fontSize = fontSize * ratio;
                  x = x * ratio;
                  y = y * ratio;
               } else {
                  fontSize = fontSize / ratio;
                  x = x / ratio;
                  y = y / ratio;
               }
               transform = 'translate(' + x + ',' + y + ') rotate(-45)';
               $textWatermark.attr('font-size', fontSize);
               $textWatermark.attr('transform', transform);
            }
         }
      }
   }

   /**
    * get value from attribute transform from tag image and calculate zoompage
    * by Bestz
    *
    * */
   ZoomTransform(isZoomIn, $object, translateY) {
      const matrix = this.getValueTransform($object.attr('transform'));
      if (translateY !== -1) {
         if (isZoomIn) {
            matrix[4] = matrix[4] * translateY;
            matrix[5] = matrix[5] * translateY;
         } else {
            matrix[4] = matrix[4] / translateY;
            matrix[5] = matrix[5] / translateY;
         }
      }
      return 'matrix(' + matrix.toString() + ')';
   }

   getValueTransform(value) {
      const transform = value.replace(/[^0-9\-.,]/g, '').split(','); // split get only value matrix(0,0,0,0,0,0) => array
      const matrix = [];
      for (let i = 0; i < transform.length; i++) {
         matrix[i] = parseFloat(transform[i]);
      }
      return matrix;
   }

   calculateXtext(width, pageNo, pageTotal) {
      return width - this.calculateLenStr(this.getLenNumber(pageNo), this.getLenNumber(pageTotal));
   }

   calculateYtext(height) {
      return height + 15;
   }

   onPrint($event) {
      this.countpageprint = 0;
      if (document.getElementById('print')) {
         $('#print').empty();
      }
      for (let i = 0; i < this.dataPages[this.currentIndex].totalPages; i++) {
         if (!this._statusInitial[i].isInitial) {
            this.addItemPagePrint(this.dataPages[this.currentIndex], i);
         }
      }

      const divToPrint = document.getElementById('print').innerHTML;
      const newWindow = window.frames['prints'];
      newWindow.document.write(`
          <html>
              <head>
                <title></title>
               <style media="print">
            .portrait{

             @page:  {
             margin: 5mm 5mm 5mm 5mm;;
             size: letter portrait;

            }
            }
            .landscape{

            @page {
                margin: 5mm 5mm 5mm 5mm;
                size: letter landscape;
            }
            }


             /*.marginprint{*/
             /*max-width: 100%;*/
             /*padding-top: 50px;*/
             /*}*/
              /*html{*/
              /*max-height: 400%;*/
              /*background-color: #fff;*/
              /*}     */
                </style>
                <script>

                 function printt(){
                    window.print();
                    window.close();

                 }
               </script>
              </head >
              <body onload="printt()" >
              ${divToPrint}
              </body>
            </html>
          `);
      newWindow.document.close();
   }

   frameLoaded(iframe: any) {
      const that = this;
      const document = iframe.contentWindow.document;
      document.addEventListener('load', function () {
         window.frames.print();
      });

   }

   /**
    *
    *  ฟังคก์ั่นไว้สำหรับปรับ transfrom rotate และเคลียลายเซ็นต์เมื่อมีลายเซ็นในหน้าที่ต้องการหมุนอยู่
    */
   onRotate(direction) {
      const signConflicts = this.getSignConflictRotatePage();
      if (signConflicts.length > 0) {
         const dialogRef = this.dialog.open(ConfirmRemovesignDialogComponent, {
            disableClose: true,
         });
         this.translate.get('newTask.confirm').subscribe(s => {
            dialogRef.componentInstance.messageWarning = s;
         });
         dialogRef.afterClosed().subscribe(result => {
            if (result) {
               this.clearSignConflict(signConflicts);
               this.checkAmount = false;
               const $parent = $($('#all-image').children()[this.page - 1]);
               $($parent.children()[0]).attr('transform', this.RotateTransform($($parent.children()[0]), direction, this.page - 1));
               const obj = this.checkItemRotate(this.itemRotates);
               this.handleWaitAction(true);
               this.service.rotateDocument(obj, true, this.taskAttribute.taskId).subscribe((response) => {
                     this.itemRotates[this.currentIndex].itemRotate[this.page - 1].item.directRotate = '';
                     this.handleWaitAction(false);
                  },
                  (err) => {
                     console.error(err);
                  });
               this.clearFlagRotate(this.itemRotates);
               this.clearSignPage(this.page, direction);
            }
         });
      } else {
         this.checkAmount = false;
         const $parent = $($('#all-image').children()[this.page - 1]);
         $($parent.children()[0]).attr('transform', this.RotateTransform($($parent.children()[0]), direction, this.page - 1));
         const obj = this.checkItemRotate(this.itemRotates);
         this.handleWaitAction(true);

         this.service.rotateDocument(obj, true, this.taskAttribute.taskId).subscribe((response) => {
               this.itemRotates[this.currentIndex].itemRotate[this.page - 1].item.directRotate = '';
               this.handleWaitAction(false);
            },
            (err) => {
               console.error(err);
            });
         this.clearFlagRotate(this.itemRotates);

         this.clearSignPage(this.page, direction);
      }
   }


   /**
    *
    *  ฟังคก์ั่นไว้สำหรับหา widthmax ของกระดาษในแต่ละ listpage
    */
   setWidthMax() {
      this.widthMax = this.itemRotates[this.currentIndex].itemRotate[0].item.width;
      for (let j = 0; j < this.taskAttribute.docList[this.currentIndex].totalPages; j++) {
         if (this.itemRotates[this.currentIndex].itemRotate[j].item.width > this.widthMax) {
            this.widthMax = this.itemRotates[this.currentIndex].itemRotate[j].item.width;
         }
         this.checkPositionPage = true;
         for (let i = 0; i < this._totalPages; i++) {
            if (this.itemRotates[this.currentIndex].itemRotate[0].item.height > this.itemRotates[this.currentIndex].itemRotate[0].item.width) {
               if (this.itemRotates[this.currentIndex].itemRotate[i].item.width > this.itemRotates[this.currentIndex].itemRotate[i].item.height) {
                  this.checkPositionPage = false;
                  break;
               }
            }
            if (this.itemRotates[this.currentIndex].itemRotate[0].item.width > this.itemRotates[this.currentIndex].itemRotate[0].item.height) {
               if (this.itemRotates[this.currentIndex].itemRotate[i].item.height > this.itemRotates[this.currentIndex].itemRotate[i].item.width) {
                  this.checkPositionPage = false;
                  break;
               }
            }
         }
      }
      this.maxWidth = this.widthMax;
      this.setLeftComment();
   }

   /**
    *
    *  ฟังคก์ั่นไว้สำหรับหมุนรูปภาพปรับหน้ากระดาษให้เหมาะสมกับหน้าจอสำหรับหน้าที่ยังไม่ได้ถูกโหลด
    */
   rotateUnInital(index) {
      this.heightMax = 0;
      if (this.checkLasyload[this.currentIndex] > index) {
         this.itemrotatenum2[this.currentIndex].itemRotate[index].item.scale += 90;
      }
      if (this.itemrotatenum2[this.currentIndex].itemRotate[index].item.scale === 0
         || this.itemrotatenum2[this.currentIndex].itemRotate[index].item.scale === -360
         || this.itemrotatenum2[this.currentIndex].itemRotate[index].item.scale === 360) {
         this.itemrotatenum2[this.currentIndex].itemRotate[index].item.scale = 0;
      }
      this.swap = this.itemRotates[this.currentIndex].itemRotate[index].item.width;
      this.itemRotates[this.currentIndex].itemRotate[index].item.width = this.itemRotates[this.currentIndex].itemRotate[index].item.height;
      this.itemRotates[this.currentIndex].itemRotate[index].item.height = this.swap;
      this.itemRotates[this.currentIndex].itemRotate[index].item.posx = 0;
      this.itemRotates[this.currentIndex].itemRotate[index].item.posy = 0;
      this.widthMax = this.itemRotates[this.currentIndex].itemRotate[0].item.width;
      for (let j = 0; j < this.taskAttribute.docList[this.currentIndex].totalPages; j++) {
         if (this.itemRotates[this.currentIndex].itemRotate[j].item.width > this.widthMax) {
            this.widthMax = this.itemRotates[this.currentIndex].itemRotate[j].item.width;
         }
         this.checkPositionPage = true;
         for (let i = 0; i < this._totalPages; i++) {
            if (this.itemRotates[this.currentIndex].itemRotate[0].item.height > this.itemRotates[this.currentIndex].itemRotate[0].item.width) {
               if (this.itemRotates[this.currentIndex].itemRotate[i].item.width > this.itemRotates[this.currentIndex].itemRotate[i].item.height) {
                  this.checkPositionPage = false;
                  break;
               }
            }
            if (this.itemRotates[this.currentIndex].itemRotate[0].item.width > this.itemRotates[this.currentIndex].itemRotate[0].item.height) {
               if (this.itemRotates[this.currentIndex].itemRotate[i].item.height > this.itemRotates[this.currentIndex].itemRotate[i].item.width) {
                  this.checkPositionPage = false;
                  break;
               }
            }
         }
      }
      this.maxWidth = this.widthMax;
      this.setLeftComment();
      for (let j = index + 1; j < this.taskAttribute.docList[this.currentIndex].totalPages; j++) {
         this.itemRotates[this.currentIndex].itemRotate[j].item.transformHeight =
            (this.itemRotates[this.currentIndex].itemRotate[j].item.transformHeight -
               this.itemRotates[this.currentIndex].itemRotate[index].item.width) +
            this.itemRotates[this.currentIndex].itemRotate[index].item.height;
      }
      for (let i = 0; i < $('#all-image').children().length; i++) {
         $($('#all-image').children()[i]).attr('transform', this.SetPosition($($('#all-image').children()[i]),
            this.itemRotates[this.currentIndex].itemRotate[index].item.height,
            this.itemRotates[this.currentIndex].itemRotate[index].item.width, 'vertical', i));
      }
      this.itemrotatenum2[this.currentIndex].itemRotate[index].item.height = this.itemRotates[this.currentIndex].itemRotate[index].item.height;
      this.itemrotatenum2[this.currentIndex].itemRotate[index].item.width = this.itemRotates[this.currentIndex].itemRotate[index].item.width;
      for (let j = 0; j < this.taskAttribute.docList[this.currentIndex].totalPages; j++) {
         if (this.countZoom === 0) {
            this.heightMax += this.itemRotates[this.currentIndex].itemRotate[j].item.height + 30;
         }
         if (this.countZoom === 2) {
            this.heightMax += this.itemRotates[this.currentIndex].itemRotate[j].item.height + 60;
         }
         if (this.countZoom === 4) {
            this.heightMax += this.itemRotates[this.currentIndex].itemRotate[j].item.height + 120;
         }
      }

      this.maxHeight = this.heightMax;
      this.sendWidthHeight.emit(this.itemrotatenum2[this.currentIndex]);
   }

   /**
    *
    *  ฟังคก์ั่นไว้สำหรับหมุนรูปภาพปรับหน้ากระดาษให้เหมาะสมกับหน้าจอ
    */
   RotateTransform($object, direction, index) {
      this.heightMax = 0;
      const $parent1 = $($('#all-image').children()[index]);
      const $imageChild1 = $($parent1.children()[0]);
      const $textChild = $($parent1.children()[1]);
      const $textWatermark = $($parent1.children()[2]);
      const pageNo = parseInt($parent1.attr('id').split('_')[1], 10);
      const Rotate = this.getValueTransform($object.attr('transform'));
      if (direction === 'left') {
         this.itemRotates[this.currentIndex].itemRotate[index].item.scale += -90;
         this.itemRotates[this.currentIndex].itemRotate[index].item.directRotate = 'left';
         if (this.checkLasyload[this.currentIndex] > index) {
            this.itemrotatenum2[this.currentIndex].itemRotate[index].item.scale += -90;
         }
         Rotate[0] += -90;
      } else if (direction === 'right') {
         this.itemRotates[this.currentIndex].itemRotate[index].item.scale += 90;
         this.itemRotates[this.currentIndex].itemRotate[index].item.directRotate = 'right';
         if (this.checkLasyload[this.currentIndex] > index) {
            this.itemrotatenum2[this.currentIndex].itemRotate[index].item.scale += 90;
         }
         Rotate[0] += 90;
      }
      if (this.itemrotatenum2[this.currentIndex].itemRotate[index].item.scale === 0
         || this.itemrotatenum2[this.currentIndex].itemRotate[index].item.scale === -360
         || this.itemrotatenum2[this.currentIndex].itemRotate[index].item.scale === 360) {
         this.itemrotatenum2[this.currentIndex].itemRotate[index].item.scale = 0;
      }
      if (this.page - 1 >= index) {
         this.checkheightpage = this.checkheightpage - this.itemRotates[this.currentIndex].itemRotate[index].item.height;
      }

      const docIndex = this.dataPages.findIndex(x => x.docId === this.getDocId());
      const scaleTmp = this.dataPages[docIndex].pages[pageNo - 1].scale;
      let widthTmp = Math.round(this.itemRotates[this.currentIndex].itemRotate[index].item.width / scaleTmp);
      let heightTmp = Math.round(this.itemRotates[this.currentIndex].itemRotate[index].item.height / scaleTmp);
      const hOld = this.itemRotates[this.currentIndex].itemRotate[index].item.height;

      const ratioZoom = this.countZoom === 0 ? 1 : this.countZoom;
      const fitWidth = 980 * ratioZoom;
      let scaleNew = 1;

      if (heightTmp > fitWidth) {
         scaleNew = fitWidth / heightTmp;
         widthTmp = Math.round(this.itemRotates[this.currentIndex].itemRotate[index].item.width * scaleNew);
         heightTmp = Math.round(this.itemRotates[this.currentIndex].itemRotate[index].item.height * scaleNew);
      }

      this.itemRotates[this.currentIndex].itemRotate[index].item.width = widthTmp;
      this.itemRotates[this.currentIndex].itemRotate[index].item.height = heightTmp;

      this.dataPages[docIndex].pages[pageNo - 1].scale = scaleNew;

      this.swap = this.itemRotates[this.currentIndex].itemRotate[index].item.width;
      this.itemRotates[this.currentIndex].itemRotate[index].item.width = this.itemRotates[this.currentIndex].itemRotate[index].item.height;
      this.itemRotates[this.currentIndex].itemRotate[index].item.height = this.swap;
      if (this.page - 1 >= index) {
         this.checkheightpage = this.checkheightpage + this.itemRotates[this.currentIndex].itemRotate[index].item.height;
      }
      this.setWidthMax();
      for (let j = index + 1; j < this.taskAttribute.docList[this.currentIndex].totalPages; j++) {
         let indexTmp = j;
         if (j > 0) {
            indexTmp = j - 1;
         }
         const h = this.itemRotates[this.currentIndex].itemRotate[indexTmp].item.height;
         this.itemRotates[this.currentIndex].itemRotate[j].item.transformHeight =
            this.itemRotates[this.currentIndex].itemRotate[indexTmp].item.transformHeight + h + 30;
      }

      const hNew = widthTmp;
      if (Rotate[0] === 0 || Rotate[0] === -360 || Rotate[0] === 360) {

         $imageChild1.attr('width', heightTmp);
         $imageChild1.attr('height', widthTmp);

         this.itemRotates[this.currentIndex].itemRotate[index].item.posx = 0;
         this.itemRotates[this.currentIndex].itemRotate[index].item.posy = 0;
         Rotate[0] = 0;
         Rotate[1] = 0;
         Rotate[2] = 0;
      }
      if (Rotate[0] === -90 || Rotate[0] === 270) {

         $imageChild1.attr('width', widthTmp);
         $imageChild1.attr('height', heightTmp);

         this.itemRotates[this.currentIndex].itemRotate[index].item.posx = Number($imageChild1.attr('width')) / 2;
         this.itemRotates[this.currentIndex].itemRotate[index].item.posy = Number($imageChild1.attr('width')) / 2;
         Rotate[1] = Number($imageChild1.attr('width')) / 2;
         Rotate[2] = Number($imageChild1.attr('width')) / 2;
      } else if (Rotate[0] === -180 || Rotate[0] === 180) {

         $imageChild1.attr('width', heightTmp);
         $imageChild1.attr('height', widthTmp);

         this.itemRotates[this.currentIndex].itemRotate[index].item.posx = Number($imageChild1.attr('width')) / 2;
         this.itemRotates[this.currentIndex].itemRotate[index].item.posy = Number($imageChild1.attr('height')) / 2;
         Rotate[1] = Number($imageChild1.attr('width')) / 2;
         Rotate[2] = Number($imageChild1.attr('height')) / 2;
      } else if (Rotate[0] === -270 || Rotate[0] === 90) {

         $imageChild1.attr('width', widthTmp);
         $imageChild1.attr('height', heightTmp);

         this.itemRotates[this.currentIndex].itemRotate[index].item.posx = Number($imageChild1.attr('height')) / 2;
         this.itemRotates[this.currentIndex].itemRotate[index].item.posy = Number($imageChild1.attr('height')) / 2;
         Rotate[1] = Number($imageChild1.attr('height')) / 2;
         Rotate[2] = Number($imageChild1.attr('height')) / 2;
      }
      if ($textWatermark) {
         const transform = 'translate(' + (heightTmp / 2) + ',' + (widthTmp / 2) + ') rotate(-45)';
         $textWatermark.attr('transform', transform);
      }

      for (let i = 0; i < $('#all-image').children().length; i++) {
         $($('#all-image').children()[i]).attr('transform', this.SetPosition($($('#all-image').children()[i]),
            $imageChild1.attr('width'), $imageChild1.attr('height'), 'vertical', i));
      }
      for (let i = index + 1; i < $('#all-image').children().length; i++) {
         $($('#all-image').children()[i]).attr('transform', this.SetTransHeight($($('#all-image').children()[i]),
            hOld, hNew, 'vertical', index));

      }

      this.itemrotatenum2[this.currentIndex].itemRotate[index].item.height = this.itemRotates[this.currentIndex].itemRotate[index].item.height;
      this.itemrotatenum2[this.currentIndex].itemRotate[index].item.width = this.itemRotates[this.currentIndex].itemRotate[index].item.width;
      this.itemrotatenum2[this.currentIndex].itemRotate[index].item.posx = Rotate[1];
      this.itemrotatenum2[this.currentIndex].itemRotate[index].item.posy = Rotate[2];
      for (let j = 0; j < this.taskAttribute.docList[this.currentIndex].totalPages; j++) {
         if (this.countZoom === 0) {
            this.heightMax += this.itemRotates[this.currentIndex].itemRotate[j].item.height + 30;
         }
         if (this.countZoom === 2) {
            this.heightMax += this.itemRotates[this.currentIndex].itemRotate[j].item.height + 60;
         }
         if (this.countZoom === 4) {
            this.heightMax += this.itemRotates[this.currentIndex].itemRotate[j].item.height + 120;
         }
      }
      this.maxHeight = this.heightMax;
      this.setXobject($textChild, this.calculateXtext(this.itemRotates[this.currentIndex]
         .itemRotate[index].item.width + 10, pageNo, this._totalPages));
      this.setYobject($textChild, this.calculateYtext(parseFloat(this.itemRotates[this.currentIndex].itemRotate[index].item.height)));
      this.sendWidthHeight.emit(this.itemrotatenum2[this.currentIndex]);
      return 'rotate(' + Rotate.toString() + ')';
   }

   /**
    *
    *  ฟังคก์ั่นไว้สำหรับเซ็ตตำแหน่งเริ่มต้นแกน x ของแต่ละหน้า
    */
   SetPosition($object, height, width, img, i) {
      const matrix = this.getValueTransform($object.attr('transform'));
      if (this.checkPositionPage) {
         matrix[4] = 0;
      }

      if (!this.checkPositionPage) {
         if (this.itemRotates[this.currentIndex].itemRotate[i].item.width >=
            this.itemRotates[this.currentIndex].itemRotate[i].item.height &&
            this.itemRotates[this.currentIndex].itemRotate[i].item.width === this.maxWidth) {
            matrix[4] = 0;
         } else {
            matrix[4] = (this.maxWidth - this.itemRotates[this.currentIndex].itemRotate[i].item.width) / 2;
         }
      }
      return 'matrix(' + matrix.toString() + ')';
   }

   /**
    *
    *  ฟังคก์ั่นไว้สำหรับเซ็ตตำแหน่งเริ่มต้นแกน y ของแต่ละหน้า
    */
   SetTransHeight($object, oldHeight, newHeight, img, i) {
      const matrix = this.getValueTransform($object.attr('transform'));
      if (img === 'horizon') {
         matrix[5] = (matrix[5] - this.itemRotates[this.currentIndex].itemRotate[i].item.width) +
            this.itemRotates[this.currentIndex].itemRotate[i].item.height;
      } else {
         matrix[5] = (matrix[5] - oldHeight) + newHeight;
      }
      return 'matrix(' + matrix.toString() + ')';
   }

   /**
    *
    *  ฟังคก์ั่นไว้สำหรับเรียก transform rotate เมื่อกดคลิ๊ก rotate by thumbnail
    */
   onRotateByPage(index, direction) {
      this.handleWaitAction(true);
      this.checkAmount = false;
      const rotatePage = [];
      if (this._statusInitial[index].isInitial === false) {
         this.rotateUnInital(index);
      } else {
         const $parent = $($('#all-image').children()[index]);
         $($parent.children()[0]).attr('transform', this.RotateTransform($($parent.children()[0]), direction, index));
      }
      rotatePage.push(index);
      this.service.rotateThumbnailDocument(this.getDocId(), 'R', rotatePage, this.taskAttribute.taskId)
         .subscribe((response) => {
               this.itemRotates[this.currentIndex].itemRotate[index].item.directRotate = '';
               this.handleWaitAction(false);
            },
            (err) => {
               console.error(err);
            });
   }

   /**
    *
    *  ฟังคก์ั่นไว้สำหรับเรียก transform rotate เมื่อกดคลิ๊ก rotate all
    */
   onRotateMulti(selectedItems, direction, amount) { // recursive
      this.handleWaitAction(true);
      this.selectedItems = selectedItems;
      this.amount = amount;
      this.checkAmount = true;
      if (this.multiRotate < amount) {
         this.numberlooprotate = selectedItems[this.multiRotate];
         this.multiRotate++;
         if (this.multiRotate === amount) {
            this.multiRotate = 0;
            this.checkAmount = false;
         }
         if (this._statusInitial[Number(this.numberlooprotate)].isInitial === false) {
            this.rotateUnInital(Number(this.numberlooprotate));
         } else {
            const $parent = $($('#all-image').children()[Number(this.numberlooprotate)]);
            $($parent.children()[0]).attr('transform', this.RotateTransform($($parent.children()[0]),
               direction, Number(this.numberlooprotate)));
         }
      }
      if (this.checkAmount === true) {
         this.onRotateMulti(this.selectedItems, 'right', this.amount);
      }
   }

   /**
    *
    *  ฟังคก์ั่นไว้สำหรับเช็คว่า scroll กำลังเลื่อนขึ้นหรือเลื่อนลงอยู่
    */
   getScrollDirection($event) {
      const scrollTop = $($event.target)[0].scrollTop;
      if (this.giveScroll < scrollTop) {
         this.giveScroll = scrollTop;
         return 'down';
      } else {
         this.giveScroll = scrollTop;
         return 'up';
      }
   }

   /**
    *
    *
    * @details :
    */
   warpPage(pageNo) {
      this.deselectAll();
      const imgCurrentId = 'img_' + pageNo;
      let heightTotal, scrollTop;
      while (this._pageCount < pageNo) {
         if (!this._statusInitial[this._pageCount].isInitial) {
            this.addItemPage(this.dataPages[this.currentIndex], this._pageCount,
               this.itemRotates[this.currentIndex].itemRotate[this._pageCount].item.transformHeight, this.maxWidth);
            this._statusInitial[this._pageCount].isInitial = true;
         }
         this._pageCount++;
      }
      heightTotal = this.getTotalPageHeight(imgCurrentId);
      scrollTop = heightTotal;
      if ((pageNo - this.pageNo1) > 7 || (pageNo - this.pageNo1) < -7) {
         $('#sideNavContent').animate({scrollTop: scrollTop}, 800);
         this.pageNo1 = pageNo;
      } else {
         $('#sideNavContent').animate({scrollTop: scrollTop});
         this.pageNo1 = pageNo;
      }
   }

   getCountZoom() {
      return this.countZoom === 0 ? 1 : this.countZoom;
   }

   onEnableDownloadAll() {
      this.ondownloadAll.emit();
   }

   onDownload(docId) {
      window.open(this.service.url + '/downloadAdmin?id=' + docId + '&token=' + this.service.user.token, '_blank');
   }

   /**
    * เช็คว่าไอเทมที่จะทำการ rotate มีข้อมูลหรือป่าวถ้ามีข้อมูลที่ page ไหนก็ push รวมเป็น object
    *
    * */
   checkItemRotate(itemRotates: any) {
      const itemRotateFilter = [];
      let objectRotate;
      for (const objItem of itemRotates[this.currentIndex].itemRotate) {
         if (objItem.item.directRotate !== '') {
            itemRotateFilter.push(objItem);
         }
      }
      if (itemRotateFilter.length > 0) {
         objectRotate = {
            itemRotate: itemRotateFilter,
            docId: this.getDocId()
         };
      }
      return objectRotate;
   }

   clearFlagRotate(itemRotates: any) {
      for (const objItem of itemRotates[this.currentIndex].itemRotate) {
         objItem.item.directRotate = '';
      }
   }

   getSelectDataPage() {
      return this.dataPages[this.currentIndex];
   }

   getSelectTaskDocument() {
      return this.taskAttribute.docList[this.currentIndex];
   }

   getItemRotates() {
      return this.itemRotates[this.currentIndex];
   }

   getItemRotatesNum2() {
      return this.itemrotatenum2[this.currentIndex];
   }

   generateTextControl(objText: any, defaultText: any) {
      const that = this;
      objText.node.addEventListener('dblclick', function (e) {
         let parentId = e.target.parentNode.id;
         let svgId = e.target.parentNode.parentNode.id;
         let eleText;
         if (e.target.parentNode.nodeName === 'text') {
            parentId = e.target.parentNode.parentNode.id;
            svgId = e.target.parentNode.parentNode.parentNode.id;
            eleText = document.getElementById(e.target.parentNode.id);
         } else {
            const childrenSvg = e.target.parentNode.childNodes;
            for (let i = 0; i < childrenSvg.length; i++) {
               if (childrenSvg[i].nodeName === 'text') {
                  eleText = document.getElementById(childrenSvg[i].id);
                  break;
               }
            }
         }

         const ele = document.getElementById(parentId);
         let parentWidth = ele.getBoundingClientRect().width;
         const parentHeight = ele.getBoundingClientRect().height;
         const transformValue = ele.getAttribute('transform');
         const eleValue = ele.textContent;
         const calWidth = calculateLenStrSign(eleValue);
         if (calWidth > parentWidth) {
            parentWidth = calWidth;
         }
         const children = ele.parentNode.parentNode.childNodes;
         let pageWidth, maxWidth;
         const coX = transformValue.split(',')[4];
         for (let i = 0; i < children.length; i++) {
            if (children[i].nodeName === 'image') {
               pageWidth = (<HTMLImageElement>children[i]).getBoundingClientRect().width;
               break;
            }
         }
         maxWidth = pageWidth - parseInt(coX, 10);
         const fo = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
         fo.setAttribute('id', 'svg-' + parentId);
         fo.setAttribute('width', String(parentWidth));
         fo.setAttribute('height', String(parentHeight));
         fo.style.maxWidth = maxWidth + 'px';
         fo.setAttribute('transform', transformValue);

         const fontSize = document.querySelector('svg [id="' + parentId + '"]').closest('g').querySelector('text').getAttribute('font-size');
         const ratioZoom = parseInt(fontSize, 10) / Number(fontSize);
         const ta = document.createElementNS('http://www.w3.org/1999/xhtml', 'input');
         ta.setAttribute('id', 'txt-' + parentId);
         ta.setAttribute('type', 'text');
         ta.setAttribute('maxlength', String(150));
         ta.setAttribute('placeholder', defaultText);
         ta.style.fontSize = fontSize + 'px';
         ta.style.resize = 'none';
         ta.style.width = parentWidth + 'px';
         ta.style.maxWidth = maxWidth + 'px';
         ta.style.height = parentHeight + 'px';
         ta.style.background = 'white';
         if (!(eleValue === 'Input Text' || eleValue === 'กรอกข้อความ' || eleValue === '')) {
            ta.setAttribute('value', eleValue);
         }

         function  calculateLenStrSign(str) {
            const widthChar = 6;
            let len = 0;
            for (const element of str) {
               if ((element === 'ำ' || element === 'ณ' || element === 'ฏ' || element === 'ฐ')) {
                  len += 6.3;
               } else if ((element >= 'a' && element <= 'z') || (element >= 'A' && element <= 'Z') || (element >= '0' && element <= '9')
                  || (element === '/') || (element >= 'ก' && element <= 'ฮ') || (element >= 'เ' && element <= 'ๆ') || (element === 'ะ')
                  || (element === ' ') || element >= 'า' && element <= 'ำ') {
                  len += widthChar;
               }
            }
            return len;
         }

         ta.addEventListener('input', function () {
            const w = calculateLenStrSign((<HTMLInputElement>this).value) * ratioZoom;
            if (w > parentWidth && w <= maxWidth) {
               this.style.width = w + 'px';
               fo.style.width = this.style.width;
            }
         });

         ta.addEventListener('keyup', function (evt) {
            const inputEle = <HTMLInputElement>this;
            if (evt.ctrlKey) {
               if (evt.key === 'a' || evt.key === 'A') {
                  inputEle.setSelectionRange(0, inputEle.value.length);
               }
            }
         });

         ta.addEventListener('keydown', function (evt) {
            const inputEle = <HTMLInputElement>this;
            const w = calculateLenStrSign(inputEle.value) * ratioZoom;
            if (evt.metaKey && (evt.key === 'a' || evt.key === 'A')) {
               inputEle.setSelectionRange(0, inputEle.value.length);
            } else if (['Enter', 'Escape'].includes(evt.key)) {
               this.blur();
               return false;
            } else if (w > maxWidth
               && !(evt.key === 'Backspace' || evt.key === 'Delete'
                  || evt.key === 'ArrowRight' || evt.key === 'ArrowLeft')) {
               // to cancel the event:
               if (evt.preventDefault) {
                  evt.preventDefault();
               }
               return false;
            }
         });

         $(ta).on('focusout', () => {
            const txtCtrl = document.getElementById('txt-' + parentId);
            let txtValue = (<HTMLInputElement>txtCtrl).value;

            if (txtValue === '') {
               txtValue = defaultText;
            }
            document.querySelector('svg [id="' + parentId + '"]').closest('g').
            querySelector('tspan').textContent = txtValue;

            document.getElementById(svgId).removeChild(fo);

            let len = eleText.getBoundingClientRect().width;
            if (len < parentWidth * ratioZoom) {// set width same old
               len = parentWidth * ratioZoom;
            }

            document.querySelector('svg [id="' + parentId + '"]').closest('g').
            querySelector('rect').setAttribute('width', String(len));
         });

         $(ta).on('click', () => {
            that.setVisibleProperty(true);
         });

         $(ta).on('select', () => {
            that.setVisibleProperty(true);
         });

         fo.appendChild(ta);
         document.getElementById(svgId).appendChild(fo);
         ta.focus();
         const controlTextbox = <HTMLInputElement>ta;
         const textValueLen = controlTextbox.value.length;
         controlTextbox.setSelectionRange(textValueLen, textValueLen);
         e.preventDefault();
      });
   }

   /** ตั้งค่าตำแหน่ง comment list */
   setLeftComment(widthPages?: any) {
      try {
         setTimeout(() => {
            let left = 0, screenWidth = 0, marginPage = 0;
            screenWidth = window.innerWidth;
            let widthPage = Number($('#svg-page').attr('width'));
            if (widthPage === 0) {
               widthPage = widthPages;
            }
            if (screenWidth > widthPage) {
               marginPage = screenWidth;
               if (this.isToggleLeftOpened) {
                  marginPage -= 250;
               }
               if (this.isToggleRightOpened) {
                  marginPage -= 320;
               }
               if (marginPage > widthPage) {
                  marginPage -= widthPage;
                  marginPage = marginPage / 2;
                  left = marginPage + widthPage + 20;
               } else {
                  left = widthPage + 20;
               }
            } else {
               left = widthPage + 20;
            }
            (document.querySelector('#comment-box') as HTMLElement).style.left = `${left}px`;
         }, 0);
      } catch (e) {
         console.error(e);
      }
   }

   checkView($event, onBack?: boolean, callback?: () => void) {
      
      if (!onBack) {
         document.getElementById('main-page').style.display = 'none';
      }
      this.flagSwitchView = true;
      this.deleteAllAddedSignatures();
      if (this._objectDrag) {
         this.onDeleteObjDrag(true);
      }
      if (this.doc === undefined) {
         this.service.getDocumentAdmin($event, 0, 'task')
            .subscribe((data) => {
                  this.initDocument(data, onBack);
                  this.comment = data.comments;
                  callback?.();
               },
               err => {
                  this.handleWaitAction(false);
                  console.error(err);
               });
      }
      if (this.doc != null) {
         this.initDocument(this.doc, onBack);
         callback?.();
      }
      document.getElementById('pdftronView').style.display = 'flex';
   }
   setWidthPage () {
      const widthPage = Number($('#svg-page').attr('width'));
      if (widthPage !== 0) {
         this.setLeftComment(widthPage);
      }
   }
   switchViewer($event) {
      this.setWidthPage();
      // กรณีที่กด save
      this.flagSwitchView = false;
      this.changeDrawPage(0);
      if ($event != 'notSave') {
         this.objTempId[$event.split(',')[1]] = $event.split(',')[0];
         this.taskAttribute.tempId = $event.split(',')[0];

      }
      document.getElementById('main-page').style.display = 'flex';
      document.getElementById('pdftronView').style.display = 'none';
   }

   initDocument(data: any, onBack?: boolean): void {

      if (!onBack) {
         if (document.getElementById('pdftronView')) {
            document.getElementById('pdftronView').style.display = 'flex';
            document.getElementById('pdftronView').style.width = '100%';
         }
      }
      
      this.checkMimeType = data.mimeType;
      const token = this.service.user.token;
      let mimeType = data.mimeType;
      if (this.namelist.endsWith('.csv')) {
         mimeType = 'text/csv';
      }
      let contentUrl = '/content';

      const watermark = this.watermark;
      const url = contentUrl + '?id=' + data.id + '&token=' + token;
      const checkType = Mimetype.checkMimeType(mimeType);
      if (checkType === 'doc') {
         const file = encodeURIComponent(this.service.url + url + '&' + Date.now());
         this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl('assets/pdfjs/web/viewer.html?file=' + file);
         this.docUrl = this.service.url + url + '&isPdfTron=true&' + '&' + Date.now();
         this.documentData = {
            url: this.docUrl,
            fileName: data.name,
            fileFormat: "pdf", // Office files stored in zDOX are converted to PDF, but the file name/extension may not change to .pdf
            type: "",
            mimeType: mimeType,
            docId: data.id,
            path: data.path,
            statusStartFlow: false,
            isPermissions: data.permissions,
            watermark: watermark,
            actionType: "switch",
            statusDocument: data.statusDocument,
            owner: data.creator.id,
         };
      } else if (checkType === 'img') {
         const file = encodeURIComponent(this.service.url + url + '&' + Date.now());
         this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl('assets/pdfjs/web/viewer.html?file=' + file);
         this.docUrl = this.service.url + url + '&' + Date.now();
         this.documentData = {
            url: this.docUrl,
            fileName: data.name,
            type: "",
            mimeType: mimeType,
            docId: data.id,
            path: data.path,
            statusStartFlow: false,
            isPermissions: data.permissions,
            watermark: watermark,
            actionType: "switch",
            statusDocument: data.statusDocument,
            owner: data.creator.id,
         };
      }  else if (checkType === 'text') {
         this.service.get(url, {responseType: 'text'}).subscribe(() => {});
      }
      if (!onBack) {
         this.annoComp.changeDoc(this.documentData);
      } else {
         this.annoComp.saveChanges();
      }
   }

   deleteAllAddedSignatures() {
      // Delete all added signatures represented by ids starting with "SvgjsImage"
      this.deleteSignaturesStartingWithSvgJsImage();

      // Check and delete any remaining updated signatures
      this.deleteUpdatedSignatures();

      // Clear the list of deleted images
      this.clearDeletedImages();

      // Submit file deletion request
      this.submitDeleteFile();

      // Refresh the page
      this.refreshPage();
   }

   deleteSignaturesStartingWithSvgJsImage() {
      const imageIdsToDelete = this.idImgUpdateValue.filter(item => item.startsWith("SvgjsImage"));
      imageIdsToDelete.forEach(id => {
         this.deleteItemSign(this.currentIndex, id);
      });
   }

   deleteUpdatedSignatures() {
      this._addAllSignature.forEach(signature => {
         const $getDataObject = $(signature.node);
         const id = $getDataObject.attr('id');
         if (id) {
            this.finishSVG('');
            this.commentboxComp.remove(id);
            this.deleteItemSign(this.currentIndex, id);
            $getDataObject.remove();
         }
      });
   }

   clearDeletedImages() {
      this.taskAttribute.docList[this.currentIndex].signItems.forEach(element => {
         if (element.idImageItem) {
            this.imgDeleted.push(element.idImageItem);
         }
      });
   }

   selectSignature(event) {
      this.fieldName = event.fieldName;
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (event.fieldName && event.type !== 'init') {
         this.leftPanelComp.onSelectedChange(1);
         if (emailPattern.test(this.dynamicFormComp?.form.controls[this.fieldName].value)) {
            this.leftPanelComp.toolsComp.onHideAndShowSigner(true);
         } else {
            if (this.dynamicFormComp?.form.controls[this.fieldName].value === '') {
               this.leftPanelComp.toolsComp.onHideAndShowSigner(true);
            } else if (this.dynamicFormComp?.form.controls[this.fieldName].value !== null) {
               this.leftPanelComp.toolsComp.onHideAndShowSigner(false);
            }
         }
      }
      if (event.taskContactId) {
         if (this.leftPanelComp.toolsComp &&  this.leftPanelComp.toolsComp.signers) {
            let index = this.leftPanelComp.toolsComp.signers.findIndex((data) => parseInt(data.taskContactId, 10) === parseInt(event.taskContactId, 10));
            if (index < 0) {
               index = 0;
            }
            this.leftPanelComp.toolsComp.selected = index;
         }
      }
   }

   setSignerField(event) {
      let arrData = []
      if (this.fieldName) {
         if (!arrData.length) {
            arrData.push(event);
            this.onselectFormSigner.emit(arrData);
            const element = document.getElementById('holder' + event.fieldName);
            element.style.backgroundColor = event.data.color !== "null" ? event.data.color : '#fefefe';
            element.style.opacity = event.data.color !== "null" ? '0.5' : '1';
            this.dynamicFormComp?.form.controls[this.fieldName].setValue(event.data.signer.signerEmail);
         } else {
            let index = arrData.findIndex(x => x.fieldName === this.fieldName);
            if (index !== -1) {
               arrData[index] = event;
               this.onselectFormSigner.emit(arrData);
            } else {
               arrData.push(event);
               this.onselectFormSigner.emit(arrData);
            }
         }
      }
   }

   validateForm(signList: any, clear?: any) {
      this.dynamicFormComp?.findValidControls(signList, clear);
   }

   checkFormValid(signerData?: any[]) {
      this.isFormName = true;
      this.changeDetector.detectChanges();
      const flag = this.dynamicFormComp?.findValidControls();
      return flag;
   }

   /**
    * เช็คว่าในบรรดา required field ทั้งหมดที่ยังไม่ได้กรอกค่า มีแค่เฉพาะ field 'signature' หรือไม่
    * - `True` = มี field ที่ยังไม่ได้กรอกค่า และ ทุก field ที่ยังไม่ได้กรอกค่าเป็น field 'signature' เท่านั้น
    * - `False` = ไม่มี field ที่ยังไม่ได้กรอกค่า หรือ มี field ที่ยังไม่ได้กรอกค่าแต่มี field ที่ไม่ใช่ field 'signature'
    *
    * (ทำไว้ช่วยเช็คเพื่อแสดง error message ตามเงื่อนไขใน ZE-4836)
    */
   checkIfInvalidRequiredFieldsOnlySignatures() {
      return this.dynamicFormComp?.checkIfInvalidRequiredFieldsOnlySignatures();
   }

   showSignTool(flag) {
      this.isShowSignTool = flag;
   }

   onBackStep(flag) {
      this.isToggle = flag;
   }

   setFieldName() {
      if (this.firstSignField) {
         this.fieldName = this.firstSignField;
      }
   }

   changePageOnCheck() {
      if (this.currentIndex !== 0) {
         this.leftPanelComp.onSelectedChange(0);
         this.leftPanelComp.onListClick({index: 0});
         this.currentIndex = 0;
      }
   }

   async isValueFormatError() {
      if (!this.dynamicFormComp) {
         return this.isFormatError;
      } else {
         this.isFormatError = await this.dynamicFormComp.isValueFormatError();
      }
      return this.isFormatError;
   }
}
